window.threadLibrary = {
  "1000": {
    "hex": "#302E32",
    "name": "Emerald Black ",
    "code": "1000"
  },
  "1001": {
    "hex": "#E8E7E7",
    "name": "Super White",
    "code": "1001"
  },
  "1002": {
    "hex": "#EAE8E7",
    "name": "Snow White",
    "code": "1002"
  },
  "1003": {
    "hex": "#EEEDEC",
    "name": "Creme White",
    "code": "1003"
  },
  "1004": {
    "hex": "#E2DEDC",
    "name": "Natural White ",
    "code": "1004"
  },
  "1005": {
    "hex": "#F5F3F6",
    "name": "Fluorescent White",
    "code": "1005"
  },
  "1006": {
    "hex": "#312E33",
    "name": "Diamond Black",
    "code": "1006"
  },
  "1007": {
    "hex": "#312F33",
    "name": "Amber Black",
    "code": "1007"
  },
  "1008": {
    "hex": "#2E2D32",
    "name": "Ruby Black",
    "code": "1008"
  },
  "1009": {
    "hex": "#323036",
    "name": "Sapphire Black",
    "code": "1009"
  },
  "1010": {
    "hex": "#C8C6C6",
    "name": "Gray Haze",
    "code": "1010"
  },
  "1011": {
    "hex": "#B7B6C1",
    "name": "Chrome Gray",
    "code": "1011"
  },
  "1012": {
    "hex": "#AAABB4",
    "name": "Smoke Gray",
    "code": "1012"
  },
  "1013": {
    "hex": "#E7CCC5",
    "name": "Peach Blush ",
    "code": "1013"
  },
  "1014": {
    "hex": "#E5AEB1",
    "name": "Bermuda Sand Pink ",
    "code": "1014"
  },
  "1015": {
    "hex": "#E9C0C1",
    "name": "Desert Bloom Pink",
    "code": "1015"
  },
  "1017": {
    "hex": "#E9BCA8",
    "name": "Orange Wisp ",
    "code": "1017"
  },
  "1018": {
    "hex": "#E8BBAC",
    "name": "Light Salmon",
    "code": "1018"
  },
  "1020": {
    "hex": "#F29774",
    "name": "Bright Peach",
    "code": "1020"
  },
  "1021": {
    "hex": "#C2532D",
    "name": "Rust Orange ",
    "code": "1021"
  },
  "1022": {
    "hex": "#E6DDB6",
    "name": "Cornsilk Yellow ",
    "code": "1022"
  },
  "1023": {
    "hex": "#EDDA55",
    "name": "Lemon Yellow ",
    "code": "1023"
  },
  "1024": {
    "hex": "#FBCD4A",
    "name": "Gold Rush",
    "code": "1024"
  },
  "1025": {
    "hex": "#C78A38",
    "name": "Military Gold",
    "code": "1025"
  },
  "1026": {
    "hex": "#EBC28E",
    "name": "Orange Sorbet ",
    "code": "1026"
  },
  "1027": {
    "hex": "#9EB7CC",
    "name": "Dolphin Blue ",
    "code": "1027"
  },
  "1028": {
    "hex": "#708EB3",
    "name": "Country Kitchen Blue",
    "code": "1028"
  },
  "1029": {
    "hex": "#4B7EB8",
    "name": "Blue Jay Blue ",
    "code": "1029"
  },
  "1030": {
    "hex": "#A3ACC7",
    "name": "Light Periwinkle",
    "code": "1030"
  },
  "1031": {
    "hex": "#D1AAC8",
    "name": "Frosted Lavender",
    "code": "1031"
  },
  "1032": {
    "hex": "#8D6CA3",
    "name": "Velvet Violet Purple",
    "code": "1032"
  },
  "1033": {
    "hex": "#714785",
    "name": "Purple Pansy",
    "code": "1033"
  },
  "1034": {
    "hex": "#934A56",
    "name": "Vintage Rose",
    "code": "1034"
  },
  "1035": {
    "hex": "#7D3C52",
    "name": "Burgundy",
    "code": "1035"
  },
  "1036": {
    "hex": "#5E3338",
    "name": "Raisin Brown Red ",
    "code": "1036"
  },
  "1037": {
    "hex": "#D72929",
    "name": "Tango Red",
    "code": "1037"
  },
  "1038": {
    "hex": "#812A32",
    "name": "Barn Red",
    "code": "1038"
  },
  "1039": {
    "hex": "#9B2A31",
    "name": "Brick Red ",
    "code": "1039"
  },
  "1040": {
    "hex": "#877881",
    "name": "Weimaraner Gray",
    "code": "1040"
  },
  "1041": {
    "hex": "#797987",
    "name": "Polished Pewter Gray ",
    "code": "1041"
  },
  "1042": {
    "hex": "#324D7B",
    "name": "Lapis Blue ",
    "code": "1042"
  },
  "1043": {
    "hex": "#323244",
    "name": "Navy Blue",
    "code": "1043"
  },
  "1044": {
    "hex": "#353343",
    "name": "Indigo Blue",
    "code": "1044"
  },
  "1045": {
    "hex": "#8EC6C6",
    "name": "Light Mint",
    "code": "1045"
  },
  "1046": {
    "hex": "#4CA99F",
    "name": "Eucalyptus",
    "code": "1046"
  },
  "1047": {
    "hex": "#A8BDA4",
    "name": "Celadon Green ",
    "code": "1047"
  },
  "1048": {
    "hex": "#71934C",
    "name": "Aloe Green",
    "code": "1048"
  },
  "1049": {
    "hex": "#7BAC4B",
    "name": "Lime Green",
    "code": "1049"
  },
  "1050": {
    "hex": "#389C4F",
    "name": "Green Thumb ",
    "code": "1050"
  },
  "1051": {
    "hex": "#2D8751",
    "name": "Bell Pepper",
    "code": "1051"
  },
  "1052": {
    "hex": "#48707C",
    "name": "Mermaid Blue Green",
    "code": "1052"
  },
  "1053": {
    "hex": "#DDB69F",
    "name": " Light Coral ",
    "code": "1053"
  },
  "1054": {
    "hex": "#B2887C",
    "name": "Tawny Brown Beige",
    "code": "1054"
  },
  "1055": {
    "hex": "#D2B590",
    "name": "Beige",
    "code": "1055"
  },
  "1056": {
    "hex": "#996C47",
    "name": "Golden Oak Brown ",
    "code": "1056"
  },
  "1057": {
    "hex": "#B5835C",
    "name": "Caramel ",
    "code": "1057"
  },
  "1058": {
    "hex": "#74493E",
    "name": "Sienna Brown",
    "code": "1058"
  },
  "1059": {
    "hex": "#473A3C",
    "name": "Dark Chocolate Brown ",
    "code": "1059"
  },
  "1060": {
    "hex": "#C6BBB1",
    "name": "Pussywillow Beige Gray ",
    "code": "1060"
  },
  "1061": {
    "hex": "#EED399",
    "name": "Vanilla Pudding Yellow ",
    "code": "1061"
  },
  "1062": {
    "hex": "#8E8279",
    "name": "Rhino Brown Gray ",
    "code": "1062"
  },
  "1063": {
    "hex": "#80746D",
    "name": "Elephant Brown Gray",
    "code": "1063"
  },
  "1064": {
    "hex": "#F1D14B",
    "name": "Goldenrod",
    "code": "1064"
  },
  "1065": {
    "hex": "#D97C35",
    "name": "Copper",
    "code": "1065"
  },
  "1066": {
    "hex": "#E8D08A",
    "name": "Cornmeal",
    "code": "1066"
  },
  "1067": {
    "hex": "#FBEBAB",
    "name": "Lemon Chiffon",
    "code": "1067"
  },
  "1068": {
    "hex": "#F9D54B",
    "name": "Canary Yellow",
    "code": "1068"
  },
  "1069": {
    "hex": "#EDBF44",
    "name": "Sunshine Yellow",
    "code": "1069"
  },
  "1070": {
    "hex": "#D1B169",
    "name": "Tawny Tan",
    "code": "1070"
  },
  "1071": {
    "hex": "#E1DDD7",
    "name": "Baby'w Breath White",
    "code": "1071"
  },
  "1072": {
    "hex": "#D7CEC0",
    "name": "Coconut Cream ",
    "code": "1072"
  },
  "1074": {
    "hex": "#A9B9D9",
    "name": "Powder Blue",
    "code": "1074"
  },
  "1075": {
    "hex": "#95A9D1",
    "name": " Baby Blue",
    "code": "1075"
  },
  "1076": {
    "hex": "#2C54AA",
    "name": "True Blue",
    "code": "1076"
  },
  "1077": {
    "hex": "#E46059",
    "name": "Dark Cora",
    "code": "1077"
  },
  "1078": {
    "hex": "#E4582C",
    "name": "Pumpkin Orange",
    "code": "1078"
  },
  "1079": {
    "hex": "#2C8156",
    "name": "Celtic Green",
    "code": "1079"
  },
  "1080": {
    "hex": "#B586B7",
    "name": "Lilac Purple",
    "code": "1080"
  },
  "1081": {
    "hex": "#962939",
    "name": "Azalea Red Pink",
    "code": "1081"
  },
  "1082": {
    "hex": "#CFBEB0",
    "name": "Antique Ecru Beige",
    "code": "1082"
  },
  "1083": {
    "hex": "#EDCC4B",
    "name": "Daisy Yellow",
    "code": "1083"
  },
  "1084": {
    "hex": "#CDBA9E",
    "name": "Sandy Shores",
    "code": "1084"
  },
  "1085": {
    "hex": "#BBB4B0",
    "name": "Cement Gray",
    "code": "1085"
  },
  "1086": {
    "hex": "#CECCCC",
    "name": "Sterling Silver",
    "code": "1086"
  },
  "1087": {
    "hex": "#C0BAB9",
    "name": " Silver Birch",
    "code": "1087"
  },
  "1088": {
    "hex": "#72ADBA",
    "name": "Robin's Egg Blue Green",
    "code": "1088"
  },
  "1089": {
    "hex": "#72AAC1",
    "name": "Sea Frost Blue Green",
    "code": "1089"
  },
  "1090": {
    "hex": "#367588",
    "name": "Deep Sky Blue",
    "code": "1090"
  },
  "1091": {
    "hex": "#2D718F",
    "name": "Teal Blue",
    "code": "1091"
  },
  "1092": {
    "hex": "#A7BFD1",
    "name": "Summer Sky Blue Gray",
    "code": "1092"
  },
  "1093": {
    "hex": "#45B4CE",
    "name": "Azure Sea Blue",
    "code": "1093"
  },
  "1094": {
    "hex": "#33B0D1",
    "name": "Caribbean Blue",
    "code": "1094"
  },
  "1095": {
    "hex": "#30AAD1",
    "name": " Larimar Blue ",
    "code": "1095"
  },
  "1096": {
    "hex": "#3882AB",
    "name": "Cobalt Blue",
    "code": "1096"
  },
  "1097": {
    "hex": "#C8D4CB",
    "name": "Honeydew Melon Green ",
    "code": "1097"
  },
  "1098": {
    "hex": "#5A8177",
    "name": "Blue Grass Green ",
    "code": "1098"
  },
  "1099": {
    "hex": "#ABB58E",
    "name": "Leek Green",
    "code": "1099"
  },
  "1100": {
    "hex": "#C9D2B8",
    "name": "Cucumber Green ",
    "code": "1100"
  },
  "1101": {
    "hex": "#46875A",
    "name": "Wintergreen",
    "code": "1101"
  },
  "1102": {
    "hex": "#BCB87D",
    "name": "Light Moss Green",
    "code": "1102"
  },
  "1103": {
    "hex": "#415248",
    "name": "Hunter Green ",
    "code": "1103"
  },
  "1104": {
    "hex": "#C5C79B",
    "name": "Scallion Green",
    "code": "1104"
  },
  "1105": {
    "hex": "#B0A77D",
    "name": "Weeping Willow Green ",
    "code": "1105"
  },
  "1106": {
    "hex": "#9F9A53",
    "name": "Guacamole Green",
    "code": "1106"
  },
  "1107": {
    "hex": "#EB7176",
    "name": "Honeysuckle Pink ",
    "code": "1107"
  },
  "1108": {
    "hex": "#E5859B",
    "name": "Pink Carnation",
    "code": "1108"
  },
  "1109": {
    "hex": "#D02C78",
    "name": "Pink Rose",
    "code": "1109"
  },
  "1110": {
    "hex": "#AF296D",
    "name": "Fuchsia Pink",
    "code": "1110"
  },
  "1111": {
    "hex": "#D1B6D0",
    "name": "Evening Mist Purple Pink ",
    "code": "1111"
  },
  "1112": {
    "hex": "#5D4788",
    "name": "Majestic Purple",
    "code": "1112"
  },
  "1114": {
    "hex": "#E8C4C8",
    "name": "Pink Petal ",
    "code": "1114"
  },
  "1115": {
    "hex": "#E2B6B9",
    "name": "Powder Puff Pink",
    "code": "1115"
  },
  "1116": {
    "hex": "#EDB3C1",
    "name": "Cotton Candy Pink ",
    "code": "1116"
  },
  "1117": {
    "hex": "#E4638F",
    "name": "Flamingo Pink ",
    "code": "1117"
  },
  "1118": {
    "hex": "#94949E",
    "name": "Overcast Gray",
    "code": "1118"
  },
  "1119": {
    "hex": "#963C5A",
    "name": "English Rose",
    "code": "1119"
  },
  "1120": {
    "hex": "#E0B4BC",
    "name": "Baby Pink ",
    "code": "1120"
  },
  "1121": {
    "hex": "#E2ACC6",
    "name": "Candy Heart Pink ",
    "code": "1121"
  },
  "1122": {
    "hex": "#563468",
    "name": "Deep Lilac Purple ",
    "code": "1122"
  },
  "1123": {
    "hex": "#F8EED8",
    "name": "Parchment Beige",
    "code": "1123"
  },
  "1124": {
    "hex": "#F0CF4A",
    "name": "Classic Rayon Gold Rush Yellow ",
    "code": "1124"
  },
  "1125": {
    "hex": "#E7BB44",
    "name": "Saffron Yellow",
    "code": "1125"
  },
  "1126": {
    "hex": "#A27754",
    "name": "Light Brown Sugar ",
    "code": "1126"
  },
  "1127": {
    "hex": "#D4B6A8",
    "name": "Loofah Beige",
    "code": "1127"
  },
  "1128": {
    "hex": "#AD9788",
    "name": "Taupe ",
    "code": "1128"
  },
  "1129": {
    "hex": "#433735",
    "name": "Mud Pie Brown",
    "code": "1129"
  },
  "1130": {
    "hex": "#4D3E3E",
    "name": "Chocolate Chip Brown",
    "code": "1130"
  },
  "1131": {
    "hex": "#393536",
    "name": "Espresso Brown",
    "code": "1131"
  },
  "1132": {
    "hex": "#A4C0D7",
    "name": "Clear Blue",
    "code": "1132"
  },
  "1133": {
    "hex": "#3269B6",
    "name": "Forget Me Not Blue ",
    "code": "1133"
  },
  "1134": {
    "hex": "#2A4B93",
    "name": "Royal Blue",
    "code": "1134"
  },
  "1135": {
    "hex": "#E8D476",
    "name": "Baby Chick Yellow",
    "code": "1135"
  },
  "1136": {
    "hex": "#8D7A6B",
    "name": "Dark Taupe Brown Grey",
    "code": "1136"
  },
  "1137": {
    "hex": "#EC9F3E",
    "name": " Citrus Burst",
    "code": "1137"
  },
  "1138": {
    "hex": "#C5B49E",
    "name": "Doe Skin Beige",
    "code": "1138"
  },
  "1140": {
    "hex": "#888D3C",
    "name": " Avocado Green ",
    "code": "1140"
  },
  "1141": {
    "hex": "#A5767C",
    "name": "Mauve",
    "code": "1141"
  },
  "1142": {
    "hex": "#B49187",
    "name": "Peach Puff ",
    "code": "1142"
  },
  "1143": {
    "hex": "#636EA6",
    "name": "China Blue",
    "code": "1143"
  },
  "1144": {
    "hex": "#7F685A",
    "name": "Bark Brown ",
    "code": "1144"
  },
  "1145": {
    "hex": "#5E3E36",
    "name": "Coffee Bean Brown",
    "code": "1145"
  },
  "1146": {
    "hex": "#E12B29",
    "name": "Tomato Red",
    "code": "1146"
  },
  "1147": {
    "hex": "#AC292C",
    "name": "Christmas Red",
    "code": "1147"
  },
  "1148": {
    "hex": "#E093A8",
    "name": "Rustic Pink ",
    "code": "1148"
  },
  "1149": {
    "hex": "#D3C2B0",
    "name": "Tusk Beige ",
    "code": "1149"
  },
  "1150": {
    "hex": "#DFE192",
    "name": " Chartreuse ",
    "code": "1150"
  },
  "1151": {
    "hex": "#C3C4D1",
    "name": "Silver Moon Gray",
    "code": "1151"
  },
  "1152": {
    "hex": "#F29564",
    "name": "Peach Tea",
    "code": "1152"
  },
  "1153": {
    "hex": "#BAC0CF",
    "name": "Frosted Glass Blue Gray ",
    "code": "1153"
  },
  "1154": {
    "hex": "#D54659",
    "name": "Lipstick Rose",
    "code": "1154"
  },
  "1155": {
    "hex": "#EEA356",
    "name": "Marmalade",
    "code": "1155"
  },
  "1156": {
    "hex": "#7A7749",
    "name": "Palm Frond Yellow Green ",
    "code": "1156"
  },
  "1157": {
    "hex": "#685E43",
    "name": "Marsh Green Brown",
    "code": "1157"
  },
  "1158": {
    "hex": "#744132",
    "name": "Chestnut Brown ",
    "code": "1158"
  },
  "1159": {
    "hex": "#CEA63F",
    "name": "Mustard Yellow Green",
    "code": "1159"
  },
  "1160": {
    "hex": "#4C6C83",
    "name": "Antique Blue",
    "code": "1160"
  },
  "1161": {
    "hex": "#384756",
    "name": "Twilight Blue Green",
    "code": "1161"
  },
  "1162": {
    "hex": "#354458",
    "name": "Admiral Blue ",
    "code": "1162"
  },
  "1163": {
    "hex": "#717F89",
    "name": "Steel Gray ",
    "code": "1163"
  },
  "1164": {
    "hex": "#42434F",
    "name": "Twister Gray",
    "code": "1164"
  },
  "1166": {
    "hex": "#2A3A7A",
    "name": "Hanukkah Blue",
    "code": "1166"
  },
  "1167": {
    "hex": "#324477",
    "name": "Blue Ink",
    "code": "1167"
  },
  "1169": {
    "hex": "#8F9C49",
    "name": "Split Pea Yellow Green",
    "code": "1169"
  },
  "1170": {
    "hex": "#567535",
    "name": "Fern Green",
    "code": "1170"
  },
  "1171": {
    "hex": "#E5B844",
    "name": "Lemon Drop ",
    "code": "1171"
  },
  "1172": {
    "hex": "#E2A63F",
    "name": "Egg Yolk Yellow ",
    "code": "1172"
  },
  "1173": {
    "hex": "#B97836",
    "name": "Autumn Gold",
    "code": "1173"
  },
  "1174": {
    "hex": "#7C3A3B",
    "name": "Cinnamon Stick Brown",
    "code": "1174"
  },
  "1175": {
    "hex": "#496693",
    "name": "Dark Federal Blue",
    "code": "1175"
  },
  "1176": {
    "hex": "#3E7DBB",
    "name": "Navajo Blue",
    "code": "1176"
  },
  "1177": {
    "hex": "#2A65A9",
    "name": "Blue Bird Blue",
    "code": "1177"
  },
  "1178": {
    "hex": "#EF7433",
    "name": "Carrot ",
    "code": "1178"
  },
  "1179": {
    "hex": "#C35543",
    "name": "Sweet Potato",
    "code": "1179"
  },
  "1180": {
    "hex": "#E8D04A",
    "name": "Daffodil Yellow",
    "code": "1180"
  },
  "1181": {
    "hex": "#822C35",
    "name": "Candy Apple Red ",
    "code": "1181"
  },
  "1182": {
    "hex": "#77293E",
    "name": "Mulberry",
    "code": "1182"
  },
  "1183": {
    "hex": "#872A50",
    "name": "Cranberry",
    "code": "1183"
  },
  "1184": {
    "hex": "#B22B42",
    "name": "Scarlet Rose Red Pink",
    "code": "1184"
  },
  "1185": {
    "hex": "#30646D",
    "name": "Dark Teal",
    "code": "1185"
  },
  "1186": {
    "hex": "#DE3A60",
    "name": "Ruby Slipper Red",
    "code": "1186"
  },
  "1187": {
    "hex": "#D7295F",
    "name": "Orchid Red Pink",
    "code": "1187"
  },
  "1188": {
    "hex": "#78336D",
    "name": "Chokecherry Purple ",
    "code": "1188"
  },
  "1189": {
    "hex": "#48593B",
    "name": "Moss Green",
    "code": "1189"
  },
  "1190": {
    "hex": "#9E8F3E",
    "name": "Sea Weed Green",
    "code": "1190"
  },
  "1191": {
    "hex": "#9D7C3A",
    "name": "Gold Coin",
    "code": "1191"
  },
  "1192": {
    "hex": "#A37B34",
    "name": "Honey Mustard Gold",
    "code": "1192"
  },
  "1193": {
    "hex": "#C0B258",
    "name": "Peridot Yellow Green ",
    "code": "1193"
  },
  "1194": {
    "hex": "#746033",
    "name": "Dark Olive Green ",
    "code": "1194"
  },
  "1195": {
    "hex": "#95C0BB",
    "name": "Menthol Green",
    "code": "1195"
  },
  "1196": {
    "hex": "#A18C39",
    "name": "Medium Camo Green",
    "code": "1196"
  },
  "1198": {
    "hex": "#B8C0D3",
    "name": "Moonstone Gray ",
    "code": "1198"
  },
  "1199": {
    "hex": "#33323C",
    "name": "Onyx (Black)",
    "code": "1199"
  },
  "1212": {
    "hex": "#A9ABB7",
    "name": "Stainless Steel ",
    "code": "1212"
  },
  "1219": {
    "hex": "#B1C1C1",
    "name": "Hint of Mint Green ",
    "code": "1219"
  },
  "1220": {
    "hex": "#E17A78",
    "name": "Conch Shell Pink ",
    "code": "1220"
  },
  "1221": {
    "hex": "#A54331",
    "name": "Terra Cotta ",
    "code": "1221"
  },
  "1223": {
    "hex": "#DECB49",
    "name": " Lemon Tart Yellow ",
    "code": "1223"
  },
  "1224": {
    "hex": "#ECD14D",
    "name": "Lemonade Yellow",
    "code": "1224"
  },
  "1225": {
    "hex": "#C6973E",
    "name": "Liquid Gold",
    "code": "1225"
  },
  "1226": {
    "hex": "#D49361",
    "name": "Amber Orange Brown",
    "code": "1226"
  },
  "1227": {
    "hex": "#88A4A8",
    "name": "Mint Jubilee Green ",
    "code": "1227"
  },
  "1228": {
    "hex": "#6B5C5A",
    "name": "Mink",
    "code": "1228"
  },
  "1229": {
    "hex": "#574843",
    "name": "Clove Brown ",
    "code": "1229"
  },
  "1230": {
    "hex": "#614C3E",
    "name": " Root Beer Brown",
    "code": "1230"
  },
  "1232": {
    "hex": "#B39EC0",
    "name": "Lavender Purple ",
    "code": "1232"
  },
  "1233": {
    "hex": "#58496B",
    "name": " Blackberry Purple ",
    "code": "1233"
  },
  "1234": {
    "hex": "#BE2A5F",
    "name": "Hibiscus Pink ",
    "code": "1234"
  },
  "1235": {
    "hex": "#9D6994",
    "name": "Crocus Purple ",
    "code": "1235"
  },
  "1236": {
    "hex": "#502D3E",
    "name": "Plum Brandy ",
    "code": "1236"
  },
  "1238": {
    "hex": "#812B38",
    "name": "Sangria ",
    "code": "1238"
  },
  "1239": {
    "hex": "#7D6F74",
    "name": "Charcoal Gray",
    "code": "1239"
  },
  "1240": {
    "hex": "#6D6165",
    "name": "Stone Gray",
    "code": "1240"
  },
  "1241": {
    "hex": "#4C4B58",
    "name": "Obsidian Gray",
    "code": "1241"
  },
  "1242": {
    "hex": "#2D3E62",
    "name": "Dark Denim",
    "code": "1242"
  },
  "1243": {
    "hex": "#333751",
    "name": "Star-kissed Night",
    "code": "1243"
  },
  "1244": {
    "hex": "#35333D",
    "name": "Darkest Night Blue",
    "code": "1244"
  },
  "1245": {
    "hex": "#28A189",
    "name": "Sea Foam Green",
    "code": "1245"
  },
  "1246": {
    "hex": "#2F898D",
    "name": "Teal Green ",
    "code": "1246"
  },
  "1247": {
    "hex": "#309980",
    "name": "Bottle Green",
    "code": "1247"
  },
  "1248": {
    "hex": "#9DD160",
    "name": "Margarita Lime Green",
    "code": "1248"
  },
  "1249": {
    "hex": "#319C49",
    "name": "Shamrock Green",
    "code": "1249"
  },
  "1250": {
    "hex": "#2A654B",
    "name": "Christmas Green",
    "code": "1250"
  },
  "1251": {
    "hex": "#319C5E",
    "name": "Kelly Green",
    "code": "1251"
  },
  "1252": {
    "hex": "#48616E",
    "name": "Neptune Blue",
    "code": "1252"
  },
  "1253": {
    "hex": "#D2864B",
    "name": "Penny Brown Orange",
    "code": "1253"
  },
  "1254": {
    "hex": "#E29383",
    "name": "Dark Salmon",
    "code": "1254"
  },
  "1255": {
    "hex": "#DDB570",
    "name": "Khaki Brown",
    "code": "1255"
  },
  "1256": {
    "hex": "#B48657",
    "name": "Teddy Bear Brown ",
    "code": "1256"
  },
  "1257": {
    "hex": "#D16E26",
    "name": "Bronze",
    "code": "1257"
  },
  "1258": {
    "hex": "#9F5A2F",
    "name": "Grizzly Bear Brown",
    "code": "1258"
  },
  "1259": {
    "hex": "#785E57",
    "name": "Cocoa",
    "code": "1259"
  },
  "1260": {
    "hex": "#D5CDA1",
    "name": "Canvas",
    "code": "1260"
  },
  "1261": {
    "hex": "#A5B3D7",
    "name": "Lavendula",
    "code": "1261"
  },
  "1263": {
    "hex": "#908EA9",
    "name": "Dusty Lilac",
    "code": "1263"
  },
  "1264": {
    "hex": "#9D9BAB",
    "name": "Lavender Ice",
    "code": "1264"
  },
  "1266": {
    "hex": "#4A6AA9",
    "name": "Regal Blue",
    "code": "1266"
  },
  "1270": {
    "hex": "#FCE39E",
    "name": "Sawdust",
    "code": "1270"
  },
  "1272": {
    "hex": "#E2B27D",
    "name": "Golden Retriever",
    "code": "1272"
  },
  "1273": {
    "hex": "#d1a859",
    "name": "Peanut Brittle Brown",
    "code": "1273"
  },
  "1274": {
    "hex": "#91B2CF",
    "name": "Porcelain Blue",
    "code": "1274"
  },
  "1275": {
    "hex": "#94A6C6",
    "name": "Periwinkle",
    "code": "1275"
  },
  "1276": {
    "hex": "#5E86A5",
    "name": "Light Denim",
    "code": "1276"
  },
  "1277": {
    "hex": "#364058",
    "name": "Blueberry Smash ",
    "code": "1277"
  },
  "1278": {
    "hex": "#FA9429",
    "name": "Orange Icing",
    "code": "1278"
  },
  "1279": {
    "hex": "#3F9C8D",
    "name": "Tropical Teal Blue Green",
    "code": "1279"
  },
  "1280": {
    "hex": "#1F9079",
    "name": "Oregon Green",
    "code": "1280"
  },
  "1281": {
    "hex": "#CE264C",
    "name": "Radish Red",
    "code": "1281"
  },
  "1284": {
    "hex": "#378473",
    "name": "Rainforest",
    "code": "1284"
  },
  "1286": {
    "hex": "#E1E3E1",
    "name": "Mist",
    "code": "1286"
  },
  "1287": {
    "hex": "#7F7D7C",
    "name": "Gun Metal",
    "code": "1287"
  },
  "1288": {
    "hex": "#827C7D",
    "name": "Shark Gray",
    "code": "1288"
  },
  "1289": {
    "hex": "#65A9B4",
    "name": "Silver Mound",
    "code": "1289"
  },
  "1290": {
    "hex": "#335665",
    "name": "Mallard Teal ",
    "code": "1290"
  },
  "1291": {
    "hex": "#316077",
    "name": "Marlin Blue",
    "code": "1291"
  },
  "1292": {
    "hex": "#A6D6D5",
    "name": "Limestone",
    "code": "1292"
  },
  "1293": {
    "hex": "#157D99",
    "name": "Malachite Blue",
    "code": "1293"
  },
  "1294": {
    "hex": "#1D84C7",
    "name": "Liberty Blue",
    "code": "1294"
  },
  "1295": {
    "hex": "#2982BB",
    "name": "Cyan Blue",
    "code": "1295"
  },
  "1296": {
    "hex": "#053382",
    "name": "Deep Ocean Blue",
    "code": "1296"
  },
  "1297": {
    "hex": "#296BBA",
    "name": "Calypso Blue",
    "code": "1297"
  },
  "1298": {
    "hex": "#2A7B84",
    "name": "Tree Frog Blue Green",
    "code": "1298"
  },
  "1299": {
    "hex": "#2BEEEC",
    "name": "Green Turquoise",
    "code": "1299"
  },
  "1301": {
    "hex": "#67C195",
    "name": "Jade",
    "code": "1301"
  },
  "1302": {
    "hex": "#90DF9F",
    "name": "Spearmint",
    "code": "1302"
  },
  "1303": {
    "hex": "#42443D",
    "name": "Fresh Oregono Green ",
    "code": "1303"
  },
  "1304": {
    "hex": "#29614F",
    "name": "Ivy",
    "code": "1304"
  },
  "1305": {
    "hex": "#B9AF91",
    "name": "Chamois Gray Beige",
    "code": "1305"
  },
  "1306": {
    "hex": "#81796D",
    "name": "Army Green",
    "code": "1306"
  },
  "1307": {
    "hex": "#DB5E5C",
    "name": "Raspberry Punch",
    "code": "1307"
  },
  "1308": {
    "hex": "#A4A48B",
    "name": "Army Fatigues Green",
    "code": "1308"
  },
  "1309": {
    "hex": "#DA77A7",
    "name": "Dahlia",
    "code": "1309"
  },
  "1310": {
    "hex": "#CC2D9D",
    "name": "Magenta",
    "code": "1310"
  },
  "1311": {
    "hex": "#9B99C8",
    "name": "Mystic Lavender",
    "code": "1311"
  },
  "1312": {
    "hex": "#665A7F",
    "name": "Purple Grape",
    "code": "1312"
  },
  "1313": {
    "hex": "#3b1e50",
    "name": "Berry Blast Purple",
    "code": "1313"
  },
  "1315": {
    "hex": "#ECA9B1",
    "name": "Pink Grapefruit",
    "code": "1315"
  },
  "1317": {
    "hex": "#E7A49C",
    "name": "Blush Pink ",
    "code": "1317"
  },
  "1318": {
    "hex": "#473E49",
    "name": "Graphite Gray",
    "code": "1318"
  },
  "1319": {
    "hex": "#A17094",
    "name": "Iris",
    "code": "1319"
  },
  "1320": {
    "hex": "#883D93",
    "name": "Purple Heart ",
    "code": "1320"
  },
  "1321": {
    "hex": "#E298C0",
    "name": "Bubble Gum Pink ",
    "code": "1321"
  },
  "1322": {
    "hex": "#51538D",
    "name": "Royal Purple",
    "code": "1322"
  },
  "1323": {
    "hex": "#D0BE47",
    "name": "Golden Wheat",
    "code": "1323"
  },
  "1328": {
    "hex": "#BD9F8C",
    "name": "Buckskin Beige",
    "code": "1328"
  },
  "1329": {
    "hex": "#826354",
    "name": "Toasted Marshmallow Brown",
    "code": "1329"
  },
  "1330": {
    "hex": "#6060A7",
    "name": "Bahamas Blue",
    "code": "1330"
  },
  "1334": {
    "hex": "#6D4376",
    "name": "Purple Passion",
    "code": "1334"
  },
  "1335": {
    "hex": "#5D69C7",
    "name": "Dark Periwinkle",
    "code": "1335"
  },
  "1336": {
    "hex": "#624C46",
    "name": "Saddle Brown ",
    "code": "1336"
  },
  "1337": {
    "hex": "#A4A894",
    "name": "Gray Mist",
    "code": "1337"
  },
  "1338": {
    "hex": "#AE926D",
    "name": "Nutmeg Brown",
    "code": "1338"
  },
  "1339": {
    "hex": "#B7B6A3",
    "name": "Spanish Moss",
    "code": "1339"
  },
  "1340": {
    "hex": "#F7E086",
    "name": "Palomino Yellow",
    "code": "1340"
  },
  "1342": {
    "hex": "#C3A38F",
    "name": "Fawn",
    "code": "1342"
  },
  "1343": {
    "hex": "#414772",
    "name": "Grape Juice",
    "code": "1343"
  },
  "1344": {
    "hex": "#9B7758",
    "name": "Camel Brown",
    "code": "1344"
  },
  "1348": {
    "hex": "#86622E",
    "name": "Antique Bronze Brown",
    "code": "1348"
  },
  "1349": {
    "hex": "#F8E195",
    "name": "Palomino",
    "code": "1349"
  },
  "1350": {
    "hex": "#BDB151",
    "name": "Citrus Green",
    "code": "1350"
  },
  "1351": {
    "hex": "#316E59",
    "name": "Alligator",
    "code": "1351"
  },
  "1352": {
    "hex": "#E0B511",
    "name": "Old Gold ",
    "code": "1352"
  },
  "1353": {
    "hex": "#6D8BAD",
    "name": "Blue Spruce",
    "code": "1353"
  },
  "1354": {
    "hex": "#CC436E",
    "name": "Watermelon Pink",
    "code": "1354"
  },
  "1356": {
    "hex": "#B49DA7",
    "name": "Pink Pearl",
    "code": "1356"
  },
  "1357": {
    "hex": "#4D483A",
    "name": "Dark Seaweed Green Brown",
    "code": "1357"
  },
  "1358": {
    "hex": "#755653",
    "name": "Cedar Bark",
    "code": "1358"
  },
  "1359": {
    "hex": "#E4B627",
    "name": "Golden Nugget ",
    "code": "1359"
  },
  "1360": {
    "hex": "#859DAC",
    "name": "Dusty Blue Gray",
    "code": "1360"
  },
  "1361": {
    "hex": "#696E68",
    "name": "Battleship",
    "code": "1361"
  },
  "1362": {
    "hex": "#5C5C69",
    "name": "Slate Purple",
    "code": "1362"
  },
  "1363": {
    "hex": "#817F97",
    "name": "Steele Lavender Gray",
    "code": "1363"
  },
  "1364": {
    "hex": "#555F7B",
    "name": "Storm Sky Blue",
    "code": "1364"
  },
  "1365": {
    "hex": "#4F5D72",
    "name": "Dusty Plum",
    "code": "1365"
  },
  "1366": {
    "hex": "#3B4070",
    "name": "Sailor Blue",
    "code": "1366"
  },
  "1367": {
    "hex": "#384047",
    "name": "Black Pearl",
    "code": "1367"
  },
  "1368": {
    "hex": "#31354A",
    "name": "Night Sky Blue",
    "code": "1368"
  },
  "1369": {
    "hex": "#2B9E36",
    "name": "Fresh Pine Green ",
    "code": "1369"
  },
  "1370": {
    "hex": "#31604D",
    "name": "Fir Green",
    "code": "1370"
  },
  "1371": {
    "hex": "#376C64",
    "name": "Deep Sea Blue Green",
    "code": "1371"
  },
  "1372": {
    "hex": "#DFA740",
    "name": "Honey Yellow Gold ",
    "code": "1372"
  },
  "1373": {
    "hex": "#82B7CF",
    "name": "Cerulean Frost",
    "code": "1373"
  },
  "1374": {
    "hex": "#663D3D",
    "name": "Maroon",
    "code": "1374"
  },
  "1375": {
    "hex": "#3894C6",
    "name": "Work Shirt Blue",
    "code": "1375"
  },
  "1376": {
    "hex": "#2A5F9A",
    "name": "Space Blue ",
    "code": "1376"
  },
  "1377": {
    "hex": "#8AE97A",
    "name": "Kiwi Green",
    "code": "1377"
  },
  "1378": {
    "hex": "#CC2A29",
    "name": "Paprika Red",
    "code": "1378"
  },
  "1379": {
    "hex": "#FF7949",
    "name": "Mandarin",
    "code": "1379"
  },
  "1380": {
    "hex": "#2D918E",
    "name": "Oasis Blue Green ",
    "code": "1380"
  },
  "1381": {
    "hex": "#8C384A",
    "name": "Ripe Raspberry",
    "code": "1381"
  },
  "1382": {
    "hex": "#6C4B53",
    "name": "Colonial Rose",
    "code": "1382"
  },
  "1383": {
    "hex": "#922950",
    "name": "Pink Pansy",
    "code": "1383"
  },
  "1384": {
    "hex": "#8E1F3F",
    "name": "Merlot",
    "code": "1384"
  },
  "1385": {
    "hex": "#752E42",
    "name": "Garnet",
    "code": "1385"
  },
  "1386": {
    "hex": "#752E42",
    "name": "Garnet ",
    "code": "1386"
  },
  "1387": {
    "hex": "#7A647E",
    "name": "Berry Frost Blue Purple",
    "code": "1387"
  },
  "1388": {
    "hex": "#62445D",
    "name": "Plum",
    "code": "1388"
  },
  "1389": {
    "hex": "#6D2A44",
    "name": "Bordeaux Purple Pink",
    "code": "1389"
  },
  "1390": {
    "hex": "#3D4B49",
    "name": "Forest Green ",
    "code": "1390"
  },
  "1391": {
    "hex": "#586E6B",
    "name": "Spruce Green ",
    "code": "1391"
  },
  "1392": {
    "hex": "#869B83",
    "name": "Silver Sage Green",
    "code": "1392"
  },
  "1393": {
    "hex": "#79796D",
    "name": "Bass Green",
    "code": "1393"
  },
  "1394": {
    "hex": "#5A6150",
    "name": "Kale",
    "code": "1394"
  },
  "1395": {
    "hex": "#434F44",
    "name": "Rosemary",
    "code": "1395"
  },
  "1396": {
    "hex": "#485545",
    "name": "Dark Sage Green",
    "code": "1396"
  },
  "1397": {
    "hex": "#305146",
    "name": "Evergreen",
    "code": "1397"
  },
  "1405": {
    "hex": "#c1beb3",
    "name": "Goose Gray",
    "code": "1405"
  },
  "1406": {
    "hex": "#63634E",
    "name": "",
    "code": "1406"
  },
  "1410": {
    "hex": "#DEDFDA",
    "name": "",
    "code": "1410"
  },
  "1411": {
    "hex": "#C1C8CA",
    "name": "",
    "code": "1411"
  },
  "1412": {
    "hex": "#534774",
    "name": "",
    "code": "1412"
  },
  "1415": {
    "hex": "#707274",
    "name": "Battleship Gray ",
    "code": "1415"
  },
  "1421": {
    "hex": "#B05B3B",
    "name": "",
    "code": "1421"
  },
  "1422": {
    "hex": "#604C88",
    "name": "",
    "code": "1422"
  },
  "1425": {
    "hex": "#57444d",
    "name": "Dusky Mauve",
    "code": "1425"
  },
  "1428": {
    "hex": "#9E9480",
    "name": "",
    "code": "1428"
  },
  "1430": {
    "hex": "#585251",
    "name": "",
    "code": "1430"
  },
  "1431": {
    "hex": "#5E4F5E",
    "name": "Bittersweet Chocolate Brown ",
    "code": "1431"
  },
  "1432": {
    "hex": "#85B0E2",
    "name": "",
    "code": "1432"
  },
  "1434": {
    "hex": "#276FA5",
    "name": "",
    "code": "1434"
  },
  "1437": {
    "hex": "#FFB22D",
    "name": "",
    "code": "1437"
  },
  "1439": {
    "hex": "#595A59",
    "name": "",
    "code": "1439"
  },
  "1440": {
    "hex": "#5A565A",
    "name": "Cobblestone Gray",
    "code": "1440"
  },
  "1445": {
    "hex": "#594743",
    "name": "",
    "code": "1445"
  },
  "1447": {
    "hex": "#B93A38",
    "name": "",
    "code": "1447"
  },
  "1448": {
    "hex": "#CFDE95",
    "name": "",
    "code": "1448"
  },
  "1449": {
    "hex": "#D6DA5E",
    "name": "",
    "code": "1449"
  },
  "1450": {
    "hex": "#D3D01F",
    "name": "",
    "code": "1450"
  },
  "1451": {
    "hex": "#99AB71",
    "name": "",
    "code": "1451"
  },
  "1460": {
    "hex": "#D4D0C8",
    "name": "",
    "code": "1460"
  },
  "1461": {
    "hex": "#758080",
    "name": "",
    "code": "1461"
  },
  "1463": {
    "hex": "#8F8E89",
    "name": "Willow Gray",
    "code": "1463"
  },
  "1466": {
    "hex": "#30437C",
    "name": "",
    "code": "1466"
  },
  "1467": {
    "hex": "#2B388D",
    "name": "Pea Coat Blue",
    "code": "1467"
  },
  "1469": {
    "hex": "#8AAB3F",
    "name": "",
    "code": "1469"
  },
  "1470": {
    "hex": "#F5CF73",
    "name": "Vegas Gold",
    "code": "1470"
  },
  "1476": {
    "hex": "#1F5A77",
    "name": "Independence Blue",
    "code": "1476"
  },
  "1477": {
    "hex": "#C44B3E",
    "name": "Salsa",
    "code": "1477"
  },
  "1478": {
    "hex": "#F47E1F",
    "name": "",
    "code": "1478"
  },
  "1479": {
    "hex": "#397B53",
    "name": "",
    "code": "1479"
  },
  "1480": {
    "hex": "#1F7B5D",
    "name": "Rain Forest Green",
    "code": "1480"
  },
  "1481": {
    "hex": "#A82C3C",
    "name": "",
    "code": "1481"
  },
  "1484": {
    "hex": "#BF3B4A",
    "name": "",
    "code": "1484"
  },
  "1485": {
    "hex": "#E5171D",
    "name": "Electric Red",
    "code": "1485"
  },
  "1488": {
    "hex": "#734164",
    "name": "",
    "code": "1488"
  },
  "1489": {
    "hex": "#658730",
    "name": "Clover Green",
    "code": "1489"
  },
  "1491": {
    "hex": "#B2884B",
    "name": "",
    "code": "1491"
  },
  "1494": {
    "hex": "#8C804E",
    "name": "",
    "code": "1494"
  },
  "1495": {
    "hex": "#616845",
    "name": "",
    "code": "1495"
  },
  "1497": {
    "hex": "#218FB8",
    "name": "",
    "code": "1497"
  },
  "1502": {
    "hex": "#848B91",
    "name": "Zipper",
    "code": "1502"
  },
  "1505": {
    "hex": "#B2B7BB",
    "name": "Polished Silver",
    "code": "1505"
  },
  "1506": {
    "hex": "#4C5963",
    "name": "Deep Steel Blue",
    "code": "1506"
  },
  "1507": {
    "hex": "#3E4850",
    "name": "Pea Coat Lining",
    "code": "1507"
  },
  "1508": {
    "hex": "#E8A1B4",
    "name": "Cherry Pie",
    "code": "1508"
  },
  "1509": {
    "hex": "#BF3F55",
    "name": "Rhubarb",
    "code": "1509"
  },
  "1521": {
    "hex": "#F97A30",
    "name": "Autumn Orange",
    "code": "1521"
  },
  "1522": {
    "hex": "#7E6CD5",
    "name": "Lavender Blue ",
    "code": "1522"
  },
  "1526": {
    "hex": "#FFF3BD",
    "name": " Yellow",
    "code": "1526"
  },
  "1527": {
    "hex": "#CBA87F",
    "name": "Teddy Bear",
    "code": "1527"
  },
  "1528": {
    "hex": "#5583BC",
    "name": "Serene Sky",
    "code": "1528"
  },
  "1529": {
    "hex": "#CAC8D7",
    "name": "Orchid Mist",
    "code": "1529"
  },
  "1531": {
    "hex": "#6990BE",
    "name": "Delphinium",
    "code": "1531"
  },
  "1532": {
    "hex": "#88B4E8",
    "name": "Little Boy Blue",
    "code": "1532"
  },
  "1535": {
    "hex": "#b6ab96",
    "name": "Tarnished Taupe",
    "code": "1535"
  },
  "1538": {
    "hex": "#B39B72",
    "name": "Tiramisu",
    "code": "1538"
  },
  "1539": {
    "hex": "#706F6A",
    "name": "Stone",
    "code": "1539"
  },
  "1540": {
    "hex": "#545959",
    "name": "Cobblestone",
    "code": "1540"
  },
  "1541": {
    "hex": "#E8EB82",
    "name": "Chartreuse",
    "code": "1541"
  },
  "1542": {
    "hex": "#7B9FC5",
    "name": "Blue Heather",
    "code": "1542"
  },
  "1544": {
    "hex": "#4F5162",
    "name": "Chimney Smoke",
    "code": "1544"
  },
  "1545": {
    "hex": "#DBF2EC",
    "name": "Winter Mint",
    "code": "1545"
  },
  "1548": {
    "hex": "#FFABCB",
    "name": "Pink Plush",
    "code": "1548"
  },
  "1549": {
    "hex": "#FCC7E0",
    "name": "Pink Sorbet",
    "code": "1549"
  },
  "1550": {
    "hex": "#C4D9F2",
    "name": "Light Periwinkle",
    "code": "1550"
  },
  "1552": {
    "hex": "#BBB576",
    "name": "Golden Green",
    "code": "1552"
  },
  "1553": {
    "hex": "#555572",
    "name": "Galaxy Blue",
    "code": "1553"
  },
  "1554": {
    "hex": "#EEDCD4",
    "name": "Dogwood",
    "code": "1554"
  },
  "1555": {
    "hex": "#393F50",
    "name": "Carbon Paper",
    "code": "1555"
  },
  "1556": {
    "hex": "#D2AC88",
    "name": "Taste of Honey",
    "code": "1556"
  },
  "1557": {
    "hex": "#514B41",
    "name": "Mud Facial",
    "code": "1557"
  },
  "1558": {
    "hex": "#4D433E",
    "name": "French Roast",
    "code": "1558"
  },
  "1559": {
    "hex": "#5b544e",
    "name": "Mud Pie",
    "code": "1559"
  },
  "1560": {
    "hex": "#44413D",
    "name": "Espresso",
    "code": "1560"
  },
  "1561": {
    "hex": "#E8D7A3",
    "name": "Cornmeal",
    "code": "1561"
  },
  "1562": {
    "hex": "#A2BEE2",
    "name": "Blue Hydrangea",
    "code": "1562"
  },
  "1563": {
    "hex": "#CDE6F4",
    "name": "Icy Blue",
    "code": "1563"
  },
  "1564": {
    "hex": "#3D3B46",
    "name": "Dark Pewter",
    "code": "1564"
  },
  "1565": {
    "hex": "#745337",
    "name": "Irish Coffee",
    "code": "1565"
  },
  "1566": {
    "hex": "#29306D",
    "name": "Brilliant Blue",
    "code": "1566"
  },
  "1567": {
    "hex": "#731220",
    "name": " Pickled Beet Red ",
    "code": "1567"
  },
  "1568": {
    "hex": "#9C9B7B",
    "name": "Granite Green",
    "code": "1568"
  },
  "1569": {
    "hex": "#767960",
    "name": "Hemlock",
    "code": "1569"
  },
  "1572": {
    "hex": "#ABA3AF",
    "name": "Winter Gray ",
    "code": "1572"
  },
  "1573": {
    "hex": "#B2A494",
    "name": "Vintage Lace",
    "code": "1573"
  },
  "1574": {
    "hex": "#3C444B",
    "name": "Dark Slate Blue",
    "code": "1574"
  },
  "1575": {
    "hex": "#63656F",
    "name": "Iron Gray",
    "code": "1575"
  },
  "1577": {
    "hex": "#1FA2BD",
    "name": "Dark Blue Turquoise",
    "code": "1577"
  },
  "1578": {
    "hex": "#9FC8AE",
    "name": "Faded Jade ",
    "code": "1578"
  },
  "1580": {
    "hex": "#278065",
    "name": "Jungle Green",
    "code": "1580"
  },
  "1582": {
    "hex": "#E7E4D1",
    "name": "White Linen",
    "code": "1582"
  },
  "1584": {
    "hex": "#D4638D",
    "name": "Deep Pink",
    "code": "1584"
  },
  "1588": {
    "hex": "#DA5145",
    "name": "Salsa",
    "code": "1588"
  },
  "1589": {
    "hex": "#2D2C31",
    "name": "Ebony",
    "code": "1589"
  },
  "1592": {
    "hex": "#D7EFEF",
    "name": "Misty Mint",
    "code": "1592"
  },
  "1593": {
    "hex": "#2982BB",
    "name": "Blue Macaw ",
    "code": "1593"
  },
  "1594": {
    "hex": "#69CADC",
    "name": "Cool Aqua",
    "code": "1594"
  },
  "1595": {
    "hex": "#FF3D6D",
    "name": "Fluorescent Pink",
    "code": "1595"
  },
  "1596": {
    "hex": "#E74684",
    "name": "",
    "code": "1596"
  },
  "1597": {
    "hex": "#FF4DA2",
    "name": "Fluorescent Pink",
    "code": "1597"
  },
  "1598": {
    "hex": "#FF6D2E",
    "name": "Fluorescent Orange",
    "code": "1598"
  },
  "1599": {
    "hex": "#9FFF4A",
    "name": "",
    "code": "1599"
  },
  "1610": {
    "hex": "#BFBEC6",
    "name": " Silver",
    "code": "1610"
  },
  "1611": {
    "hex": "#A6A7B9",
    "name": "Smoke Gray",
    "code": "1611"
  },
  "1612": {
    "hex": "#939DB8",
    "name": "Steel",
    "code": "1612"
  },
  "1613": {
    "hex": "#8A929D",
    "name": "Gull Gray",
    "code": "1613"
  },
  "1614": {
    "hex": "#57525A",
    "name": "Twister ",
    "code": "1614"
  },
  "1615": {
    "hex": "#64606B",
    "name": "Battleship Gray",
    "code": "1615"
  },
  "1616": {
    "hex": "#E87E78",
    "name": "Conch Shell Pink",
    "code": "1616"
  },
  "1617": {
    "hex": "#3D3342",
    "name": "Slate Purple",
    "code": "1617"
  },
  "1618": {
    "hex": "#676370",
    "name": "Gun Powder",
    "code": "1618"
  },
  "1619": {
    "hex": "#524C5A",
    "name": " Granite",
    "code": "1619"
  },
  "1620": {
    "hex": "#F19493",
    "name": "Light Salmon Pink",
    "code": "1620"
  },
  "1621": {
    "hex": "#A53F2A",
    "name": "Rust Orange",
    "code": "1621"
  },
  "1622": {
    "hex": "#EEDFCA",
    "name": "Parchment",
    "code": "1622"
  },
  "1623": {
    "hex": "#F4E14F",
    "name": "Daffodil",
    "code": "1623"
  },
  "1624": {
    "hex": "#E1A63E",
    "name": "Egg Yolk",
    "code": "1624"
  },
  "1625": {
    "hex": "#B36E32",
    "name": "Butterscotch",
    "code": "1625"
  },
  "1626": {
    "hex": "#F3CB6B",
    "name": "Peaches 'n' Cream",
    "code": "1626"
  },
  "1627": {
    "hex": "#827291",
    "name": "Dusty Lilac",
    "code": "1627"
  },
  "1628": {
    "hex": "#7F9DC1",
    "name": "Worn Denim",
    "code": "1628"
  },
  "1629": {
    "hex": "#C0BDD1",
    "name": "Ice ",
    "code": "1629"
  },
  "1630": {
    "hex": "#B0AFDF",
    "name": "Lavendula",
    "code": "1630"
  },
  "1631": {
    "hex": "#754A87",
    "name": "Velvet Violet",
    "code": "1631"
  },
  "1632": {
    "hex": "#2C2935",
    "name": "Blackberry Purple",
    "code": "1632"
  },
  "1633": {
    "hex": "#3B2942",
    "name": "Purple Passion",
    "code": "1633"
  },
  "1634": {
    "hex": "#2D2941",
    "name": "Grape Jelly ",
    "code": "1634"
  },
  "1635": {
    "hex": "#402929",
    "name": "Burgundy",
    "code": "1635"
  },
  "1637": {
    "hex": "#A42929",
    "name": "Cinnamon Candy ",
    "code": "1637"
  },
  "1638": {
    "hex": "#70292B",
    "name": "Barn Red ",
    "code": "1638"
  },
  "1639": {
    "hex": "#A73237",
    "name": "Cinnabar Red",
    "code": "1639"
  },
  "1640": {
    "hex": "#504C57",
    "name": "Lead ",
    "code": "1640"
  },
  "1641": {
    "hex": "#2B2930",
    "name": "Obsidian",
    "code": "1641"
  },
  "1642": {
    "hex": "#2E4685",
    "name": "Lapis Blue",
    "code": "1642"
  },
  "1643": {
    "hex": "#42495E",
    "name": "Navy",
    "code": "1643"
  },
  "1645": {
    "hex": "#87D6D6",
    "name": "Light Mint",
    "code": "1645"
  },
  "1647": {
    "hex": "#ADE0C5",
    "name": "Mantis Green ",
    "code": "1647"
  },
  "1648": {
    "hex": "#7B8D55",
    "name": "Celery Green",
    "code": "1648"
  },
  "1649": {
    "hex": "#5A933A",
    "name": "Granny Smith Green",
    "code": "1649"
  },
  "1650": {
    "hex": "#337033",
    "name": "Fresh Pine Green ",
    "code": "1650"
  },
  "1651": {
    "hex": "#2A633B",
    "name": "Celtic Green ",
    "code": "1651"
  },
  "1652": {
    "hex": "#44717E",
    "name": "Mermaid ",
    "code": "1652"
  },
  "1653": {
    "hex": "#EDC5B3",
    "name": "Light Coral Pink",
    "code": "1653"
  },
  "1654": {
    "hex": "#6A5C56",
    "name": "Cocoa",
    "code": "1654"
  },
  "1656": {
    "hex": "#BC9788",
    "name": "Fawn Brown Beige",
    "code": "1656"
  },
  "1657": {
    "hex": "#724E3C",
    "name": "Golden Oak Brown ",
    "code": "1657"
  },
  "1658": {
    "hex": "#512D29",
    "name": "Mocha Brown",
    "code": "1658"
  },
  "1659": {
    "hex": "#3D2F30",
    "name": "Coffee Bean Brown",
    "code": "1659"
  },
  "1660": {
    "hex": "#B5A5A7",
    "name": "Sand Castle Gray ",
    "code": "1660"
  },
  "1661": {
    "hex": "#F3EEE1",
    "name": "Moonbeam",
    "code": "1661"
  },
  "1662": {
    "hex": "#918D7F",
    "name": "Slate",
    "code": "1662"
  },
  "1663": {
    "hex": "#5D4F4B",
    "name": "Clove Brown Gray",
    "code": "1663"
  },
  "1664": {
    "hex": "#4C4749",
    "name": "Graphite Gray",
    "code": "1664"
  },
  "1665": {
    "hex": "#322F31",
    "name": "Coal Gray",
    "code": "1665"
  },
  "1666": {
    "hex": "#FFF5DA",
    "name": " Cornsilk",
    "code": "1666"
  },
  "1668": {
    "hex": "#586059",
    "name": "Silver Sage",
    "code": "1668"
  },
  "1669": {
    "hex": "#343534",
    "name": "Rosemary ",
    "code": "1669"
  },
  "1670": {
    "hex": "#D1A558",
    "name": "Vegas Gold",
    "code": "1670"
  },
  "1671": {
    "hex": "#667FAA",
    "name": "Country Kitchen Blue",
    "code": "1671"
  },
  "1672": {
    "hex": "#A4823E",
    "name": "Toasted Almond ",
    "code": "1672"
  },
  "1673": {
    "hex": "#A88658",
    "name": "Khaki Brown Gold ",
    "code": "1673"
  },
  "1674": {
    "hex": "#C0E3F4",
    "name": "Light Denim Blue",
    "code": "1674"
  },
  "1675": {
    "hex": "#83A8D3",
    "name": "Nordic Blue",
    "code": "1675"
  },
  "1676": {
    "hex": "#2A356F",
    "name": "Hanukkah Blue",
    "code": "1676"
  },
  "1677": {
    "hex": "#275356",
    "name": "Mallard Teal",
    "code": "1677"
  },
  "1678": {
    "hex": "#DF775A",
    "name": "Pumpkin Orange",
    "code": "1678"
  },
  "1680": {
    "hex": "#614B65",
    "name": "Purple Heart",
    "code": "1680"
  },
  "1681": {
    "hex": "#A32A3D",
    "name": "Azalea Red ",
    "code": "1681"
  },
  "1682": {
    "hex": "#D4C6B9",
    "name": "Tusk Beige ",
    "code": "1682"
  },
  "1683": {
    "hex": "#EEC848",
    "name": "Lemon Drop",
    "code": "1683"
  },
  "1684": {
    "hex": "#B89D6B",
    "name": "Wheat Gold",
    "code": "1684"
  },
  "1685": {
    "hex": "#2A7A8D",
    "name": "Tree Frog",
    "code": "1685"
  },
  "1686": {
    "hex": "#CAC1C5",
    "name": "Mist Gray",
    "code": "1686"
  },
  "1687": {
    "hex": "#C9C5C8",
    "name": "Sterling Silver ",
    "code": "1687"
  },
  "1689": {
    "hex": "#655D60",
    "name": "Shark Gray ",
    "code": "1689"
  },
  "1690": {
    "hex": "#29333C",
    "name": "Deep Sea",
    "code": "1690"
  },
  "1692": {
    "hex": "#A9C1C8",
    "name": "Limestone",
    "code": "1692"
  },
  "1694": {
    "hex": "#2C8BAA",
    "name": "Caribbean Blue",
    "code": "1694"
  },
  "1695": {
    "hex": "#295D8F",
    "name": "Cyan Blue ",
    "code": "1695"
  },
  "1701": {
    "hex": "#2F8E38",
    "name": "Spring Green",
    "code": "1701"
  },
  "1702": {
    "hex": "#95C6A1",
    "name": "Spearmint Green",
    "code": "1702"
  },
  "1703": {
    "hex": "#29332E",
    "name": "Fir Green",
    "code": "1703"
  },
  "1704": {
    "hex": "#303536",
    "name": "Evergreen ",
    "code": "1704"
  },
  "1705": {
    "hex": "#313D2F",
    "name": " Fresh Oregano Green",
    "code": "1705"
  },
  "1706": {
    "hex": "#85823E",
    "name": "Guacamole Green",
    "code": "1706"
  },
  "1707": {
    "hex": "#DF5861",
    "name": "Honeysuckle Pink",
    "code": "1707"
  },
  "1709": {
    "hex": "#A42973",
    "name": "Shocking Pink",
    "code": "1709"
  },
  "1710": {
    "hex": "#6A2949",
    "name": "Magenta",
    "code": "1710"
  },
  "1711": {
    "hex": "#B68EC8",
    "name": "Lavender",
    "code": "1711"
  },
  "1712": {
    "hex": "#956391",
    "name": " Lilac Purple ",
    "code": "1712"
  },
  "1713": {
    "hex": "#FEE1E2",
    "name": "Peach Blush",
    "code": "1713"
  },
  "1718": {
    "hex": "#ADB2BF",
    "name": "Overcast Gray ",
    "code": "1718"
  },
  "1719": {
    "hex": "#6A1565",
    "name": "Chokecherry",
    "code": "1719"
  },
  "1720": {
    "hex": "#664461",
    "name": "Plum",
    "code": "1720"
  },
  "1721": {
    "hex": "#D43C6E",
    "name": "Flamingo Pink",
    "code": "1721"
  },
  "1722": {
    "hex": "#322C70",
    "name": "Royal Purple ",
    "code": "1722"
  },
  "1723": {
    "hex": "#EBCA9E",
    "name": "Flan Brown Orange",
    "code": "1723"
  },
  "1724": {
    "hex": "#CDA840",
    "name": "Gold Nugget",
    "code": "1724"
  },
  "1725": {
    "hex": "#C48838",
    "name": "Liquid Gold",
    "code": "1725"
  },
  "1726": {
    "hex": "#946441",
    "name": "Light Brown Sugar ",
    "code": "1726"
  },
  "1727": {
    "hex": "#F8E47A",
    "name": "Baby Chick",
    "code": "1727"
  },
  "1728": {
    "hex": "#806659",
    "name": "Bark Brown ",
    "code": "1728"
  },
  "1729": {
    "hex": "#876D60",
    "name": "Buckskin Brown",
    "code": "1729"
  },
  "1730": {
    "hex": "#5B432D",
    "name": "Cumin Brown ",
    "code": "1730"
  },
  "1731": {
    "hex": "#A38CA0",
    "name": "Purple Pearl",
    "code": "1731"
  },
  "1733": {
    "hex": "#3866A2",
    "name": "Blue Jay",
    "code": "1733"
  },
  "1734": {
    "hex": "#AF2929",
    "name": "Electric Red ",
    "code": "1734"
  },
  "1735": {
    "hex": "#EECE4E",
    "name": " Lemonade",
    "code": "1735"
  },
  "1736": {
    "hex": "#837573",
    "name": "Dark Taupe Brown ",
    "code": "1736"
  },
  "1738": {
    "hex": "#CFC0A4",
    "name": "Champagne Beige",
    "code": "1738"
  },
  "1739": {
    "hex": "#363237",
    "name": "Charcoal Gray",
    "code": "1739"
  },
  "1740": {
    "hex": "#6D6672",
    "name": "Weimaraner Blue Gray ",
    "code": "1740"
  },
  "1741": {
    "hex": "#6C6668",
    "name": "Gun Metal ",
    "code": "1741"
  },
  "1742": {
    "hex": "#292A3E",
    "name": " Blue Ink ",
    "code": "1742"
  },
  "1743": {
    "hex": "#29293C",
    "name": "Oxford Blue ",
    "code": "1743"
  },
  "1744": {
    "hex": "#675D51",
    "name": "Siamese Cat Brown",
    "code": "1744"
  },
  "1745": {
    "hex": "#5F4A41",
    "name": "Toasted Marshmallow Brown",
    "code": "1745"
  },
  "1746": {
    "hex": "#2F8C9A",
    "name": "Teal Green ",
    "code": "1746"
  },
  "1747": {
    "hex": "#902A2C",
    "name": "Candy Apple Red ",
    "code": "1747"
  },
  "1748": {
    "hex": "#C5E18D",
    "name": "Margarita Lime",
    "code": "1748"
  },
  "1749": {
    "hex": "#2E883D",
    "name": "Green Thumb",
    "code": "1749"
  },
  "1750": {
    "hex": "#294B3D",
    "name": "Christmas Green",
    "code": "1750"
  },
  "1751": {
    "hex": "#294F38",
    "name": "Emerald Isle Green",
    "code": "1751"
  },
  "1752": {
    "hex": "#FEBA8F",
    "name": "Cantalope",
    "code": "1752"
  },
  "1753": {
    "hex": "#C07F55",
    "name": "Penny Brown Orange",
    "code": "1753"
  },
  "1754": {
    "hex": "#C12E31",
    "name": "Raspberry Punch Red ",
    "code": "1754"
  },
  "1755": {
    "hex": "#F19D3E",
    "name": "Marmalade Brown Orange",
    "code": "1755"
  },
  "1756": {
    "hex": "#4F5528",
    "name": "Pea Green",
    "code": "1756"
  },
  "1757": {
    "hex": "#493E2C",
    "name": "Dark Olive",
    "code": "1757"
  },
  "1758": {
    "hex": "#4A322A",
    "name": " Grizzly Bear Brown",
    "code": "1758"
  },
  "1759": {
    "hex": "#8d750b",
    "name": "Camo Green Brown",
    "code": "1759"
  },
  "1760": {
    "hex": "#495B71",
    "name": "Antique Blue ",
    "code": "1760"
  },
  "1761": {
    "hex": "#889CB5",
    "name": "Dolphin",
    "code": "1761"
  },
  "1762": {
    "hex": "#29344F",
    "name": " Deep Ocean Blue",
    "code": "1762"
  },
  "1763": {
    "hex": "#CD7533",
    "name": "Copper Brown Orange ",
    "code": "1763"
  },
  "1764": {
    "hex": "#33425E",
    "name": "Denim Blue",
    "code": "1764"
  },
  "1765": {
    "hex": "#D57843",
    "name": "Tiger Orange ",
    "code": "1765"
  },
  "1766": {
    "hex": "#292958",
    "name": "Sailor Blue",
    "code": "1766"
  },
  "1767": {
    "hex": "#292955",
    "name": "Ultramarine Blue",
    "code": "1767"
  },
  "1768": {
    "hex": "#AAB682",
    "name": "Bamboo Green ",
    "code": "1768"
  },
  "1769": {
    "hex": "#49622E",
    "name": "Clover Green ",
    "code": "1769"
  },
  "1770": {
    "hex": "#405938",
    "name": "Light Emerald Green ",
    "code": "1770"
  },
  "1771": {
    "hex": "#DCAA40",
    "name": "Whipped Butterscotch",
    "code": "1771"
  },
  "1772": {
    "hex": "#CC943A",
    "name": "Military Gold",
    "code": "1772"
  },
  "1773": {
    "hex": "#8F4F2B",
    "name": "Autumn Gold Brown",
    "code": "1773"
  },
  "1775": {
    "hex": "#456D98",
    "name": "Dark Federal Blue ",
    "code": "1775"
  },
  "1776": {
    "hex": "#2C4D7B",
    "name": "Independence Blue ",
    "code": "1776"
  },
  "1777": {
    "hex": "#E17F6C",
    "name": "Bright Peach ",
    "code": "1777"
  },
  "1778": {
    "hex": "#CA452B",
    "name": "Carrot Orange",
    "code": "1778"
  },
  "1779": {
    "hex": "#AD4331",
    "name": "Sweet Potato ",
    "code": "1779"
  },
  "1780": {
    "hex": "#294A4A",
    "name": "Rainforest Green ",
    "code": "1780"
  },
  "1781": {
    "hex": "#77292C",
    "name": "Radish ",
    "code": "1781"
  },
  "1782": {
    "hex": "#692A31",
    "name": "Mulberry ",
    "code": "1782"
  },
  "1783": {
    "hex": "#5A2939",
    "name": " Dark Raspberry Pink ",
    "code": "1783"
  },
  "1784": {
    "hex": "#442929",
    "name": "Merlot Red ",
    "code": "1784"
  },
  "1785": {
    "hex": "#6A3D4D",
    "name": "Bordeaux",
    "code": "1785"
  },
  "1786": {
    "hex": "#882936",
    "name": "Hibiscus Pink ",
    "code": "1786"
  },
  "1787": {
    "hex": "#AD4472",
    "name": "Fuchsia",
    "code": "1787"
  },
  "1788": {
    "hex": "#522949",
    "name": "Dark Magenta",
    "code": "1788"
  },
  "1789": {
    "hex": "#674B60",
    "name": "Plum Drop",
    "code": "1789"
  },
  "1790": {
    "hex": "#64592D",
    "name": "Dill Pickle Green",
    "code": "1790"
  },
  "1791": {
    "hex": "#A16D36",
    "name": "Brass Brown",
    "code": "1791"
  },
  "1792": {
    "hex": "#977132",
    "name": "Old Gold",
    "code": "1792"
  },
  "1793": {
    "hex": "#7C6D3C",
    "name": "Bullfrog",
    "code": "1793"
  },
  "1794": {
    "hex": "#413C2C",
    "name": "Field Gear Green ",
    "code": "1794"
  },
  "1795": {
    "hex": "#35332A",
    "name": "Field Gear Green ",
    "code": "1795"
  },
  "1796": {
    "hex": "#68663D",
    "name": "Aged Moss",
    "code": "1796"
  },
  "1797": {
    "hex": "#2960A4",
    "name": "Calypso Blue",
    "code": "1797"
  },
  "1798": {
    "hex": "#31302D",
    "name": "Bass Green",
    "code": "1798"
  },
  "1799": {
    "hex": "#31AAAA",
    "name": "Green Turquoise",
    "code": "1799"
  },
  "1800": {
    "hex": "#26282A",
    "name": "Emerald Black",
    "code": "1800"
  },
  "1801": {
    "hex": "#F8F8F8",
    "name": "Super White",
    "code": "1801"
  },
  "1802": {
    "hex": "#F1F5FF",
    "name": "Snow White",
    "code": "1802"
  },
  "1803": {
    "hex": "#F2F1F0",
    "name": "Cream White",
    "code": "1803"
  },
  "1804": {
    "hex": "#FFFFF9",
    "name": "Natural White",
    "code": "1804"
  },
  "1805": {
    "hex": "#DBE3FF",
    "name": "Fluorescent White",
    "code": "1805"
  },
  "1809": {
    "hex": "#B3A449",
    "name": "Brushed Bronze Yellow Green",
    "code": "1809"
  },
  "1810": {
    "hex": "#A8A6AC",
    "name": "Gray Haze",
    "code": "1810"
  },
  "1811": {
    "hex": "#AAA9B4",
    "name": " Chrome",
    "code": "1811"
  },
  "1812": {
    "hex": "#A49EA0",
    "name": "Cement Gray",
    "code": "1812"
  },
  "1815": {
    "hex": "#F3BFCC",
    "name": " Baby Pink",
    "code": "1815"
  },
  "1816": {
    "hex": "#F9BEC5",
    "name": "Rustic Pink",
    "code": "1816"
  },
  "1817": {
    "hex": "#EFAB95",
    "name": "Pleasant Peach",
    "code": "1817"
  },
  "1818": {
    "hex": "#EED1CD",
    "name": "Powder Pink",
    "code": "1818"
  },
  "1819": {
    "hex": "#FFB2AC",
    "name": "Blush Pink",
    "code": "1819"
  },
  "1820": {
    "hex": "#ED9E82",
    "name": "Peach Tea Pink",
    "code": "1820"
  },
  "1821": {
    "hex": "#8A2929",
    "name": "Terra Cotta Red",
    "code": "1821"
  },
  "1822": {
    "hex": "#E2D7CA",
    "name": "Coconut Cream Yellow",
    "code": "1822"
  },
  "1823": {
    "hex": "#F3F452",
    "name": "Fluorescent Yellow Green",
    "code": "1823"
  },
  "1824": {
    "hex": "#FFD91F",
    "name": "",
    "code": "1824"
  },
  "1825": {
    "hex": "#F0BE44",
    "name": "Summer Sun",
    "code": "1825"
  },
  "1826": {
    "hex": "#FFC170",
    "name": "Peach Pie",
    "code": "1826"
  },
  "1827": {
    "hex": "#54AAD1",
    "name": "Swimming Pool Blue",
    "code": "1827"
  },
  "1828": {
    "hex": "#336599",
    "name": "Work Shirt Blue ",
    "code": "1828"
  },
  "1829": {
    "hex": "#2A4B90",
    "name": "Blue Bird ",
    "code": "1829"
  },
  "1830": {
    "hex": "#7183BF",
    "name": "China Blue ",
    "code": "1830"
  },
  "1831": {
    "hex": "#8B548E",
    "name": "Purple Pansy ",
    "code": "1831"
  },
  "1832": {
    "hex": "#563E83",
    "name": "Majestic Purple ",
    "code": "1832"
  },
  "1833": {
    "hex": "#4E294F",
    "name": " Heliotrope ",
    "code": "1833"
  },
  "1834": {
    "hex": "#B289BD",
    "name": "Amethyst",
    "code": "1834"
  },
  "1835": {
    "hex": "#59292D",
    "name": "Cranberry Red ",
    "code": "1835"
  },
  "1836": {
    "hex": "#3C3030",
    "name": "Cappuccino Brown",
    "code": "1836"
  },
  "1837": {
    "hex": "#FB572C",
    "name": "Fluorescent Red Orange",
    "code": "1837"
  },
  "1838": {
    "hex": "#772929",
    "name": "Brick Red ",
    "code": "1838"
  },
  "1839": {
    "hex": "#65362F",
    "name": "Christmas Red",
    "code": "1839"
  },
  "1840": {
    "hex": "#626573",
    "name": "Cadet Gray",
    "code": "1840"
  },
  "1841": {
    "hex": "#3F414D",
    "name": "Pewter Gray ",
    "code": "1841"
  },
  "1842": {
    "hex": "#29377B",
    "name": "True Blue ",
    "code": "1842"
  },
  "1843": {
    "hex": "#292A55",
    "name": "Persian Blue",
    "code": "1843"
  },
  "1844": {
    "hex": "#2D3274",
    "name": "Indigo",
    "code": "1844"
  },
  "1845": {
    "hex": "#76BFAA",
    "name": "Mint",
    "code": "1845"
  },
  "1846": {
    "hex": "#2A7083",
    "name": "Dark Teal ",
    "code": "1846"
  },
  "1847": {
    "hex": "#389A93",
    "name": "Sea Foam Green",
    "code": "1847"
  },
  "1848": {
    "hex": "#679854",
    "name": "Lime Green ",
    "code": "1848"
  },
  "1849": {
    "hex": "#376B6B",
    "name": "Tropical Teal ",
    "code": "1849"
  },
  "1850": {
    "hex": "#3CC748",
    "name": "Fluorescent Green",
    "code": "1850"
  },
  "1851": {
    "hex": "#293E2F",
    "name": "Cadmium Green",
    "code": "1851"
  },
  "1852": {
    "hex": "#457194",
    "name": "Cobalt Blue",
    "code": "1852"
  },
  "1853": {
    "hex": "#E5BD9A",
    "name": "Light Apricot Orange",
    "code": "1853"
  },
  "1854": {
    "hex": "#957C7A",
    "name": "Rain Barrel Brown",
    "code": "1854"
  },
  "1855": {
    "hex": "#A78365",
    "name": "Coffee with Cream",
    "code": "1855"
  },
  "1856": {
    "hex": "#783629",
    "name": "Burnt Orange",
    "code": "1856"
  },
  "1857": {
    "hex": "#784F34",
    "name": "Chocolate Lab Brown",
    "code": "1857"
  },
  "1858": {
    "hex": "#442929",
    "name": "Chestnut ",
    "code": "1858"
  },
  "1859": {
    "hex": "#332B2D",
    "name": "Dark Chocolate Brown",
    "code": "1859"
  },
  "1860": {
    "hex": "#ADA09C",
    "name": "Pussy Willow Brown Gray ",
    "code": "1860"
  },
  "1861": {
    "hex": "#EED480",
    "name": "Palomino",
    "code": "1861"
  },
  "1862": {
    "hex": "#90867B",
    "name": "Rhino Brown Gray",
    "code": "1862"
  },
  "1863": {
    "hex": "#DED6C0",
    "name": "Chamois Beige",
    "code": "1863"
  },
  "1866": {
    "hex": "#EEDD93",
    "name": "Buff",
    "code": "1866"
  },
  "1867": {
    "hex": "#E2F597",
    "name": "Fluorescent Green",
    "code": "1867"
  },
  "1868": {
    "hex": "#2B7A69",
    "name": "Bottle Green",
    "code": "1868"
  },
  "1869": {
    "hex": "#D68638",
    "name": "Pumpkin Spice",
    "code": "1869"
  },
  "1870": {
    "hex": "#DD964C",
    "name": " Orange Sorbet ",
    "code": "1870"
  },
  "1871": {
    "hex": "#97B7CD",
    "name": "Porcelain Blue ",
    "code": "1871"
  },
  "1872": {
    "hex": "#443530",
    "name": "Brunette Brown",
    "code": "1872"
  },
  "1874": {
    "hex": "#99AED7",
    "name": " Baby Blue ",
    "code": "1874"
  },
  "1878": {
    "hex": "#C14533",
    "name": "Tomato Red",
    "code": "1878"
  },
  "1879": {
    "hex": "#294F53",
    "name": "Oregon Green ",
    "code": "1879"
  },
  "1880": {
    "hex": "#562963",
    "name": "Deep Lilac Purple",
    "code": "1880"
  },
  "1882": {
    "hex": "#F0C6AD",
    "name": "Peach Blossom ",
    "code": "1882"
  },
  "1883": {
    "hex": "#FFE91F",
    "name": "",
    "code": "1883"
  },
  "1884": {
    "hex": "#E6D0AB",
    "name": "Burly Wood Beige",
    "code": "1884"
  },
  "1885": {
    "hex": "#8F6F57",
    "name": "Camel Brown ",
    "code": "1885"
  },
  "1886": {
    "hex": "#B9B6B8",
    "name": "Light Steel Gray",
    "code": "1886"
  },
  "1887": {
    "hex": "#4F3E45",
    "name": "Mince Pie",
    "code": "1887"
  },
  "1888": {
    "hex": "#2B7F97",
    "name": " Deep Sky Blue",
    "code": "1888"
  },
  "1890": {
    "hex": "#296680",
    "name": "Midnight Green",
    "code": "1890"
  },
  "1891": {
    "hex": "#20626A",
    "name": "Teal Velvet",
    "code": "1891"
  },
  "1892": {
    "hex": "#79BBCB",
    "name": "Robins Egg Blue ",
    "code": "1892"
  },
  "1893": {
    "hex": "#389BC6",
    "name": "Blue Sky",
    "code": "1893"
  },
  "1895": {
    "hex": "#2979A4",
    "name": "Teal Blue",
    "code": "1895"
  },
  "1896": {
    "hex": "#29507B",
    "name": "Liberty Blue",
    "code": "1896"
  },
  "1898": {
    "hex": "#6B2D29",
    "name": "Auburn Brown Orange ",
    "code": "1898"
  },
  "1899": {
    "hex": "#662929",
    "name": "Henna ",
    "code": "1899"
  },
  "1900": {
    "hex": "#C7E1BE",
    "name": "Celadon Green ",
    "code": "1900"
  },
  "1901": {
    "hex": "#32A03E",
    "name": "Fluorescent Green",
    "code": "1901"
  },
  "1902": {
    "hex": "#292E2C",
    "name": " Hunter Green",
    "code": "1902"
  },
  "1903": {
    "hex": "#353E3E",
    "name": "Spruce Green ",
    "code": "1903"
  },
  "1904": {
    "hex": "#333B37",
    "name": "Dark Sage",
    "code": "1904"
  },
  "1905": {
    "hex": "#485641",
    "name": "Moss Green",
    "code": "1905"
  },
  "1906": {
    "hex": "#493A2F",
    "name": "Antique Bronze Brown",
    "code": "1906"
  },
  "1907": {
    "hex": "#FF4A5D",
    "name": "",
    "code": "1907"
  },
  "1908": {
    "hex": "#F92929",
    "name": "Fluorescent Pink ",
    "code": "1908"
  },
  "1909": {
    "hex": "#F56476",
    "name": "Electric Pink ",
    "code": "1909"
  },
  "1910": {
    "hex": "#AD2933",
    "name": "Electric Magenta",
    "code": "1910"
  },
  "1911": {
    "hex": "#CEB8D3",
    "name": "Evening Mist",
    "code": "1911"
  },
  "1915": {
    "hex": "#F4B4B5",
    "name": "Bermuda Sand Pink",
    "code": "1915"
  },
  "1917": {
    "hex": "#CE8494",
    "name": "Dusty Rose",
    "code": "1917"
  },
  "1918": {
    "hex": "#9EA0A3",
    "name": "Polished Pewter ",
    "code": "1918"
  },
  "1919": {
    "hex": "#8C4352",
    "name": "English Rose",
    "code": "1919"
  },
  "1920": {
    "hex": "#CCC28D",
    "name": "Light Khaki ",
    "code": "1920"
  },
  "1921": {
    "hex": "#E885A7",
    "name": "Pink Bubblegum",
    "code": "1921"
  },
  "1922": {
    "hex": "#2E294F",
    "name": "Regal Purple",
    "code": "1922"
  },
  "1923": {
    "hex": "#FFAA3D",
    "name": "Apricot",
    "code": "1923"
  },
  "1924": {
    "hex": "#F2DD4C",
    "name": "Lemon Tart",
    "code": "1924"
  },
  "1925": {
    "hex": "#FFBD1F",
    "name": "",
    "code": "1925"
  },
  "1926": {
    "hex": "#A17660",
    "name": "Dark Champagne Brown Beige",
    "code": "1926"
  },
  "1927": {
    "hex": "#D3AD80",
    "name": "Shiny Penny Beige",
    "code": "1927"
  },
  "1928": {
    "hex": "#8E8370",
    "name": "Natural Suede",
    "code": "1928"
  },
  "1929": {
    "hex": "#70695F",
    "name": "Brown Hare",
    "code": "1929"
  },
  "1930": {
    "hex": "#373B82",
    "name": "Bahamas Blue ",
    "code": "1930"
  },
  "1931": {
    "hex": "#464545",
    "name": "Bittersweet Chocolate",
    "code": "1931"
  },
  "1932": {
    "hex": "#8CBEDB",
    "name": "Summer Sky",
    "code": "1932"
  },
  "1933": {
    "hex": "#7770A7",
    "name": "Lavender Lilac ",
    "code": "1933"
  },
  "1934": {
    "hex": "#293A79",
    "name": " Royal Blue",
    "code": "1934"
  },
  "1935": {
    "hex": "#E9F552",
    "name": "Fluorescent Yellow Green ",
    "code": "1935"
  },
  "1936": {
    "hex": "#625555",
    "name": "Mink Brown",
    "code": "1936"
  },
  "1937": {
    "hex": "#FCA53E",
    "name": "Fluorescent Orange ",
    "code": "1937"
  },
  "1938": {
    "hex": "#BBA89E",
    "name": "Doe Skin Beige",
    "code": "1938"
  },
  "1939": {
    "hex": "#8F7955",
    "name": "Peanut Brittle Gold",
    "code": "1939"
  },
  "1940": {
    "hex": "#C9CE49",
    "name": "Key Lime Green",
    "code": "1940"
  },
  "1941": {
    "hex": "#C09A9A",
    "name": "Mauve",
    "code": "1941"
  },
  "1942": {
    "hex": "#8D615A",
    "name": "Rose Gold",
    "code": "1942"
  },
  "1943": {
    "hex": "#565EA2",
    "name": "Dark Periwinkle ",
    "code": "1943"
  },
  "1944": {
    "hex": "#30303D",
    "name": "Blueberry Smash",
    "code": "1944"
  },
  "1945": {
    "hex": "#4A332C",
    "name": "Sienna Brown",
    "code": "1945"
  },
  "1946": {
    "hex": "#FB8036",
    "name": "Fluorescent Orange",
    "code": "1946"
  },
  "1947": {
    "hex": "#FF483D",
    "name": "",
    "code": "1947"
  },
  "1948": {
    "hex": "#EFA1A7",
    "name": "Pink Carnation",
    "code": "1948"
  },
  "1949": {
    "hex": "#F6EEE8",
    "name": "Ivory Beige",
    "code": "1949"
  },
  "1950": {
    "hex": "#88E54F",
    "name": "Fluorescent Green",
    "code": "1950"
  },
  "1951": {
    "hex": "#EEA940",
    "name": "Pumpkin Chiffon",
    "code": "1951"
  },
  "1952": {
    "hex": "#E8773B",
    "name": "Melon Burst ",
    "code": "1952"
  },
  "1953": {
    "hex": "#CDE0F7",
    "name": "Powder Blue",
    "code": "1953"
  },
  "1954": {
    "hex": "#FF3A3B",
    "name": "",
    "code": "1954"
  },
  "1955": {
    "hex": "#DF8637",
    "name": "Citrus Burst Gold",
    "code": "1955"
  },
  "1956": {
    "hex": "#837B4E",
    "name": "Olive Green",
    "code": "1956"
  },
  "1957": {
    "hex": "#332B29",
    "name": "Burnt Taupe Brown",
    "code": "1957"
  },
  "1958": {
    "hex": "#483031",
    "name": "Cedar Bark Brown ",
    "code": "1958"
  },
  "1959": {
    "hex": "#BFAA13",
    "name": "Burnished Gold",
    "code": "1959"
  },
  "1960": {
    "hex": "#9FB4C4",
    "name": "Dusty Blue",
    "code": "1960"
  },
  "1961": {
    "hex": "#4F5B7C",
    "name": "Blue Spruce",
    "code": "1961"
  },
  "1962": {
    "hex": "#292E3E",
    "name": "Admiral Blue",
    "code": "1962"
  },
  "1963": {
    "hex": "#515E72",
    "name": "Dusty Plum",
    "code": "1963"
  },
  "1964": {
    "hex": "#474E6A",
    "name": "Stormy Sky Blue ",
    "code": "1964"
  },
  "1965": {
    "hex": "#D3512B",
    "name": "Orange Peal ",
    "code": "1965"
  },
  "1966": {
    "hex": "#29293D",
    "name": "Pea Coat Blue ",
    "code": "1966"
  },
  "1967": {
    "hex": "#292939",
    "name": "Dark Denim ",
    "code": "1967"
  },
  "1968": {
    "hex": "#659056",
    "name": "Green Tea ",
    "code": "1968"
  },
  "1969": {
    "hex": "#535044",
    "name": "Army Green",
    "code": "1969"
  },
  "1970": {
    "hex": "#334235",
    "name": " Emerald Green",
    "code": "1970"
  },
  "1971": {
    "hex": "#F6C648",
    "name": "Saffron Yellow",
    "code": "1971"
  },
  "1972": {
    "hex": "#FFC11F",
    "name": "",
    "code": "1972"
  },
  "1973": {
    "hex": "#77492B",
    "name": "Bronze Brown",
    "code": "1973"
  },
  "1974": {
    "hex": "#682D2F",
    "name": "Cinnamon Stick Red",
    "code": "1974"
  },
  "1975": {
    "hex": "#29345B",
    "name": "Colonial Blue",
    "code": "1975"
  },
  "1976": {
    "hex": "#29292F",
    "name": "Night Sky ",
    "code": "1976"
  },
  "1977": {
    "hex": "#2966AA",
    "name": "Peacock Blue",
    "code": "1977"
  },
  "1978": {
    "hex": "#FB933A",
    "name": "Fluorescent Orange",
    "code": "1978"
  },
  "1979": {
    "hex": "#293C35",
    "name": "Dark Amazon Green",
    "code": "1979"
  },
  "1980": {
    "hex": "#ECC547",
    "name": "Sunflower",
    "code": "1980"
  },
  "1981": {
    "hex": "#61292A",
    "name": "Carmine Red ",
    "code": "1981"
  },
  "1982": {
    "hex": "#80001F",
    "name": "Sangria",
    "code": "1982"
  },
  "1983": {
    "hex": "#5A4050",
    "name": "Eggplant Purple",
    "code": "1983"
  },
  "1984": {
    "hex": "#822933",
    "name": "Orchid Pink",
    "code": "1984"
  },
  "1985": {
    "hex": "#294246",
    "name": "Deep Rain Forest ",
    "code": "1985"
  },
  "1986": {
    "hex": "#AC3A51",
    "name": "Ripe Raspberry",
    "code": "1986"
  },
  "1987": {
    "hex": "#B02929",
    "name": "Paprika Red",
    "code": "1987"
  },
  "1988": {
    "hex": "#2B6D3E",
    "name": "Kelly Green ",
    "code": "1988"
  },
  "1989": {
    "hex": "#2B7B56",
    "name": "Leaf Green ",
    "code": "1989"
  },
  "1990": {
    "hex": "#CF7DA4",
    "name": "Pink Rose ",
    "code": "1990"
  },
  "1991": {
    "hex": "#295671",
    "name": "Malachite ",
    "code": "1991"
  },
  "1992": {
    "hex": "#294468",
    "name": "Rough Caribbean Sea ",
    "code": "1992"
  },
  "1993": {
    "hex": "#C62A3E",
    "name": " Watermelon Red",
    "code": "1993"
  },
  "1994": {
    "hex": "#E65A73",
    "name": "Lipstick Rose",
    "code": "1994"
  },
  "1995": {
    "hex": "#FFFB1F",
    "name": "",
    "code": "1995"
  },
  "1996": {
    "hex": "#3A4D4A",
    "name": "Deep Emerald",
    "code": "1996"
  },
  "1997": {
    "hex": "#413D46",
    "name": "Plum Pudding",
    "code": "1997"
  },
  "1998": {
    "hex": "#674B55",
    "name": "Dark Mauve ",
    "code": "1998"
  },
  "1999": {
    "hex": "#44292C",
    "name": "Red Brown ",
    "code": "1999"
  },
  "2201": {
    "hex": "#C79E29",
    "name": "Old Gold",
    "code": "2201"
  },
  "2202": {
    "hex": "#879E91",
    "name": "Olive",
    "code": "2202"
  },
  "2203": {
    "hex": "#E5C7A7",
    "name": "Gold",
    "code": "2203"
  },
  "2204": {
    "hex": "#8EDBDF",
    "name": "Turquoise",
    "code": "2204"
  },
  "2205": {
    "hex": "#C85042",
    "name": "Dark Rust",
    "code": "2205"
  },
  "2206": {
    "hex": "#A5C2E1",
    "name": "Baby Blue",
    "code": "2206"
  },
  "2207": {
    "hex": "#E1CDCB",
    "name": "Gray",
    "code": "2207"
  },
  "2208": {
    "hex": "#1F9566",
    "name": "Dark Green",
    "code": "2208"
  },
  "2209": {
    "hex": "#528742",
    "name": "Green",
    "code": "2209"
  },
  "2210": {
    "hex": "#393787",
    "name": "Royal",
    "code": "2210"
  },
  "2211": {
    "hex": "#ABDF9C",
    "name": "Nile",
    "code": "2211"
  },
  "2212": {
    "hex": "#E4B827",
    "name": "Sun Gold",
    "code": "2212"
  },
  "2213": {
    "hex": "#FCAE2E",
    "name": "Yellow",
    "code": "2213"
  },
  "2214": {
    "hex": "#4BAA4D",
    "name": "Emerald",
    "code": "2214"
  },
  "2215": {
    "hex": "#303C54",
    "name": "Navy",
    "code": "2215"
  },
  "2216": {
    "hex": "#FFD25F",
    "name": "Marigold",
    "code": "2216"
  },
  "2217": {
    "hex": "#7A7876",
    "name": "Twilight",
    "code": "2217"
  },
  "2218": {
    "hex": "#FA7D25",
    "name": "Orange",
    "code": "2218"
  },
  "2219": {
    "hex": "#DD2652",
    "name": "Scarlet",
    "code": "2219"
  },
  "2220": {
    "hex": "#464B9C",
    "name": "Blue",
    "code": "2220"
  },
  "2221": {
    "hex": "#AAB4A5",
    "name": "Willow",
    "code": "2221"
  },
  "2222": {
    "hex": "#CFEBE1",
    "name": "Light Blue",
    "code": "2222"
  },
  "2223": {
    "hex": "#FCC7CF",
    "name": "Pink",
    "code": "2223"
  },
  "2224": {
    "hex": "#B48656",
    "name": "Beige",
    "code": "2224"
  },
  "2225": {
    "hex": "#87464D",
    "name": "Wine",
    "code": "2225"
  },
  "2226": {
    "hex": "#6A9C30",
    "name": "Meadow",
    "code": "2226"
  },
  "2227": {
    "hex": "#957342",
    "name": "Chocolate",
    "code": "2227"
  },
  "2228": {
    "hex": "#E86A7F",
    "name": "Begonia",
    "code": "2228"
  },
  "2229": {
    "hex": "#6A7630",
    "name": "Palmetto",
    "code": "2229"
  },
  "2230": {
    "hex": "#A0A523",
    "name": "Tamarack",
    "code": "2230"
  },
  "2231": {
    "hex": "#C28649",
    "name": "Toast",
    "code": "2231"
  },
  "2232": {
    "hex": "#EFD8C4",
    "name": "Ecru",
    "code": "2232"
  },
  "2233": {
    "hex": "#C72749",
    "name": "Lipstick",
    "code": "2233"
  },
  "2234": {
    "hex": "#FFDD8E",
    "name": "Glow",
    "code": "2234"
  },
  "2235": {
    "hex": "#FCE432",
    "name": "Canary Yellow",
    "code": "2235"
  },
  "2236": {
    "hex": "#ERROR!",
    "name": "Paprika",
    "code": "2236"
  },
  "2237": {
    "hex": "#ERROR!",
    "name": "Carnation",
    "code": "2237"
  },
  "2238": {
    "hex": "#B4EDC5",
    "name": "Mint",
    "code": "2238"
  },
  "2239": {
    "hex": "#A7CBE5",
    "name": "Sky Blue",
    "code": "2239"
  },
  "2240": {
    "hex": "#1F8A54",
    "name": "Kelly",
    "code": "2240"
  },
  "2241": {
    "hex": "#C4C8BB",
    "name": "Palm Leaf",
    "code": "2241"
  },
  "2242": {
    "hex": "#FCD732",
    "name": "Goldenrod",
    "code": "2242"
  },
  "2243": {
    "hex": "#F1D2D4",
    "name": "Light Pink",
    "code": "2243"
  },
  "2244": {
    "hex": "#FC9AA5",
    "name": "Rose Cerise",
    "code": "2244"
  },
  "2245": {
    "hex": "#7F95B2",
    "name": "Copen",
    "code": "2245"
  },
  "2246": {
    "hex": "#E86A7F",
    "name": "Shrimp",
    "code": "2246"
  },
  "2247": {
    "hex": "#FCC271",
    "name": "Honey",
    "code": "2247"
  },
  "2248": {
    "hex": "#F55D7D",
    "name": "Bashful Pink",
    "code": "2248"
  },
  "2249": {
    "hex": "#9A404B",
    "name": "Burgundy",
    "code": "2249"
  },
  "2250": {
    "hex": "#D2CDA0",
    "name": "Pistachio",
    "code": "2250"
  },
  "2251": {
    "hex": "#6D5444",
    "name": "Brown",
    "code": "2251"
  },
  "2252": {
    "hex": "#8A4050",
    "name": "Russet",
    "code": "2252"
  },
  "2253": {
    "hex": "#FAC2B4",
    "name": "Flesh Pink",
    "code": "2253"
  },
  "2254": {
    "hex": "#9C5DB7",
    "name": "Puprle",
    "code": "2254"
  },
  "2255": {
    "hex": "#F8C7C7",
    "name": "Opal Mist",
    "code": "2255"
  },
  "2256": {
    "hex": "#FAC7AA",
    "name": "Tawny",
    "code": "2256"
  },
  "2257": {
    "hex": "#FACDB4",
    "name": "Peach",
    "code": "2257"
  },
  "2258": {
    "hex": "#FAB09A",
    "name": "Flamingo",
    "code": "2258"
  },
  "2259": {
    "hex": "#D41F8C",
    "name": "Wild Pink",
    "code": "2259"
  },
  "2260": {
    "hex": "#D87DAA",
    "name": "Hot Pink",
    "code": "2260"
  },
  "2261": {
    "hex": "#E54291",
    "name": "Ruby Glint",
    "code": "2261"
  },
  "2262": {
    "hex": "#ED2C7D",
    "name": "Cherry Blossom",
    "code": "2262"
  },
  "2263": {
    "hex": "#D42E40",
    "name": "Foxy Red",
    "code": "2263"
  },
  "2264": {
    "hex": "#F8EBB4",
    "name": "Maize",
    "code": "2264"
  },
  "2265": {
    "hex": "#878783",
    "name": "Charcoal",
    "code": "2265"
  },
  "2266": {
    "hex": "#CB3952",
    "name": "Radiant Red",
    "code": "2266"
  },
  "2267": {
    "hex": "#AE4050",
    "name": "Wildfire",
    "code": "2267"
  },
  "2268": {
    "hex": "#9A404B",
    "name": "Carolina Red",
    "code": "2268"
  },
  "2269": {
    "hex": "#B9C4DF",
    "name": "Sun Blue",
    "code": "2269"
  },
  "2270": {
    "hex": "#A53C4D",
    "name": "Cranberry",
    "code": "2270"
  },
  "2271": {
    "hex": "#E1CDCB",
    "name": "Heather",
    "code": "2271"
  },
  "2272": {
    "hex": "#D8C0AE",
    "name": "Grape",
    "code": "2272"
  },
  "2273": {
    "hex": "#D8B28C",
    "name": "Tan",
    "code": "2273"
  },
  "2274": {
    "hex": "#DDD2D7",
    "name": "Steel Gray",
    "code": "2274"
  },
  "2275": {
    "hex": "#7F95B2",
    "name": "Slate Blue",
    "code": "2275"
  },
  "2276": {
    "hex": "#F1CDD8",
    "name": "Lavender",
    "code": "2276"
  },
  "2277": {
    "hex": "#F55664",
    "name": "Persimmon",
    "code": "2277"
  },
  "2278": {
    "hex": "#8AB29E",
    "name": "Moss",
    "code": "2278"
  },
  "2279": {
    "hex": "#B4E17F",
    "name": "Spruce",
    "code": "2279"
  },
  "2280": {
    "hex": "#464B9C",
    "name": "Sapphire",
    "code": "2280"
  },
  "2281": {
    "hex": "#C72749",
    "name": "Jockey Red",
    "code": "2281"
  },
  "2282": {
    "hex": "#CDDBAB",
    "name": "Flite Green",
    "code": "2282"
  },
  "2283": {
    "hex": "#D7D4E1",
    "name": "Paris Blue",
    "code": "2283"
  },
  "2284": {
    "hex": "#1F7D56",
    "name": "Deep Green",
    "code": "2284"
  },
  "2285": {
    "hex": "#EFCBE1",
    "name": "Violet",
    "code": "2285"
  },
  "2286": {
    "hex": "#CFB7DD",
    "name": "Tulip",
    "code": "2286"
  },
  "2287": {
    "hex": "#9787C2",
    "name": "Mauve",
    "code": "2287"
  },
  "2288": {
    "hex": "#B983C8",
    "name": "Iris",
    "code": "2288"
  },
  "2289": {
    "hex": "#C46425",
    "name": "Rust",
    "code": "2289"
  },
  "2290": {
    "hex": "#A76435",
    "name": "Date",
    "code": "2290"
  },
  "2291": {
    "hex": "#D41F8C",
    "name": "Passion",
    "code": "2291"
  },
  "2292": {
    "hex": "#AA3D95",
    "name": "Plum",
    "code": "2292"
  },
  "2293": {
    "hex": "#FCA7BB",
    "name": "Rose",
    "code": "2293"
  },
  "2294": {
    "hex": "#FA9C7F",
    "name": "Melon",
    "code": "2294"
  },
  "2295": {
    "hex": "#B98623",
    "name": "Copper",
    "code": "2295"
  },
  "2296": {
    "hex": "#374049",
    "name": "Black",
    "code": "2296"
  },
  "2297": {
    "hex": "",
    "name": "Snow White",
    "code": "2297"
  },
  "2298": {
    "hex": "#D7C79E",
    "name": "Taupe",
    "code": "2298"
  },
  "2299": {
    "hex": "#EDBBBB",
    "name": "Salmon",
    "code": "2299"
  },
  "2300": {
    "hex": "#BED7EB",
    "name": "Ice Blue",
    "code": "2300"
  },
  "2301": {
    "hex": "#8E9AC7",
    "name": "Oriental Blue",
    "code": "2301"
  },
  "2302": {
    "hex": "#4B6A95",
    "name": "Imperial Blue",
    "code": "2302"
  },
  "2303": {
    "hex": "#2E3C66",
    "name": "Light Navy",
    "code": "2303"
  },
  "2304": {
    "hex": "#B9C4DF",
    "name": "Lake Blue",
    "code": "2304"
  },
  "2305": {
    "hex": "#A5DBE1",
    "name": "Blue Frost",
    "code": "2305"
  },
  "2306": {
    "hex": "#42CBDD",
    "name": "Periwinkle",
    "code": "2306"
  },
  "2307": {
    "hex": "#1FB7CD",
    "name": "Aquamarine",
    "code": "2307"
  },
  "2308": {
    "hex": "#71A5B4",
    "name": "Misty",
    "code": "2308"
  },
  "2309": {
    "hex": "#739E9E",
    "name": "Teal",
    "code": "2309"
  },
  "2310": {
    "hex": "#A0E1DF",
    "name": "Mint Julep",
    "code": "2310"
  },
  "2311": {
    "hex": "#81D4A7",
    "name": "Seafoam",
    "code": "2311"
  },
  "2312": {
    "hex": "#81D4A7",
    "name": "Isle Green",
    "code": "2312"
  },
  "2313": {
    "hex": "#BBDDDD",
    "name": "Sprite",
    "code": "2313"
  },
  "2314": {
    "hex": "#BEA0A7",
    "name": "Satin Wine",
    "code": "2314"
  },
  "2315": {
    "hex": "#26654C",
    "name": "Evergeen",
    "code": "2315"
  },
  "2316": {
    "hex": "#F4EDC4",
    "name": "Celery",
    "code": "2316"
  },
  "2317": {
    "hex": "#717852",
    "name": "Olive Drab",
    "code": "2317"
  },
  "2318": {
    "hex": "#CFEBE1",
    "name": "Pale Green",
    "code": "2318"
  },
  "2319": {
    "hex": "#BED29C",
    "name": "Green Oak",
    "code": "2319"
  },
  "2320": {
    "hex": "#9ADB1F",
    "name": "Erin Green",
    "code": "2320"
  },
  "2321": {
    "hex": "#8EC21F",
    "name": "Pastoral Green",
    "code": "2321"
  },
  "2322": {
    "hex": "#8EC21F",
    "name": "Ming",
    "code": "2322"
  },
  "2323": {
    "hex": "#3C6F4B",
    "name": "Holly",
    "code": "2323"
  },
  "2324": {
    "hex": "#F8EBB4",
    "name": "Chinese Yellow",
    "code": "2324"
  },
  "2325": {
    "hex": "#F5EF5D",
    "name": "Lemon",
    "code": "2325"
  },
  "2326": {
    "hex": "#FAEB30",
    "name": "Daffodil",
    "code": "2326"
  },
  "2327": {
    "hex": "#FAA729",
    "name": "Honeydew",
    "code": "2327"
  },
  "2328": {
    "hex": "#F88E1F",
    "name": "Pumpkin",
    "code": "2328"
  },
  "2329": {
    "hex": "#FA5640",
    "name": "Saffron",
    "code": "2329"
  },
  "2330": {
    "hex": "#FC955A",
    "name": "Golden Poppy",
    "code": "2330"
  },
  "2331": {
    "hex": "#E4B42C",
    "name": "Mustard",
    "code": "2331"
  },
  "2332": {
    "hex": "#F4C75F",
    "name": "Penny",
    "code": "2332"
  },
  "2333": {
    "hex": "#AE8E30",
    "name": "Ginger",
    "code": "2333"
  },
  "2334": {
    "hex": "#AB494B",
    "name": "Terra Cotta",
    "code": "2334"
  },
  "2335": {
    "hex": "#FFFFFF",
    "name": "Ivory",
    "code": "2335"
  },
  "2336": {
    "hex": "#DDBEA3",
    "name": "Amber Beige",
    "code": "2336"
  },
  "2337": {
    "hex": "#564944",
    "name": "Espresso",
    "code": "2337"
  },
  "2338": {
    "hex": "#C89C73",
    "name": "Bamboo",
    "code": "2338"
  },
  "2339": {
    "hex": "#6F4642",
    "name": "Coffee Bean",
    "code": "2339"
  },
  "2340": {
    "hex": "#DFD8D8",
    "name": "Pearl Gray",
    "code": "2340"
  },
  "2341": {
    "hex": "#525F83",
    "name": "Ash",
    "code": "2341"
  },
  "2342": {
    "hex": "",
    "name": "Natural White",
    "code": "2342"
  },
  "2343": {
    "hex": "",
    "name": "Eggshell",
    "code": "2343"
  },
  "2372": {
    "hex": "#755947",
    "name": "Dark Brown",
    "code": "2372"
  },
  "2373": {
    "hex": "#FABBC0",
    "name": "Pink Mist",
    "code": "2373"
  },
  "2374": {
    "hex": "#FAB9B7",
    "name": "Emily Pink",
    "code": "2374"
  },
  "2375": {
    "hex": "#F47A87",
    "name": "Dusty Rose",
    "code": "2375"
  },
  "2376": {
    "hex": "#643C52",
    "name": "Dark Maroon",
    "code": "2376"
  },
  "2377": {
    "hex": "#F4CBB9",
    "name": "Bisque",
    "code": "2377"
  },
  "2378": {
    "hex": "#C72749",
    "name": "Red Berry",
    "code": "2378"
  },
  "2379": {
    "hex": "#E8C7CD",
    "name": "Orchid",
    "code": "2379"
  },
  "2380": {
    "hex": "#782E7F",
    "name": "Mulberry",
    "code": "2380"
  },
  "2381": {
    "hex": "#613071",
    "name": "Dark Purple",
    "code": "2381"
  },
  "2382": {
    "hex": "#CDD7DB",
    "name": "Pastel Blue",
    "code": "2382"
  },
  "2383": {
    "hex": "#B0C2E4",
    "name": "Cristy Blue",
    "code": "2383"
  },
  "2384": {
    "hex": "#6F87D2",
    "name": "Jay Blue",
    "code": "2384"
  },
  "2385": {
    "hex": "#464B9C",
    "name": "Jamie Blue",
    "code": "2385"
  },
  "2386": {
    "hex": "#4D566F",
    "name": "Light Midnight",
    "code": "2386"
  },
  "2387": {
    "hex": "#303C54",
    "name": "Midnight Navy",
    "code": "2387"
  },
  "2388": {
    "hex": "#1F9CDB",
    "name": "Pacific Blue",
    "code": "2388"
  },
  "2389": {
    "hex": "#1FABCB",
    "name": "California Blue",
    "code": "2389"
  },
  "2390": {
    "hex": "#4DCBB9",
    "name": "Peppermint",
    "code": "2390"
  },
  "2391": {
    "hex": "#1F9A91",
    "name": "Pine Green",
    "code": "2391"
  },
  "2392": {
    "hex": "#647F71",
    "name": "Harbor Green",
    "code": "2392"
  },
  "2393": {
    "hex": "#A0E1DF",
    "name": "Sea Mist",
    "code": "2393"
  },
  "2394": {
    "hex": "#FCAE2E",
    "name": "Mango",
    "code": "2394"
  },
  "2395": {
    "hex": "#FFD25F",
    "name": "Cornsilk",
    "code": "2395"
  },
  "2396": {
    "hex": "#FFD25F",
    "name": "Brite Yellow",
    "code": "2396"
  },
  "2397": {
    "hex": "#F85F20",
    "name": "Sunkist",
    "code": "2397"
  },
  "2398": {
    "hex": "#FCD495",
    "name": "Visor Gold",
    "code": "2398"
  },
  "2399": {
    "hex": "#FCD495",
    "name": "New Gold",
    "code": "2399"
  },
  "2400": {
    "hex": "#C79E29",
    "name": "Topaz",
    "code": "2400"
  },
  "2401": {
    "hex": "#D79C69",
    "name": "Ashley Gold",
    "code": "2401"
  },
  "2402": {
    "hex": "#866940",
    "name": "Sienna",
    "code": "2402"
  },
  "2403": {
    "hex": "#FFFFFF",
    "name": "Oyster",
    "code": "2403"
  },
  "2404": {
    "hex": "#D2C8CD",
    "name": "Cinder",
    "code": "2404"
  },
  "2405": {
    "hex": "#D2C8CD",
    "name": "Dover Gray",
    "code": "2405"
  },
  "2406": {
    "hex": "#B2A0B7",
    "name": "Sterling",
    "code": "2406"
  },
  "2407": {
    "hex": "#787F81",
    "name": "Metal",
    "code": "2407"
  },
  "2408": {
    "hex": "#FCDD6A",
    "name": "Star Gold",
    "code": "2408"
  },
  "2409": {
    "hex": "#FCAE2E",
    "name": "Yellow Mist",
    "code": "2409"
  },
  "2410": {
    "hex": "#1F8A54",
    "name": "Light Kelly",
    "code": "2410"
  },
  "2411": {
    "hex": "#424640",
    "name": "D.H. Green",
    "code": "2411"
  },
  "2412": {
    "hex": "#FA939C",
    "name": "Azalea",
    "code": "2412"
  },
  "2413": {
    "hex": "#F5D2B4",
    "name": "Flesh",
    "code": "2413"
  },
  "2414": {
    "hex": "#FA9783",
    "name": "Coral",
    "code": "2414"
  },
  "2415": {
    "hex": "#EF83B4",
    "name": "Floral Pink",
    "code": "2415"
  },
  "2416": {
    "hex": "#DB2081",
    "name": "Crimson",
    "code": "2416"
  },
  "2417": {
    "hex": "#B41F64",
    "name": "Cherry Punch",
    "code": "2417"
  },
  "2418": {
    "hex": "#B93946",
    "name": "Red Berry",
    "code": "2418"
  },
  "2419": {
    "hex": "#C72749",
    "name": "Very Red",
    "code": "2419"
  },
  "2420": {
    "hex": "#DB4242",
    "name": "Tuxedo Red",
    "code": "2420"
  },
  "2421": {
    "hex": "#864054",
    "name": "Red Jubilee",
    "code": "2421"
  },
  "2422": {
    "hex": "#9C7A87",
    "name": "Ducky Mauve",
    "code": "2422"
  },
  "2423": {
    "hex": "#FCC7CF",
    "name": "Pale Orchid",
    "code": "2423"
  },
  "2424": {
    "hex": "#BE9ABB",
    "name": "Cachet",
    "code": "2424"
  },
  "2425": {
    "hex": "#9C5DB7",
    "name": "Laurie Lilac",
    "code": "2425"
  },
  "2426": {
    "hex": "#A764A3",
    "name": "Raspberry",
    "code": "2426"
  },
  "2427": {
    "hex": "#4B4286",
    "name": "Violet Blue",
    "code": "2427"
  },
  "2428": {
    "hex": "#4D1F7F",
    "name": "Purple Maze",
    "code": "2428"
  },
  "2429": {
    "hex": "#393787",
    "name": "Purple Twist",
    "code": "2429"
  },
  "2430": {
    "hex": "#6F208A",
    "name": "Purple Shadow",
    "code": "2430"
  },
  "2431": {
    "hex": "#5A3D71",
    "name": "Purple Accent",
    "code": "2431"
  },
  "2432": {
    "hex": "#B41F64",
    "name": "Strawberry",
    "code": "2432"
  },
  "2433": {
    "hex": "#86BBE1",
    "name": "Ultra Blue",
    "code": "2433"
  },
  "2434": {
    "hex": "#86B4DF",
    "name": "Tropic Blue",
    "code": "2434"
  },
  "2435": {
    "hex": "#ERROR!",
    "name": "Blue Horizon",
    "code": "2435"
  },
  "2436": {
    "hex": "#1F50A0",
    "name": "Fire Blue",
    "code": "2436"
  },
  "2437": {
    "hex": "#5642A0",
    "name": "Empire Blue",
    "code": "2437"
  },
  "2438": {
    "hex": "#1F448E",
    "name": "Blue Suede",
    "code": "2438"
  },
  "2439": {
    "hex": "#2C446F",
    "name": "Blue Ribbon",
    "code": "2439"
  },
  "2440": {
    "hex": "#44406F",
    "name": "Blue Ink",
    "code": "2440"
  },
  "2441": {
    "hex": "#1F9CDB",
    "name": "Baltic Blue",
    "code": "2441"
  },
  "2442": {
    "hex": "#1F69AB",
    "name": "Solar Blue",
    "code": "2442"
  },
  "2443": {
    "hex": "#739E9E",
    "name": "Mystic Teal",
    "code": "2443"
  },
  "2444": {
    "hex": "#1F5669",
    "name": "Dark Teal",
    "code": "2444"
  },
  "2445": {
    "hex": "#1F8383",
    "name": "M.D. Green",
    "code": "2445"
  },
  "2446": {
    "hex": "#1F7F86",
    "name": "Oceanic Green",
    "code": "2446"
  },
  "2447": {
    "hex": "#1F7876",
    "name": "Garden Green",
    "code": "2447"
  },
  "2448": {
    "hex": "#1F9183",
    "name": "Greenstone",
    "code": "2448"
  },
  "2449": {
    "hex": "#1F7876",
    "name": "Fern Green",
    "code": "2449"
  },
  "2450": {
    "hex": "#4D4064",
    "name": "Fleet Blue",
    "code": "2450"
  },
  "2451": {
    "hex": "#1F736A",
    "name": "Green Forest",
    "code": "2451"
  },
  "2452": {
    "hex": "#A0E1DF",
    "name": "Green Pearl",
    "code": "2452"
  },
  "2453": {
    "hex": "#1F8A54",
    "name": "Dark Emerald",
    "code": "2453"
  },
  "2454": {
    "hex": "#1F7D56",
    "name": "Fleece Green",
    "code": "2454"
  },
  "2455": {
    "hex": "#1F7D69",
    "name": "Green Bay",
    "code": "2455"
  },
  "2456": {
    "hex": "#AEB925",
    "name": "Peapod",
    "code": "2456"
  },
  "2457": {
    "hex": "#8EC21F",
    "name": "Green Dust",
    "code": "2457"
  },
  "2458": {
    "hex": "#205F49",
    "name": "Green Petal",
    "code": "2458"
  },
  "2459": {
    "hex": "#1e423c",
    "name": "Green Sail",
    "code": "2459"
  },
  "2460": {
    "hex": "#406659",
    "name": "Field Green",
    "code": "2460"
  },
  "2461": {
    "hex": "#EDE1A3",
    "name": "Wheat",
    "code": "2461"
  },
  "2462": {
    "hex": "#FAE132",
    "name": "Sunflower",
    "code": "2462"
  },
  "2463": {
    "hex": "#FCBE30",
    "name": "Merit Gold",
    "code": "2463"
  },
  "2464": {
    "hex": "#FFCD39",
    "name": "Nectar",
    "code": "2464"
  },
  "2465": {
    "hex": "#FCC75F",
    "name": "Scholastic",
    "code": "2465"
  },
  "2466": {
    "hex": "#FCD732",
    "name": "Manila",
    "code": "2466"
  },
  "2467": {
    "hex": "#F85F20",
    "name": "Orangeade",
    "code": "2467"
  },
  "2468": {
    "hex": "#FA6A20",
    "name": "Tex Orange",
    "code": "2468"
  },
  "2469": {
    "hex": "#FA7620",
    "name": "Dark Tex Orange",
    "code": "2469"
  },
  "2470": {
    "hex": "#E4B42C",
    "name": "Karat",
    "code": "2470"
  },
  "2471": {
    "hex": "#CDAB29",
    "name": "Shimmering Gold",
    "code": "2471"
  },
  "2472": {
    "hex": "#B93946",
    "name": "Auburn",
    "code": "2472"
  },
  "2473": {
    "hex": "#F8D8BE",
    "name": "Opaline",
    "code": "2473"
  },
  "2474": {
    "hex": "#C8B286",
    "name": "Rattan",
    "code": "2474"
  },
  "2475": {
    "hex": "#D8B28C",
    "name": "Mocha Cream",
    "code": "2475"
  },
  "2476": {
    "hex": "#DBD2B9",
    "name": "Seashell",
    "code": "2476"
  },
  "2477": {
    "hex": "#7D5D30",
    "name": "Sand Dune",
    "code": "2477"
  },
  "2478": {
    "hex": "#7E6037",
    "name": "Light Coco",
    "code": "2478"
  },
  "2479": {
    "hex": "#B98623",
    "name": "Almond",
    "code": "2479"
  },
  "2480": {
    "hex": "#BB7D81",
    "name": "K.A. Bronze",
    "code": "2480"
  },
  "2481": {
    "hex": "#A76435",
    "name": "Hazel",
    "code": "2481"
  },
  "2482": {
    "hex": "#D2C8CD",
    "name": "Skylight",
    "code": "2482"
  },
  "2483": {
    "hex": "#B9B4AE",
    "name": "Cloud",
    "code": "2483"
  },
  "2484": {
    "hex": "#9A9793",
    "name": "Silvery Gray",
    "code": "2484"
  },
  "2485": {
    "hex": "#DFD8D8",
    "name": "Saturn Gray",
    "code": "2485"
  },
  "2486": {
    "hex": "#BBB2BE",
    "name": "Storm Gray",
    "code": "2486"
  },
  "2487": {
    "hex": "#4D5059",
    "name": "Smokey",
    "code": "2487"
  },
  "2488": {
    "hex": "#BB9173",
    "name": "Cocoa Mulch",
    "code": "2488"
  },
  "2489": {
    "hex": "#B48656",
    "name": "Wicker",
    "code": "2489"
  },
  "2490": {
    "hex": "#764971",
    "name": "Plum Wine",
    "code": "2490"
  },
  "2491": {
    "hex": "#E86A7F",
    "name": "Primrose",
    "code": "2491"
  },
  "2492": {
    "hex": "#1F9597",
    "name": "J. Turquoise",
    "code": "2492"
  },
  "2493": {
    "hex": "#C89C73",
    "name": "Light Bronze",
    "code": "2493"
  },
  "2494": {
    "hex": "#A03250",
    "name": "Carbernet",
    "code": "2494"
  },
  "2495": {
    "hex": "#FABBC0",
    "name": "Mountain Rose",
    "code": "2495"
  },
  "2496": {
    "hex": "#783944",
    "name": "Warm Wine",
    "code": "2496"
  },
  "2497": {
    "hex": "#9C3D5A",
    "name": "Perfect Ruby",
    "code": "2497"
  },
  "2498": {
    "hex": "#7F3C56",
    "name": "Brushed Burgundy",
    "code": "2498"
  },
  "2499": {
    "hex": "#9C3D5A",
    "name": "Passion Rose",
    "code": "2499"
  },
  "2500": {
    "hex": "#B71F86",
    "name": "New Berry",
    "code": "2500"
  },
  "2501": {
    "hex": "#FCCFCD",
    "name": "Petal Pink",
    "code": "2501"
  },
  "2502": {
    "hex": "#F5C7D7",
    "name": "Memphis Belle",
    "code": "2502"
  },
  "2503": {
    "hex": "#F8C7C7",
    "name": "Desert Bloom",
    "code": "2503"
  },
  "2504": {
    "hex": "#B41F64",
    "name": "Cherrystone",
    "code": "2504"
  },
  "2505": {
    "hex": "#AE4050",
    "name": "Antique Red",
    "code": "2505"
  },
  "2506": {
    "hex": "#CB3952",
    "name": "Devil Red",
    "code": "2506"
  },
  "2507": {
    "hex": "#B91F54",
    "name": "Candy Apple Red",
    "code": "2507"
  },
  "2508": {
    "hex": "#DD3756",
    "name": "Rosewood",
    "code": "2508"
  },
  "2509": {
    "hex": "#FC7183",
    "name": "Bitteroot",
    "code": "2509"
  },
  "2510": {
    "hex": "#FACDB4",
    "name": "Peach Blossom",
    "code": "2510"
  },
  "2511": {
    "hex": "#FAC2B4",
    "name": "Illusion",
    "code": "2511"
  },
  "2512": {
    "hex": "#FA9783",
    "name": "Melonade",
    "code": "2512"
  },
  "2513": {
    "hex": "#E55442",
    "name": "Honeysuckle",
    "code": "2513"
  },
  "2514": {
    "hex": "#1F9A91",
    "name": "Brite Jade",
    "code": "2514"
  },
  "2515": {
    "hex": "#1FBBAB",
    "name": "Bluestone",
    "code": "2515"
  },
  "2516": {
    "hex": "#5DDBC8",
    "name": "Aqua Pearl",
    "code": "2516"
  },
  "2517": {
    "hex": "#95E1D7",
    "name": "Seafrost",
    "code": "2517"
  },
  "2518": {
    "hex": "#46CDDB",
    "name": "Indian Ocean Blue",
    "code": "2518"
  },
  "2519": {
    "hex": "#1FB0DF",
    "name": "Surf Blue",
    "code": "2519"
  },
  "2520": {
    "hex": "#1FAEE1",
    "name": "Mid Windsor",
    "code": "2520"
  },
  "2521": {
    "hex": "#1F7F86",
    "name": "Mallard Blue",
    "code": "2521"
  },
  "2522": {
    "hex": "#B9C4DF",
    "name": "Bridgeport Blue",
    "code": "2522"
  },
  "2523": {
    "hex": "#4B6A95",
    "name": "China Blue",
    "code": "2523"
  },
  "2524": {
    "hex": "#87A3BB",
    "name": "Country Blue",
    "code": "2524"
  },
  "2525": {
    "hex": "#C8CFE1",
    "name": "Heron Blue",
    "code": "2525"
  },
  "2526": {
    "hex": "#7897D2",
    "name": "Bright Blue",
    "code": "2526"
  },
  "2527": {
    "hex": "#6D73B2",
    "name": "Soldier Blue",
    "code": "2527"
  },
  "2528": {
    "hex": "#7897D2",
    "name": "Atlantis Blue",
    "code": "2528"
  },
  "2529": {
    "hex": "#5286CB",
    "name": "Dolphin Blue",
    "code": "2529"
  },
  "2530": {
    "hex": "#86B4DF",
    "name": "Caribbean Blue",
    "code": "2530"
  },
  "2531": {
    "hex": "#CBDDE5",
    "name": "Dana Blue",
    "code": "2531"
  },
  "2532": {
    "hex": "#CBDDE5",
    "name": "Cadet Blue",
    "code": "2532"
  },
  "2533": {
    "hex": "#73B9E1",
    "name": "Ozone",
    "code": "2533"
  },
  "2534": {
    "hex": "#1F547D",
    "name": "Salem Blue",
    "code": "2534"
  },
  "2535": {
    "hex": "#526A64",
    "name": "Enchanted Sea",
    "code": "2535"
  },
  "2536": {
    "hex": "#A7B4C7",
    "name": "Rockport Blue",
    "code": "2536"
  },
  "2537": {
    "hex": "#C7C2B9",
    "name": "Steel",
    "code": "2537"
  },
  "2538": {
    "hex": "#D2C8BB",
    "name": "Stainless Steel",
    "code": "2538"
  },
  "2539": {
    "hex": "#D7D2C7",
    "name": "Chrome",
    "code": "2539"
  },
  "2540": {
    "hex": "#B7B9B4",
    "name": "Traditional Gray",
    "code": "2540"
  },
  "2541": {
    "hex": "#5A5450",
    "name": "Black Chrome",
    "code": "2541"
  },
  "2542": {
    "hex": "#A59327",
    "name": "Foliage Green",
    "code": "2542"
  },
  "2543": {
    "hex": "#AE9123",
    "name": "Autumn Green",
    "code": "2543"
  },
  "2544": {
    "hex": "#978735",
    "name": "Desert Cactus",
    "code": "2544"
  },
  "2545": {
    "hex": "#818130",
    "name": "Cypress",
    "code": "2545"
  },
  "2546": {
    "hex": "#939123",
    "name": "Crescent Moon",
    "code": "2546"
  },
  "2547": {
    "hex": "#E5E893",
    "name": "Pebblestone",
    "code": "2547"
  },
  "2548": {
    "hex": "#A59C25",
    "name": "Sun Shadow",
    "code": "2548"
  },
  "2549": {
    "hex": "#1F5F64",
    "name": "Blue Spruce",
    "code": "2549"
  },
  "2550": {
    "hex": "#647F71",
    "name": "Newport",
    "code": "2550"
  },
  "2551": {
    "hex": "#879E91",
    "name": "Spring Garden",
    "code": "2551"
  },
  "2552": {
    "hex": "#294940",
    "name": "Ivy",
    "code": "2552"
  },
  "2553": {
    "hex": "#3D5246",
    "name": "Dark Army Green",
    "code": "2553"
  },
  "2554": {
    "hex": "#697A6A",
    "name": "Water Lilly",
    "code": "2554"
  },
  "2555": {
    "hex": "#CFDBAE",
    "name": "Pastel Green",
    "code": "2555"
  },
  "2556": {
    "hex": "#E4B42C",
    "name": "Pollen Gold",
    "code": "2556"
  },
  "2557": {
    "hex": "#F5E595",
    "name": "Pale Yellow",
    "code": "2557"
  },
  "2558": {
    "hex": "#FFCD39",
    "name": "Buttercup",
    "code": "2558"
  },
  "2559": {
    "hex": "#F8EBB4",
    "name": "Tusk",
    "code": "2559"
  },
  "2560": {
    "hex": "#FAE132",
    "name": "Moonbeam",
    "code": "2560"
  },
  "2561": {
    "hex": "#CDAB29",
    "name": "Black Eyed Susie",
    "code": "2561"
  },
  "2562": {
    "hex": "#AE8E30",
    "name": "Bullion",
    "code": "2562"
  },
  "2563": {
    "hex": "#6D5444",
    "name": "Dogwood",
    "code": "2563"
  },
  "2564": {
    "hex": "#564944",
    "name": "Mahogany",
    "code": "2564"
  },
  "2565": {
    "hex": "#5A5450",
    "name": "Aged Charcoal",
    "code": "2565"
  },
  "2566": {
    "hex": "#544942",
    "name": "Best Brown",
    "code": "2566"
  },
  "2567": {
    "hex": "#76522E",
    "name": "Mushroom",
    "code": "2567"
  },
  "2568": {
    "hex": "#C8B286",
    "name": "Perfect Tan",
    "code": "2568"
  },
  "2569": {
    "hex": "#8A6F2E",
    "name": "Earthen Tan",
    "code": "2569"
  },
  "2570": {
    "hex": "#C8B286",
    "name": "Golden Tan",
    "code": "2570"
  },
  "2571": {
    "hex": "#C8BEB0",
    "name": "Platinum",
    "code": "2571"
  },
  "2572": {
    "hex": "#B7AB8A",
    "name": "Grayrod",
    "code": "2572"
  },
  "2573": {
    "hex": "#B7AB8A",
    "name": "Pewter",
    "code": "2573"
  },
  "2574": {
    "hex": "#FFFFFF",
    "name": "Aspen White",
    "code": "2574"
  },
  "2575": {
    "hex": "#786D61",
    "name": "Dark Taupe",
    "code": "2575"
  },
  "2576": {
    "hex": "#5F4D4B",
    "name": "Egyptian Brown",
    "code": "2576"
  },
  "2577": {
    "hex": "#71A5B4",
    "name": "Wonder Blue",
    "code": "2577"
  },
  "2578": {
    "hex": "#39BE52",
    "name": "Harvest Green",
    "code": "2578"
  },
  "2579": {
    "hex": "#1FAA5F",
    "name": "Vibrant Green",
    "code": "2579"
  },
  "2580": {
    "hex": "#1FAA5F",
    "name": "Green Grass",
    "code": "2580"
  },
  "2581": {
    "hex": "#B0562C",
    "name": "Old Dark Tex Orange",
    "code": "2581"
  },
  "2582": {
    "hex": "#FFFFFF",
    "name": "Bone",
    "code": "2582"
  },
  "2584": {
    "hex": "#565F40",
    "name": "Dress Green",
    "code": "2584"
  },
  "2585": {
    "hex": "#9EA3A0",
    "name": "Banner Gray",
    "code": "2585"
  },
  "2586": {
    "hex": "#F4C75F",
    "name": "14 Kt. Gold",
    "code": "2586"
  },
  "2587": {
    "hex": "#6D4B5A",
    "name": "Intense Maroon",
    "code": "2587"
  },
  "2588": {
    "hex": "#E5AADB",
    "name": "Mid Lilac",
    "code": "2588"
  },
  "2589": {
    "hex": "#1F5669",
    "name": "Deep Windsor",
    "code": "2589"
  },
  "2590": {
    "hex": "#B41F78",
    "name": "Hot Peony",
    "code": "2590"
  },
  "2591": {
    "hex": "#DD97A7",
    "name": "Rose Tint",
    "code": "2591"
  },
  "2592": {
    "hex": "#B7B9B4",
    "name": "Silver Steel",
    "code": "2592"
  },
  "2593": {
    "hex": "#EFD8BE",
    "name": "Cottage Beige",
    "code": "2593"
  },
  "2594": {
    "hex": "#8AB29E",
    "name": "Wintergreen",
    "code": "2594"
  },
  "2595": {
    "hex": "#698749",
    "name": "Sage",
    "code": "2595"
  },
  "2596": {
    "hex": "#CDAB29",
    "name": "Marine Gold",
    "code": "2596"
  },
  "2597": {
    "hex": "#1F8C78",
    "name": "Jungle Green",
    "code": "2597"
  },
  "2598": {
    "hex": "#C8CFE1",
    "name": "Blue Hint",
    "code": "2598"
  },
  "2599": {
    "hex": "#F1CDD8",
    "name": "Pink Bazaar",
    "code": "2599"
  },
  "2600": {
    "hex": "#664069",
    "name": "Port Wine",
    "code": "2600"
  },
  "2601": {
    "hex": "#565F40",
    "name": "Hedge",
    "code": "2601"
  },
  "2602": {
    "hex": "#DD9A20",
    "name": "24 Kt. Gold",
    "code": "2602"
  },
  "2603": {
    "hex": "#303C54",
    "name": "Flag Blue",
    "code": "2603"
  },
  "2604": {
    "hex": "#FFFFFF",
    "name": "Light Maize",
    "code": "2604"
  },
  "2605": {
    "hex": "#FFD25F",
    "name": "Goldenlite",
    "code": "2605"
  },
  "2606": {
    "hex": "#F4D47A",
    "name": "TH Gold",
    "code": "2606"
  },
  "2607": {
    "hex": "#1F7A69",
    "name": "TH Green",
    "code": "2607"
  },
  "2608": {
    "hex": "#8C3C42",
    "name": "TH Burgundy",
    "code": "2608"
  },
  "2609": {
    "hex": "#1F4069",
    "name": "TH Navy",
    "code": "2609"
  },
  "2610": {
    "hex": "#FFFFFF",
    "name": "Pro Brown",
    "code": "2610"
  },
  "2611": {
    "hex": "#FFFFFF",
    "name": "Pro Cinnamon",
    "code": "2611"
  },
  "2612": {
    "hex": "#40698C",
    "name": "Pro Imperial",
    "code": "2612"
  },
  "2613": {
    "hex": "#1F4069",
    "name": "Pro Midnight",
    "code": "2613"
  },
  "2614": {
    "hex": "#6F87D2",
    "name": "Pro Lusty Blue",
    "code": "2614"
  },
  "2615": {
    "hex": "#1F7F78",
    "name": "Pro Hunter",
    "code": "2615"
  },
  "2616": {
    "hex": "#66465A",
    "name": "Pro Maroon",
    "code": "2616"
  },
  "2617": {
    "hex": "#93A5B0",
    "name": "Pro Twinkle",
    "code": "2617"
  },
  "2618": {
    "hex": "#B7B9B4",
    "name": "Pro Night Sky",
    "code": "2618"
  },
  "2619": {
    "hex": "#1F66C2",
    "name": "Pro Brilliance",
    "code": "2619"
  },
  "2620": {
    "hex": "#1F465D",
    "name": "Pro Dark Blue",
    "code": "2620"
  },
  "2621": {
    "hex": "#1F7D87",
    "name": "Pro Teal",
    "code": "2621"
  },
  "2622": {
    "hex": "#864054",
    "name": "Pro Firebrand",
    "code": "2622"
  },
  "2623": {
    "hex": "#B93946",
    "name": "Pro Red",
    "code": "2623"
  },
  "2624": {
    "hex": "#87A3BB",
    "name": "Pro Saxon",
    "code": "2624"
  },
  "2625": {
    "hex": "#353C7A",
    "name": "Pro Navy",
    "code": "2625"
  },
  "2626": {
    "hex": "#FFCD39",
    "name": "Pro Gold",
    "code": "2626"
  },
  "2627": {
    "hex": "#1F4B8E",
    "name": "Pro Royal",
    "code": "2627"
  },
  "2628": {
    "hex": "#ERROR!",
    "name": "Pro Purple",
    "code": "2628"
  },
  "2629": {
    "hex": "#FFFFF8",
    "name": "Pro Walnut",
    "code": "2629"
  },
  "2630": {
    "hex": "#E5DBBE",
    "name": "Pro Beige",
    "code": "2630"
  },
  "2631": {
    "hex": "#446156",
    "name": "Lizzy Lime",
    "code": "2631"
  },
  "2647": {
    "hex": "#1F405F",
    "name": "Pro College Blue",
    "code": "2647"
  },
  "2728": {
    "hex": "#3C5449",
    "name": "Army Green",
    "code": "2728"
  },
  "2729": {
    "hex": "#7A7876",
    "name": "Mineral",
    "code": "2729"
  },
  "2730": {
    "hex": "#1FAEE1",
    "name": "Boo Boo Blue",
    "code": "2730"
  },
  "2731": {
    "hex": "#9A9793",
    "name": "Gull",
    "code": "2731"
  },
  "2732": {
    "hex": "#FAE49A",
    "name": "Pro Maize",
    "code": "2732"
  },
  "2733": {
    "hex": "#CBC8C2",
    "name": "Pro Cool Gray",
    "code": "2733"
  },
  "2734": {
    "hex": "#1F5A50",
    "name": "Pro Dark Green",
    "code": "2734"
  },
  "2735": {
    "hex": "#1F7F78",
    "name": "Pro Green",
    "code": "2735"
  },
  "2736": {
    "hex": "#442E78",
    "name": "Pro Brite Star",
    "code": "2736"
  },
  "2737": {
    "hex": "#1F81AA",
    "name": "Pro Band Blue",
    "code": "2737"
  },
  "2738": {
    "hex": "#6AB437",
    "name": "Pro Erin",
    "code": "2738"
  },
  "2739": {
    "hex": "#A5978C",
    "name": "Pro Gray",
    "code": "2739"
  },
  "2740": {
    "hex": "#1F8AB0",
    "name": "Pro Peacock",
    "code": "2740"
  },
  "2741": {
    "hex": "#C2C0B9",
    "name": "Pro Pearl",
    "code": "2741"
  },
  "2742": {
    "hex": "#50358A",
    "name": "Pro Violet",
    "code": "2742"
  },
  "2743": {
    "hex": "#1F736A",
    "name": "Pro Forest",
    "code": "2743"
  },
  "2800": {
    "hex": "#3B3F3D",
    "name": "",
    "code": "2800"
  },
  "2801": {
    "hex": "#EEF4FF",
    "name": "",
    "code": "2801"
  },
  "4006": {
    "hex": "#E8BF11",
    "name": "Gold",
    "code": "4006"
  },
  "5501": {
    "hex": "#B38F57",
    "name": "Old Gold",
    "code": "5501"
  },
  "5502": {
    "hex": "#798C77",
    "name": "Olive",
    "code": "5502"
  },
  "5503": {
    "hex": "#DDB99C",
    "name": "Gold",
    "code": "5503"
  },
  "5504": {
    "hex": "#54A4A3",
    "name": "Turquoise",
    "code": "5504"
  },
  "5505": {
    "hex": "#AE5E52",
    "name": "Dark Rust",
    "code": "5505"
  },
  "5506": {
    "hex": "#8CB6CE",
    "name": "Baby Blue",
    "code": "5506"
  },
  "5507": {
    "hex": "#ABA0A8",
    "name": "Gray",
    "code": "5507"
  },
  "5508": {
    "hex": "#1F885C",
    "name": "Dark Green",
    "code": "5508"
  },
  "5509": {
    "hex": "#6E8742",
    "name": "Green",
    "code": "5509"
  },
  "5510": {
    "hex": "#3A5C97",
    "name": "Royal",
    "code": "5510"
  },
  "5511": {
    "hex": "#88BA87",
    "name": "Nile",
    "code": "5511"
  },
  "5512": {
    "hex": "#DFA04B",
    "name": "Sun Gld",
    "code": "5512"
  },
  "5513": {
    "hex": "#E88B27",
    "name": "Yellow Mist",
    "code": "5513"
  },
  "5514": {
    "hex": "#5EA36A",
    "name": "Emerald",
    "code": "5514"
  },
  "5515": {
    "hex": "#434954",
    "name": "Navy",
    "code": "5515"
  },
  "5516": {
    "hex": "#F9B158",
    "name": "Marigold",
    "code": "5516"
  },
  "5517": {
    "hex": "#92979E",
    "name": "Twilight",
    "code": "5517"
  },
  "5518": {
    "hex": "#DF7650",
    "name": "Orange",
    "code": "5518"
  },
  "5519": {
    "hex": "#A63E46",
    "name": "Scarlet",
    "code": "5519"
  },
  "5520": {
    "hex": "#3577AB",
    "name": "Blue",
    "code": "5520"
  },
  "5521": {
    "hex": "#969D94",
    "name": "Willow",
    "code": "5521"
  },
  "5522": {
    "hex": "#B1D7D0",
    "name": "Light Blue",
    "code": "5522"
  },
  "5523": {
    "hex": "#EDB4C4",
    "name": "Pink Cascade",
    "code": "5523"
  },
  "5524": {
    "hex": "#AE9780",
    "name": "Beige",
    "code": "5524"
  },
  "5525": {
    "hex": "#7C4B5A",
    "name": "Wine",
    "code": "5525"
  },
  "5526": {
    "hex": "#6A8640",
    "name": "Meadow",
    "code": "5526"
  },
  "5527": {
    "hex": "#8E614A",
    "name": "Chocolate",
    "code": "5527"
  },
  "5528": {
    "hex": "#F47B99",
    "name": "Begonia",
    "code": "5528"
  },
  "5529": {
    "hex": "#7F804D",
    "name": "Palmetto",
    "code": "5529"
  },
  "5530": {
    "hex": "#A39951",
    "name": "Tamarack",
    "code": "5530"
  },
  "5531": {
    "hex": "#E29260",
    "name": "Toast",
    "code": "5531"
  },
  "5532": {
    "hex": "#D6BEB1",
    "name": "Ecru",
    "code": "5532"
  },
  "5533": {
    "hex": "#BF4452",
    "name": "Lipstick",
    "code": "5533"
  },
  "5534": {
    "hex": "#F8C07F",
    "name": "Glow",
    "code": "5534"
  },
  "5535": {
    "hex": "#F8BC4C",
    "name": "Canary",
    "code": "5535"
  },
  "5536": {
    "hex": "#CE543E",
    "name": "Paprika",
    "code": "5536"
  },
  "5537": {
    "hex": "#FF8EA7",
    "name": "Carnation",
    "code": "5537"
  },
  "5538": {
    "hex": "#B1CDAC",
    "name": "Mint Julep",
    "code": "5538"
  },
  "5539": {
    "hex": "#96C0D6",
    "name": "Sky Blue",
    "code": "5539"
  },
  "5540": {
    "hex": "#539260",
    "name": "Kelly",
    "code": "5540"
  },
  "5541": {
    "hex": "#B8B9AE",
    "name": "Palm Leaf",
    "code": "5541"
  },
  "5542": {
    "hex": "#F5B91F",
    "name": "Goldenrod",
    "code": "5542"
  },
  "5543": {
    "hex": "#F2DCDE",
    "name": "Light Pink",
    "code": "5543"
  },
  "5544": {
    "hex": "#FFA3B1",
    "name": "Rose Cerise",
    "code": "5544"
  },
  "5545": {
    "hex": "#5D8EB5",
    "name": "Copen",
    "code": "5545"
  },
  "5546": {
    "hex": "#F997A9",
    "name": "Shrimp",
    "code": "5546"
  },
  "5547": {
    "hex": "#DD9B69",
    "name": "Honey",
    "code": "5547"
  },
  "5549": {
    "hex": "#8B4451",
    "name": "Burgundy",
    "code": "5549"
  },
  "5550": {
    "hex": "#C9B99D",
    "name": "Pistachio",
    "code": "5550"
  },
  "5551": {
    "hex": "#695350",
    "name": "Brown",
    "code": "5551"
  },
  "5552": {
    "hex": "#7A434B",
    "name": "Russet",
    "code": "5552"
  },
  "5553": {
    "hex": "#EFB3AA",
    "name": "Flesh Pink",
    "code": "5553"
  },
  "5554": {
    "hex": "#755E8F",
    "name": "Purple",
    "code": "5554"
  },
  "5556": {
    "hex": "#F6B9A3",
    "name": "Tawny",
    "code": "5556"
  },
  "5558": {
    "hex": "#FFB1A5",
    "name": "Flamingo",
    "code": "5558"
  },
  "5559": {
    "hex": "#E991B4",
    "name": "Wild Pink",
    "code": "5559"
  },
  "5560": {
    "hex": "#AF4C74",
    "name": "Hot Pink",
    "code": "5560"
  },
  "5561": {
    "hex": "#B94774",
    "name": "Ruby Glint",
    "code": "5561"
  },
  "5563": {
    "hex": "#C1464F",
    "name": "Foxy Red",
    "code": "5563"
  },
  "5564": {
    "hex": "#EDCB96",
    "name": "Maize",
    "code": "5564"
  },
  "5565": {
    "hex": "#70696A",
    "name": "Charcoal",
    "code": "5565"
  },
  "5566": {
    "hex": "#F2D3C8",
    "name": "Radiant Red",
    "code": "5566"
  },
  "5567": {
    "hex": "#B43E55",
    "name": "Wild Fire",
    "code": "5567"
  },
  "5568": {
    "hex": "#9A4854",
    "name": "Carolina Red",
    "code": "5568"
  },
  "5569": {
    "hex": "#A1BBD0",
    "name": "Sun Blue",
    "code": "5569"
  },
  "5570": {
    "hex": "#A21F35",
    "name": "Cranberry",
    "code": "5570"
  },
  "5572": {
    "hex": "#D0AFAA",
    "name": "Grape",
    "code": "5572"
  },
  "5573": {
    "hex": "#CBAF99",
    "name": "Tan",
    "code": "5573"
  },
  "5574": {
    "hex": "#A098A1",
    "name": "Steel Gray",
    "code": "5574"
  },
  "5575": {
    "hex": "#677F96",
    "name": "Slate Blue",
    "code": "5575"
  },
  "5578": {
    "hex": "#8EAEA3",
    "name": "Moss",
    "code": "5578"
  },
  "5579": {
    "hex": "#89AB72",
    "name": "Spruce",
    "code": "5579"
  },
  "5580": {
    "hex": "#0745AB",
    "name": "Saphire",
    "code": "5580"
  },
  "5581": {
    "hex": "#B2454E",
    "name": "Jockey Red",
    "code": "5581"
  },
  "5583": {
    "hex": "#B6C1DA",
    "name": "Paris Blue",
    "code": "5583"
  },
  "5584": {
    "hex": "#4E7B61",
    "name": "Deep Green",
    "code": "5584"
  },
  "5585": {
    "hex": "#CFB3C8",
    "name": "Violet",
    "code": "5585"
  },
  "5586": {
    "hex": "#9C95B9",
    "name": "Tulip",
    "code": "5586"
  },
  "5587": {
    "hex": "#7677A2",
    "name": "Mauve",
    "code": "5587"
  },
  "5588": {
    "hex": "#7761A1",
    "name": "Iris",
    "code": "5588"
  },
  "5589": {
    "hex": "#D98868",
    "name": "Rust",
    "code": "5589"
  },
  "5590": {
    "hex": "#93624D",
    "name": "Date",
    "code": "5590"
  },
  "5591": {
    "hex": "#B05077",
    "name": "Passion Rose",
    "code": "5591"
  },
  "5592": {
    "hex": "#95688F",
    "name": "Plum",
    "code": "5592"
  },
  "5594": {
    "hex": "#FF9D92",
    "name": "Melon",
    "code": "5594"
  },
  "5595": {
    "hex": "#C1864B",
    "name": "Copper",
    "code": "5595"
  },
  "5596": {
    "hex": "#4A4B4B",
    "name": "Black",
    "code": "5596"
  },
  "5597": {
    "hex": "#F1F5FF",
    "name": "Snow White",
    "code": "5597"
  },
  "5598": {
    "hex": "#C8AB93",
    "name": "Taupe",
    "code": "5598"
  },
  "5599": {
    "hex": "#D4A19E",
    "name": "Salmon",
    "code": "5599"
  },
  "5600": {
    "hex": "#B5CCDE",
    "name": "Ice Blue",
    "code": "5600"
  },
  "5601": {
    "hex": "#729EC3",
    "name": "Oriental Blue",
    "code": "5601"
  },
  "5602": {
    "hex": "#456893",
    "name": "Imperial Blue",
    "code": "5602"
  },
  "5603": {
    "hex": "#45485A",
    "name": "Light Navy",
    "code": "5603"
  },
  "5604": {
    "hex": "#87ABCC",
    "name": "Lake Blue",
    "code": "5604"
  },
  "5607": {
    "hex": "#1FA3AF",
    "name": "Marine Aqua",
    "code": "5607"
  },
  "5608": {
    "hex": "#73A5B8",
    "name": "Misty",
    "code": "5608"
  },
  "5609": {
    "hex": "#23979E",
    "name": "Teal",
    "code": "5609"
  },
  "5610": {
    "hex": "#A2A4AA",
    "name": "Mint Julep",
    "code": "5610"
  },
  "5611": {
    "hex": "#77C0AA",
    "name": "Seafoam",
    "code": "5611"
  },
  "5612": {
    "hex": "#40A58C",
    "name": "Isle Green",
    "code": "5612"
  },
  "5613": {
    "hex": "#A6C6C8",
    "name": "Sprite",
    "code": "5613"
  },
  "5614": {
    "hex": "#A68A94",
    "name": "Satin White",
    "code": "5614"
  },
  "5615": {
    "hex": "#416455",
    "name": "Evergreen",
    "code": "5615"
  },
  "5616": {
    "hex": "#EBE7C8",
    "name": "Velery",
    "code": "5616"
  },
  "5617": {
    "hex": "#797961",
    "name": "Olive Drab",
    "code": "5617"
  },
  "5618": {
    "hex": "#AEDAD0",
    "name": "Pale Green",
    "code": "5618"
  },
  "5619": {
    "hex": "#A7C79A",
    "name": "Green Oak",
    "code": "5619"
  },
  "5620": {
    "hex": "#88BA52",
    "name": "Erin Green",
    "code": "5620"
  },
  "5621": {
    "hex": "#AAC57A",
    "name": "Pastoral Green",
    "code": "5621"
  },
  "5622": {
    "hex": "#89AA49",
    "name": "Ming",
    "code": "5622"
  },
  "5623": {
    "hex": "#4D6649",
    "name": "Hollyhock Red",
    "code": "5623"
  },
  "5625": {
    "hex": "#F5E08E",
    "name": "Lemon",
    "code": "5625"
  },
  "5626": {
    "hex": "#F5CF5D",
    "name": "Fdaffodil",
    "code": "5626"
  },
  "5629": {
    "hex": "#CC514B",
    "name": "Saffron",
    "code": "5629"
  },
  "5630": {
    "hex": "#E07C50",
    "name": "Golden Poppy",
    "code": "5630"
  },
  "5631": {
    "hex": "#D7A462",
    "name": "Mustard",
    "code": "5631"
  },
  "5632": {
    "hex": "#D4AB7A",
    "name": "Penny",
    "code": "5632"
  },
  "5633": {
    "hex": "#C29D59",
    "name": "Ginger",
    "code": "5633"
  },
  "5634": {
    "hex": "#A3524B",
    "name": "Terra Cotta",
    "code": "5634"
  },
  "5635": {
    "hex": "#EDDCC9",
    "name": "Ivory",
    "code": "5635"
  },
  "5636": {
    "hex": "#CDA58F",
    "name": "Amber Beige",
    "code": "5636"
  },
  "5637": {
    "hex": "#665752",
    "name": "Espresso",
    "code": "5637"
  },
  "5638": {
    "hex": "#DBAC8E",
    "name": "Bamboo",
    "code": "5638"
  },
  "5639": {
    "hex": "#765453",
    "name": "Coffee Bean",
    "code": "5639"
  },
  "5640": {
    "hex": "#D1CEC4",
    "name": "Pearl Gray",
    "code": "5640"
  },
  "5641": {
    "hex": "#5E667D",
    "name": "Ash",
    "code": "5641"
  },
  "5643": {
    "hex": "#F1EBDA",
    "name": "Eggshell",
    "code": "5643"
  },
  "5672": {
    "hex": "#6B584D",
    "name": "Dark Brown",
    "code": "5672"
  },
  "5675": {
    "hex": "#EAADBD",
    "name": "Dusty Rose",
    "code": "5675"
  },
  "5676": {
    "hex": "#6F444E",
    "name": "Maroon",
    "code": "5676"
  },
  "5677": {
    "hex": "#EBCAC1",
    "name": "Bisque",
    "code": "5677"
  },
  "5678": {
    "hex": "#AE3E49",
    "name": "Red",
    "code": "5678"
  },
  "5681": {
    "hex": "#66517A",
    "name": "Dark Purple",
    "code": "5681"
  },
  "5682": {
    "hex": "#9DC4DE",
    "name": "Pastel Blue",
    "code": "5682"
  },
  "5683": {
    "hex": "#89A5C2",
    "name": "Cristy Blue",
    "code": "5683"
  },
  "5684": {
    "hex": "#537CB4",
    "name": "Jay Blue",
    "code": "5684"
  },
  "5685": {
    "hex": "#3D619C",
    "name": "Jamie Blue",
    "code": "5685"
  },
  "5686": {
    "hex": "#484B65",
    "name": "Light Midnight",
    "code": "5686"
  },
  "5687": {
    "hex": "#444B57",
    "name": "Midnight Navy",
    "code": "5687"
  },
  "5689": {
    "hex": "#1F9CC4",
    "name": "California Blue",
    "code": "5689"
  },
  "5690": {
    "hex": "#1F9885",
    "name": "Peppermint",
    "code": "5690"
  },
  "5691": {
    "hex": "#1F897F",
    "name": "Pine Green",
    "code": "5691"
  },
  "5692": {
    "hex": "#5C7562",
    "name": "Harbor Green",
    "code": "5692"
  },
  "5693": {
    "hex": "#9ED7C6",
    "name": "Sea Mist",
    "code": "5693"
  },
  "5694": {
    "hex": "#F1A156",
    "name": "Mango",
    "code": "5694"
  },
  "5695": {
    "hex": "#F4B462",
    "name": "Cornsilk",
    "code": "5695"
  },
  "5696": {
    "hex": "#EEA943",
    "name": "Brite Yellow",
    "code": "5696"
  },
  "5698": {
    "hex": "#F5B97F",
    "name": "Visor Gold",
    "code": "5698"
  },
  "5699": {
    "hex": "#E8BD95",
    "name": "New Gold",
    "code": "5699"
  },
  "5700": {
    "hex": "#DFB388",
    "name": "Topaz",
    "code": "5700"
  },
  "5701": {
    "hex": "#D7A478",
    "name": "Ashley Gold",
    "code": "5701"
  },
  "5702": {
    "hex": "#7B4917",
    "name": "Sienna",
    "code": "5702"
  },
  "5703": {
    "hex": "#E7DDD7",
    "name": "Oyster",
    "code": "5703"
  },
  "5704": {
    "hex": "#97989E",
    "name": "Cinder",
    "code": "5704"
  },
  "5705": {
    "hex": "#9A9196",
    "name": "Dover Grey",
    "code": "5705"
  },
  "5706": {
    "hex": "#9A94A8",
    "name": "Sterling",
    "code": "5706"
  },
  "5707": {
    "hex": "#7D858C",
    "name": "Metal",
    "code": "5707"
  },
  "5708": {
    "hex": "#F4BD57",
    "name": "Star Gold",
    "code": "5708"
  },
  "5709": {
    "hex": "#F59F4D",
    "name": "Yellow Mist",
    "code": "5709"
  },
  "5710": {
    "hex": "#FF864C",
    "name": "Neon",
    "code": "5710"
  },
  "5711": {
    "hex": "#FB80A3",
    "name": "Neon Pink",
    "code": "5711"
  },
  "5712": {
    "hex": "#FF824F",
    "name": "Neon Red",
    "code": "5712"
  },
  "5713": {
    "hex": "#ECFF2D",
    "name": "Neon Yellow",
    "code": "5713"
  },
  "5717": {
    "hex": "#C14569",
    "name": "Cherry Punch",
    "code": "5717"
  },
  "5718": {
    "hex": "#B94150",
    "name": "Red Berry",
    "code": "5718"
  },
  "5719": {
    "hex": "#BB4352",
    "name": "Very Red",
    "code": "5719"
  },
  "5722": {
    "hex": "#82707B",
    "name": "Ducky Mauve",
    "code": "5722"
  },
  "5728": {
    "hex": "#5A568C",
    "name": "Purple Maze",
    "code": "5728"
  },
  "5729": {
    "hex": "#455288",
    "name": "Purple Twist",
    "code": "5729"
  },
  "5731": {
    "hex": "#5C5082",
    "name": "Purple Accent",
    "code": "5731"
  },
  "5732": {
    "hex": "#C44772",
    "name": "Strawberry",
    "code": "5732"
  },
  "5733": {
    "hex": "#76A4C7",
    "name": "Ultra Blue",
    "code": "5733"
  },
  "5734": {
    "hex": "#709FC2",
    "name": "Tropic Blue",
    "code": "5734"
  },
  "5736": {
    "hex": "#3B6091",
    "name": "Fire Blue",
    "code": "5736"
  },
  "5737": {
    "hex": "#485B9A",
    "name": "Empire Blue",
    "code": "5737"
  },
  "5738": {
    "hex": "#30578B",
    "name": "Blue Suede",
    "code": "5738"
  },
  "5739": {
    "hex": "#43526E",
    "name": "Blue Ribbon",
    "code": "5739"
  },
  "5740": {
    "hex": "#464D6B",
    "name": "Blue Ink",
    "code": "5740"
  },
  "5741": {
    "hex": "#1F81A3",
    "name": "Baltic Blue",
    "code": "5741"
  },
  "5743": {
    "hex": "#4BA6AB",
    "name": "Mystic Teal",
    "code": "5743"
  },
  "5745": {
    "hex": "#1F9D96",
    "name": "M.D. Green",
    "code": "5745"
  },
  "5746": {
    "hex": "#1F9C9E",
    "name": "Oceanic Green",
    "code": "5746"
  },
  "5748": {
    "hex": "#1F8974",
    "name": "Green Stone",
    "code": "5748"
  },
  "5749": {
    "hex": "#348179",
    "name": "Fern Green",
    "code": "5749"
  },
  "5750": {
    "hex": "#4C5167",
    "name": "Fleet Blue",
    "code": "5750"
  },
  "5751": {
    "hex": "#1F9985",
    "name": "Green Forest",
    "code": "5751"
  },
  "5752": {
    "hex": "#85CDBF",
    "name": "Green Pearl",
    "code": "5752"
  },
  "5755": {
    "hex": "#437363",
    "name": "Green Bay",
    "code": "5755"
  },
  "5756": {
    "hex": "#A3AF5B",
    "name": "Peapod",
    "code": "5756"
  },
  "5757": {
    "hex": "#90A266",
    "name": "Green Dust",
    "code": "5757"
  },
  "5758": {
    "hex": "#426D58",
    "name": "Green Petal",
    "code": "5758"
  },
  "5759": {
    "hex": "#405A55",
    "name": "Green Sail",
    "code": "5759"
  },
  "5760": {
    "hex": "#3D5A4F",
    "name": "Field Green",
    "code": "5760"
  },
  "5761": {
    "hex": "#FDE594",
    "name": "Wheat",
    "code": "5761"
  },
  "5762": {
    "hex": "#FDD25D",
    "name": "Sunflower",
    "code": "5762"
  },
  "5763": {
    "hex": "#F3A11F",
    "name": "Maerit Gold",
    "code": "5763"
  },
  "5764": {
    "hex": "#F4AC52",
    "name": "Nectar",
    "code": "5764"
  },
  "5765": {
    "hex": "#ERROR!",
    "name": "Scholastic",
    "code": "5765"
  },
  "5766": {
    "hex": "#F6BC58",
    "name": "Manila",
    "code": "5766"
  },
  "5767": {
    "hex": "#D75C47",
    "name": "Orangeade",
    "code": "5767"
  },
  "5769": {
    "hex": "#F37941",
    "name": "Dark Texas Orange",
    "code": "5769"
  },
  "5770": {
    "hex": "#D89645",
    "name": "Karat",
    "code": "5770"
  },
  "5771": {
    "hex": "#C29F51",
    "name": "Shimmering Gold",
    "code": "5771"
  },
  "5772": {
    "hex": "#B04C4F",
    "name": "Auburn",
    "code": "5772"
  },
  "5773": {
    "hex": "#EFC2AF",
    "name": "Opaline",
    "code": "5773"
  },
  "5774": {
    "hex": "#C1A38F",
    "name": "Rattan",
    "code": "5774"
  },
  "5776": {
    "hex": "#DBC5AE",
    "name": "Seashell",
    "code": "5776"
  },
  "5777": {
    "hex": "#927865",
    "name": "Sand Dune",
    "code": "5777"
  },
  "5778": {
    "hex": "#8F6957",
    "name": "Light Cocoa",
    "code": "5778"
  },
  "5779": {
    "hex": "#D2904C",
    "name": "Almond",
    "code": "5779"
  },
  "5780": {
    "hex": "#C58281",
    "name": "K.A. Bronze",
    "code": "5780"
  },
  "5781": {
    "hex": "#AD6D53",
    "name": "Hazel",
    "code": "5781"
  },
  "5782": {
    "hex": "#B6B2B5",
    "name": "Skylight",
    "code": "5782"
  },
  "5783": {
    "hex": "#ACACAD",
    "name": "Cloud",
    "code": "5783"
  },
  "5784": {
    "hex": "#9396A2",
    "name": "Silvery Gray",
    "code": "5784"
  },
  "5785": {
    "hex": "#C3C1C4",
    "name": "Saturn Gray",
    "code": "5785"
  },
  "5786": {
    "hex": "#98939E",
    "name": "Storm Gray",
    "code": "5786"
  },
  "5787": {
    "hex": "#4C4C53",
    "name": "Smokey",
    "code": "5787"
  },
  "5788": {
    "hex": "#A87B69",
    "name": "Cocoa Mulch",
    "code": "5788"
  },
  "5789": {
    "hex": "#C19170",
    "name": "Wicker",
    "code": "5789"
  },
  "5792": {
    "hex": "#33A3A2",
    "name": "J. Turquoise",
    "code": "5792"
  },
  "5794": {
    "hex": "#C4708A",
    "name": "Cabernet",
    "code": "5794"
  },
  "5795": {
    "hex": "#EDAAB6",
    "name": "Mountain Rose",
    "code": "5795"
  },
  "5796": {
    "hex": "#7C4754",
    "name": "Warm Wine",
    "code": "5796"
  },
  "5797": {
    "hex": "#AF4F7C",
    "name": "Perfect Ruby",
    "code": "5797"
  },
  "5800": {
    "hex": "#B35D98",
    "name": "New Berry",
    "code": "5800"
  },
  "5801": {
    "hex": "#1F86AF",
    "name": "Cerulean",
    "code": "5801"
  },
  "5802": {
    "hex": "#919395",
    "name": "GS Grey",
    "code": "5802"
  },
  "5803": {
    "hex": "#5E5489",
    "name": "Deep Purple",
    "code": "5803"
  },
  "5804": {
    "hex": "#AD4C75",
    "name": "Cherry Stone",
    "code": "5804"
  },
  "5805": {
    "hex": "#495E52",
    "name": "Special Green",
    "code": "5805"
  },
  "5806": {
    "hex": "#CD6386",
    "name": "Rose Pink",
    "code": "5806"
  },
  "5807": {
    "hex": "#A93C53",
    "name": "Candy Apple Red",
    "code": "5807"
  },
  "5809": {
    "hex": "#1F8E85",
    "name": "Dark Teal",
    "code": "5809"
  },
  "5810": {
    "hex": "#1F7C8C",
    "name": "Peacock",
    "code": "5810"
  },
  "5811": {
    "hex": "#AF3F4B",
    "name": "Deep Scarlet",
    "code": "5811"
  },
  "5812": {
    "hex": "#1F8458",
    "name": "Irish Green",
    "code": "5812"
  },
  "5813": {
    "hex": "#2A866B",
    "name": "Jade",
    "code": "5813"
  },
  "5814": {
    "hex": "#7FBF3E",
    "name": "Neon Green",
    "code": "5814"
  },
  "5815": {
    "hex": "#A48C7D",
    "name": "Bronze",
    "code": "5815"
  },
  "5819": {
    "hex": "#1FA0B3",
    "name": "Surf Blue",
    "code": "5819"
  },
  "5820": {
    "hex": "#4891A6",
    "name": "Mid Windsor",
    "code": "5820"
  },
  "5821": {
    "hex": "#1F8D95",
    "name": "Mallard Blue",
    "code": "5821"
  },
  "5823": {
    "hex": "#5486AC",
    "name": "China Blue",
    "code": "5823"
  },
  "5824": {
    "hex": "#3F5170",
    "name": "PN Navy (24)",
    "code": "5824"
  },
  "5825": {
    "hex": "#A5C3DC",
    "name": "Heron Blue",
    "code": "5825"
  },
  "5829": {
    "hex": "#3287B1",
    "name": "Dolphin Blue",
    "code": "5829"
  },
  "5836": {
    "hex": "#869DAE",
    "name": "Rockport Blue",
    "code": "5836"
  },
  "5839": {
    "hex": "#EAE6E3",
    "name": "Chrome",
    "code": "5839"
  },
  "5841": {
    "hex": "#6B6867",
    "name": "Black Chrome",
    "code": "5841"
  },
  "5842": {
    "hex": "#A8965B",
    "name": "Foilage Green",
    "code": "5842"
  },
  "5843": {
    "hex": "#A38251",
    "name": "Autumn Green",
    "code": "5843"
  },
  "5849": {
    "hex": "#386A68",
    "name": "Blue Spruce",
    "code": "5849"
  },
  "5850": {
    "hex": "#64857A",
    "name": "Newport",
    "code": "5850"
  },
  "5852": {
    "hex": "#647266",
    "name": "Ivy",
    "code": "5852"
  },
  "5853": {
    "hex": "#535F4F",
    "name": "Dark Army Green",
    "code": "5853"
  },
  "5854": {
    "hex": "#697966",
    "name": "Water Lilly",
    "code": "5854"
  },
  "5855": {
    "hex": "#CDDDB2",
    "name": "Pastel Green",
    "code": "5855"
  },
  "5856": {
    "hex": "#E8A53D",
    "name": "Pollen Gold",
    "code": "5856"
  },
  "5860": {
    "hex": "#F7CE5D",
    "name": "Moonbeam",
    "code": "5860"
  },
  "5861": {
    "hex": "#DDB25B",
    "name": "Black Eyed Susie",
    "code": "5861"
  },
  "5864": {
    "hex": "#514D4D",
    "name": "Mahogany",
    "code": "5864"
  },
  "5865": {
    "hex": "#696767",
    "name": "Aged Charcoal",
    "code": "5865"
  },
  "5870": {
    "hex": "#C0A787",
    "name": "Golden Tan",
    "code": "5870"
  },
  "5877": {
    "hex": "#5A90A0",
    "name": "Wonder Blue",
    "code": "5877"
  },
  "5884": {
    "hex": "#6E7765",
    "name": "Dress Green",
    "code": "5884"
  },
  "5887": {
    "hex": "#644B59",
    "name": "Intense Maroon",
    "code": "5887"
  },
  "5899": {
    "hex": "#B25E81",
    "name": "Passion Rose",
    "code": "5899"
  },
  "5906": {
    "hex": "#B09461",
    "name": "TH Gold",
    "code": "5906"
  },
  "5907": {
    "hex": "#1F7255",
    "name": "TH Green",
    "code": "5907"
  },
  "5908": {
    "hex": "#884956",
    "name": "TH Burgundy",
    "code": "5908"
  },
  "5909": {
    "hex": "#414656",
    "name": "TH Navy",
    "code": "5909"
  },
  "7027": {
    "hex": "#407F44",
    "name": "",
    "code": "7027"
  },
  "7041": {
    "hex": "#9F9DA7",
    "name": "",
    "code": "7041"
  },
  "7058": {
    "hex": "#DED981",
    "name": "",
    "code": "7058"
  },
  "7109": {
    "hex": "#8D4881",
    "name": "",
    "code": "7109"
  },
  "7125": {
    "hex": "#DAA784",
    "name": "",
    "code": "7125"
  },
  "7142": {
    "hex": "#6689BD",
    "name": "",
    "code": "7142"
  },
  "7144": {
    "hex": "#8B93B5",
    "name": "",
    "code": "7144"
  },
  "7147": {
    "hex": "#ACB6D0",
    "name": "",
    "code": "7147"
  },
  "7165": {
    "hex": "#C1506B",
    "name": "",
    "code": "7165"
  },
  "7170": {
    "hex": "#765166",
    "name": "",
    "code": "7170"
  },
  "7255": {
    "hex": "#A65965",
    "name": "",
    "code": "7255"
  },
  "7286": {
    "hex": "#6F4991",
    "name": "",
    "code": "7286"
  },
  "7310": {
    "hex": "#D8BDC2",
    "name": "",
    "code": "7310"
  },
  "7313": {
    "hex": "#ACCBDC",
    "name": "",
    "code": "7313"
  },
  "7364": {
    "hex": "#D48046",
    "name": "",
    "code": "7364"
  },
  "7595": {
    "hex": "#EA75A5",
    "name": "",
    "code": "7595"
  },
  "7598": {
    "hex": "#F08D65",
    "name": "",
    "code": "7598"
  },
  "7599": {
    "hex": "#C1D99B",
    "name": "",
    "code": "7599"
  },
  "7611": {
    "hex": "#D0DADE",
    "name": "",
    "code": "7611"
  },
  "7612": {
    "hex": "#AAADC7",
    "name": "",
    "code": "7612"
  },
  "7613": {
    "hex": "#CFD7D8",
    "name": "",
    "code": "7613"
  },
  "7616": {
    "hex": "#FB8D88",
    "name": "",
    "code": "7616"
  },
  "7621": {
    "hex": "#FD874A",
    "name": "",
    "code": "7621"
  },
  "7623": {
    "hex": "#FBED6F",
    "name": "",
    "code": "7623"
  },
  "7624": {
    "hex": "#FEC769",
    "name": "",
    "code": "7624"
  },
  "7625": {
    "hex": "#F3C195",
    "name": "",
    "code": "7625"
  },
  "7627": {
    "hex": "#D5CCDF",
    "name": "",
    "code": "7627"
  },
  "7628": {
    "hex": "#C1D9EE",
    "name": "",
    "code": "7628"
  },
  "7630": {
    "hex": "#C0B0CF",
    "name": "",
    "code": "7630"
  },
  "7635": {
    "hex": "#693D49",
    "name": "",
    "code": "7635"
  },
  "7639": {
    "hex": "#BF5A53",
    "name": "",
    "code": "7639"
  },
  "7640": {
    "hex": "#757B7F",
    "name": "",
    "code": "7640"
  },
  "7641": {
    "hex": "#434C53",
    "name": "",
    "code": "7641"
  },
  "7643": {
    "hex": "#2A384F",
    "name": "",
    "code": "7643"
  },
  "7645": {
    "hex": "#BFE1DD",
    "name": "",
    "code": "7645"
  },
  "7647": {
    "hex": "#BAD7AB",
    "name": "",
    "code": "7647"
  },
  "7648": {
    "hex": "#B5D59E",
    "name": "",
    "code": "7648"
  },
  "7649": {
    "hex": "#B3C861",
    "name": "",
    "code": "7649"
  },
  "7650": {
    "hex": "#38975B",
    "name": "",
    "code": "7650"
  },
  "7652": {
    "hex": "#1F9A97",
    "name": "",
    "code": "7652"
  },
  "7653": {
    "hex": "#EDE1E1",
    "name": "",
    "code": "7653"
  },
  "7657": {
    "hex": "#B2825D",
    "name": "",
    "code": "7657"
  },
  "7658": {
    "hex": "#B16850",
    "name": "",
    "code": "7658"
  },
  "7661": {
    "hex": "#F4F2DB",
    "name": "",
    "code": "7661"
  },
  "7662": {
    "hex": "#B3A198",
    "name": "",
    "code": "7662"
  },
  "7664": {
    "hex": "#8F8477",
    "name": "",
    "code": "7664"
  },
  "7666": {
    "hex": "#FBF9C2",
    "name": "",
    "code": "7666"
  },
  "7668": {
    "hex": "#A0B4A2",
    "name": "",
    "code": "7668"
  },
  "7670": {
    "hex": "#E1C88C",
    "name": "",
    "code": "7670"
  },
  "7674": {
    "hex": "#B2CBD3",
    "name": "",
    "code": "7674"
  },
  "7680": {
    "hex": "#755E7A",
    "name": "",
    "code": "7680"
  },
  "7682": {
    "hex": "#D8C9BB",
    "name": "",
    "code": "7682"
  },
  "7689": {
    "hex": "#909796",
    "name": "",
    "code": "7689"
  },
  "7690": {
    "hex": "#224C53",
    "name": "",
    "code": "7690"
  },
  "7692": {
    "hex": "#C8EDEA",
    "name": "",
    "code": "7692"
  },
  "7694": {
    "hex": "#89BFB9",
    "name": "",
    "code": "7694"
  },
  "7695": {
    "hex": "#3BAEC4",
    "name": "",
    "code": "7695"
  },
  "7701": {
    "hex": "#F4C6C9",
    "name": "Petal Pink",
    "code": "7701"
  },
  "7704": {
    "hex": "#216452",
    "name": "",
    "code": "7704"
  },
  "7706": {
    "hex": "#C0B261",
    "name": "",
    "code": "7706"
  },
  "7709": {
    "hex": "#DF6A7C",
    "name": "Bitteroot",
    "code": "7709"
  },
  "7710": {
    "hex": "#BA5995",
    "name": "",
    "code": "7710"
  },
  "7711": {
    "hex": "#B2A8CF",
    "name": "",
    "code": "7711"
  },
  "7712": {
    "hex": "#DC6A92",
    "name": "Azalea",
    "code": "7712"
  },
  "7713": {
    "hex": "#EDDEE1",
    "name": "",
    "code": "7713"
  },
  "7718": {
    "hex": "#9EA7AC",
    "name": "",
    "code": "7718"
  },
  "7721": {
    "hex": "#F2B0C5",
    "name": "",
    "code": "7721"
  },
  "7723": {
    "hex": "#F4E1B1",
    "name": "",
    "code": "7723"
  },
  "7725": {
    "hex": "#E5C17E",
    "name": "",
    "code": "7725"
  },
  "7729": {
    "hex": "#A88981",
    "name": "",
    "code": "7729"
  },
  "7730": {
    "hex": "#BF8356",
    "name": "",
    "code": "7730"
  },
  "7731": {
    "hex": "#DDC8D4",
    "name": "",
    "code": "7731"
  },
  "7733": {
    "hex": "#679CCE",
    "name": "",
    "code": "7733"
  },
  "7735": {
    "hex": "#F2E465",
    "name": "",
    "code": "7735"
  },
  "7739": {
    "hex": "#465B53",
    "name": "",
    "code": "7739"
  },
  "7741": {
    "hex": "#697070",
    "name": "",
    "code": "7741"
  },
  "7742": {
    "hex": "#415578",
    "name": "",
    "code": "7742"
  },
  "7745": {
    "hex": "#7D6858",
    "name": "",
    "code": "7745"
  },
  "7746": {
    "hex": "#70B2AB",
    "name": "",
    "code": "7746"
  },
  "7747": {
    "hex": "#A4393F",
    "name": "",
    "code": "7747"
  },
  "7748": {
    "hex": "#BCDA96",
    "name": "",
    "code": "7748"
  },
  "7749": {
    "hex": "#76D47B",
    "name": "",
    "code": "7749"
  },
  "7752": {
    "hex": "#F2C1B2",
    "name": "",
    "code": "7752"
  },
  "7753": {
    "hex": "#EDB79F",
    "name": "",
    "code": "7753"
  },
  "7754": {
    "hex": "#E55347",
    "name": "",
    "code": "7754"
  },
  "7755": {
    "hex": "#FDB76B",
    "name": "",
    "code": "7755"
  },
  "7760": {
    "hex": "#6698BA",
    "name": "",
    "code": "7760"
  },
  "7761": {
    "hex": "#DCE2FB",
    "name": "",
    "code": "7761"
  },
  "7767": {
    "hex": "#493F8F",
    "name": "",
    "code": "7767"
  },
  "7770": {
    "hex": "#8EBF77",
    "name": "",
    "code": "7770"
  },
  "7771": {
    "hex": "#ECBA75",
    "name": "",
    "code": "7771"
  },
  "7773": {
    "hex": "#E1A558",
    "name": "",
    "code": "7773"
  },
  "7775": {
    "hex": "#2C86A8",
    "name": "",
    "code": "7775"
  },
  "7777": {
    "hex": "#E59E9B",
    "name": "",
    "code": "7777"
  },
  "7778": {
    "hex": "#F28346",
    "name": "",
    "code": "7778"
  },
  "7779": {
    "hex": "#ED6A65",
    "name": "",
    "code": "7779"
  },
  "7781": {
    "hex": "#AC3C56",
    "name": "",
    "code": "7781"
  },
  "7786": {
    "hex": "#C85677",
    "name": "",
    "code": "7786"
  },
  "7787": {
    "hex": "#E15B91",
    "name": "",
    "code": "7787"
  },
  "7790": {
    "hex": "#9A8A41",
    "name": "",
    "code": "7790"
  },
  "7791": {
    "hex": "#C58D4B",
    "name": "",
    "code": "7791"
  },
  "7792": {
    "hex": "#C0AC55",
    "name": "",
    "code": "7792"
  },
  "7793": {
    "hex": "#968C57",
    "name": "",
    "code": "7793"
  },
  "7795": {
    "hex": "#616552",
    "name": "",
    "code": "7795"
  },
  "7797": {
    "hex": "#1F96C1",
    "name": "",
    "code": "7797"
  },
  "7800": {
    "hex": "#3A4244",
    "name": "",
    "code": "7800"
  },
  "7801": {
    "hex": "#F2F6FF",
    "name": "",
    "code": "7801"
  },
  "7803": {
    "hex": "#F1F1F1",
    "name": "Frosted Matt",
    "code": "7803"
  },
  "7804": {
    "hex": "#8A9263",
    "name": "",
    "code": "7804"
  },
  "7809": {
    "hex": "#CCCB68",
    "name": "",
    "code": "7809"
  },
  "7810": {
    "hex": "#BEC0B4",
    "name": "",
    "code": "7810"
  },
  "7811": {
    "hex": "#CAC6C1",
    "name": "",
    "code": "7811"
  },
  "7812": {
    "hex": "#FB9F93",
    "name": "Melonade",
    "code": "7812"
  },
  "7815": {
    "hex": "#E5D1D8",
    "name": "",
    "code": "7815"
  },
  "7816": {
    "hex": "#EACBD1",
    "name": "",
    "code": "7816"
  },
  "7818": {
    "hex": "#E5D1D3",
    "name": "",
    "code": "7818"
  },
  "7820": {
    "hex": "#E48D6B",
    "name": "",
    "code": "7820"
  },
  "7821": {
    "hex": "#D5453F",
    "name": "",
    "code": "7821"
  },
  "7822": {
    "hex": "#DBD5C8",
    "name": "",
    "code": "7822"
  },
  "7823": {
    "hex": "#E3FF1F",
    "name": "",
    "code": "7823"
  },
  "7825": {
    "hex": "#F4E950",
    "name": "",
    "code": "7825"
  },
  "7827": {
    "hex": "#8BC0C9",
    "name": "",
    "code": "7827"
  },
  "7828": {
    "hex": "#95B9DC",
    "name": "",
    "code": "7828"
  },
  "7832": {
    "hex": "#9266B5",
    "name": "",
    "code": "7832"
  },
  "7833": {
    "hex": "#A4B069",
    "name": "",
    "code": "7833"
  },
  "7834": {
    "hex": "#D7B0CD",
    "name": "",
    "code": "7834"
  },
  "7837": {
    "hex": "#EA5C6A",
    "name": "",
    "code": "7837"
  },
  "7838": {
    "hex": "#C9444D",
    "name": "",
    "code": "7838"
  },
  "7840": {
    "hex": "#999CA3",
    "name": "",
    "code": "7840"
  },
  "7841": {
    "hex": "#58636A",
    "name": "",
    "code": "7841"
  },
  "7842": {
    "hex": "#3253A0",
    "name": "",
    "code": "7842"
  },
  "7843": {
    "hex": "#1F3E6E",
    "name": "",
    "code": "7843"
  },
  "7844": {
    "hex": "#3B444C",
    "name": "",
    "code": "7844"
  },
  "7845": {
    "hex": "#A3D2B4",
    "name": "",
    "code": "7845"
  },
  "7848": {
    "hex": "#97BE7B",
    "name": "",
    "code": "7848"
  },
  "7851": {
    "hex": "#20725C",
    "name": "",
    "code": "7851"
  },
  "7852": {
    "hex": "#4591A5",
    "name": "",
    "code": "7852"
  },
  "7855": {
    "hex": "#F7D4BD",
    "name": "",
    "code": "7855"
  },
  "7859": {
    "hex": "#614E4A",
    "name": "",
    "code": "7859"
  },
  "7860": {
    "hex": "#E5E0C9",
    "name": "",
    "code": "7860"
  },
  "7866": {
    "hex": "#F5EEA9",
    "name": "",
    "code": "7866"
  },
  "7868": {
    "hex": "#27A389",
    "name": "",
    "code": "7868"
  },
  "7869": {
    "hex": "#F2AF6D",
    "name": "",
    "code": "7869"
  },
  "7870": {
    "hex": "#FCD69E",
    "name": "",
    "code": "7870"
  },
  "7871": {
    "hex": "#ABBDD6",
    "name": "",
    "code": "7871"
  },
  "7874": {
    "hex": "#BFCDEA",
    "name": "",
    "code": "7874"
  },
  "7882": {
    "hex": "#E4D4C6",
    "name": "",
    "code": "7882"
  },
  "7884": {
    "hex": "#DAC4B2",
    "name": "",
    "code": "7884"
  },
  "7885": {
    "hex": "#C7A27E",
    "name": "",
    "code": "7885"
  },
  "7886": {
    "hex": "#E5E3E4",
    "name": "",
    "code": "7886"
  },
  "7892": {
    "hex": "#B9DCD8",
    "name": "",
    "code": "7892"
  },
  "7893": {
    "hex": "#75C1CA",
    "name": "",
    "code": "7893"
  },
  "7899": {
    "hex": "#C66E54",
    "name": "",
    "code": "7899"
  },
  "7900": {
    "hex": "#D2D7C1",
    "name": "",
    "code": "7900"
  },
  "7902": {
    "hex": "#2D7068",
    "name": "",
    "code": "7902"
  },
  "7903": {
    "hex": "#3C6A59",
    "name": "",
    "code": "7903"
  },
  "7908": {
    "hex": "#FC7779",
    "name": "",
    "code": "7908"
  },
  "7909": {
    "hex": "#FF6A9C",
    "name": "",
    "code": "7909"
  },
  "7911": {
    "hex": "#EEE2E5",
    "name": "",
    "code": "7911"
  },
  "7917": {
    "hex": "#CF8391",
    "name": "",
    "code": "7917"
  },
  "7919": {
    "hex": "#E17B93",
    "name": "",
    "code": "7919"
  },
  "7920": {
    "hex": "#B9BA93",
    "name": "",
    "code": "7920"
  },
  "7921": {
    "hex": "#E9C5D3",
    "name": "",
    "code": "7921"
  },
  "7922": {
    "hex": "#65569B",
    "name": "",
    "code": "7922"
  },
  "7924": {
    "hex": "#F4E644",
    "name": "",
    "code": "7924"
  },
  "7931": {
    "hex": "#4F453E",
    "name": "",
    "code": "7931"
  },
  "7934": {
    "hex": "#3274B2",
    "name": "",
    "code": "7934"
  },
  "7936": {
    "hex": "#AC9F82",
    "name": "",
    "code": "7936"
  },
  "7937": {
    "hex": "#FDA727",
    "name": "",
    "code": "7937"
  },
  "7938": {
    "hex": "#EADFCC",
    "name": "",
    "code": "7938"
  },
  "7939": {
    "hex": "#B3A88D",
    "name": "",
    "code": "7939"
  },
  "7941": {
    "hex": "#EACFCD",
    "name": "",
    "code": "7941"
  },
  "7946": {
    "hex": "#FD9F2B",
    "name": "",
    "code": "7946"
  },
  "7948": {
    "hex": "#EBA4B5",
    "name": "",
    "code": "7948"
  },
  "7949": {
    "hex": "#EDEDEB",
    "name": "",
    "code": "7949"
  },
  "7950": {
    "hex": "#ABF32A",
    "name": "",
    "code": "7950"
  },
  "7951": {
    "hex": "#FBCC4C",
    "name": "",
    "code": "7951"
  },
  "7952": {
    "hex": "#F2A594",
    "name": "",
    "code": "7952"
  },
  "7953": {
    "hex": "#CBD8E4",
    "name": "",
    "code": "7953"
  },
  "7957": {
    "hex": "#5C564F",
    "name": "",
    "code": "7957"
  },
  "7962": {
    "hex": "#285370",
    "name": "",
    "code": "7962"
  },
  "7965": {
    "hex": "#FBA153",
    "name": "",
    "code": "7965"
  },
  "7969": {
    "hex": "#A8B094",
    "name": "",
    "code": "7969"
  },
  "7970": {
    "hex": "#4A7C4B",
    "name": "",
    "code": "7970"
  },
  "7971": {
    "hex": "#FAD95A",
    "name": "",
    "code": "7971"
  },
  "7976": {
    "hex": "#354C6A",
    "name": "",
    "code": "7976"
  },
  "7977": {
    "hex": "#359DC2",
    "name": "",
    "code": "7977"
  },
  "7980": {
    "hex": "#F4D840",
    "name": "",
    "code": "7980"
  },
  "7982": {
    "hex": "#823E4B",
    "name": "",
    "code": "7982"
  },
  "7984": {
    "hex": "#EB7FA4",
    "name": "",
    "code": "7984"
  },
  "7986": {
    "hex": "#CC3D3C",
    "name": "",
    "code": "7986"
  },
  "7988": {
    "hex": "#28CA73",
    "name": "",
    "code": "7988"
  },
  "7995": {
    "hex": "#F5ED69",
    "name": "",
    "code": "7995"
  },
  "9001": {
    "hex": "#F9C11F",
    "name": "Ombre Gold",
    "code": "9001"
  },
  "9002": {
    "hex": "#9F4B52",
    "name": "Toasty Red",
    "code": "9002"
  },
  "9003": {
    "hex": "#F6D07D",
    "name": "Lemon Fluff",
    "code": "9003"
  },
  "9004": {
    "hex": "#D2BBCF",
    "name": "Piatris Lavender",
    "code": "9004"
  },
  "9005": {
    "hex": "#C19C49",
    "name": "Cloth of Gold",
    "code": "9005"
  },
  "9006": {
    "hex": "#A5414D",
    "name": "Hollyhock Red",
    "code": "9006"
  },
  "9007": {
    "hex": "#E4789C",
    "name": "Wild Romance",
    "code": "9007"
  },
  "9008": {
    "hex": "#D7835C",
    "name": "Sunburst",
    "code": "9008"
  },
  "9009": {
    "hex": "#C49EC1",
    "name": "Dwarf Lilac",
    "code": "9009"
  },
  "9010": {
    "hex": "#E9B04F",
    "name": "Day Lilly",
    "code": "9010"
  },
  "9011": {
    "hex": "#9F8BB1",
    "name": "Poker Primrose",
    "code": "9011"
  },
  "9012": {
    "hex": "#CC5680",
    "name": "Pink Bleeding Heart",
    "code": "9012"
  },
  "9013": {
    "hex": "#B34661",
    "name": "Red Coral Bell",
    "code": "9013"
  },
  "9014": {
    "hex": "#EDD79E",
    "name": "Coronation Gold",
    "code": "9014"
  },
  "9015": {
    "hex": "#CB8DA0",
    "name": "Fairy Tale Pink",
    "code": "9015"
  },
  "9016": {
    "hex": "#BEA5C1",
    "name": "Russian Sage",
    "code": "9016"
  },
  "9017": {
    "hex": "#954E78",
    "name": "Raspberry Ice",
    "code": "9017"
  },
  "9018": {
    "hex": "#EBE4AB",
    "name": "Green Ice",
    "code": "9018"
  },
  "9019": {
    "hex": "#8D6C98",
    "name": "Popular Purple",
    "code": "9019"
  },
  "9020": {
    "hex": "#D25353",
    "name": "Scarlet Flame",
    "code": "9020"
  },
  "9021": {
    "hex": "#5C528B",
    "name": "Regal Purple",
    "code": "9021"
  },
  "9022": {
    "hex": "#485285",
    "name": "Nikko Blue",
    "code": "9022"
  },
  "9023": {
    "hex": "#EC6963",
    "name": "Indian Summer",
    "code": "9023"
  },
  "9024": {
    "hex": "#EEE5D7",
    "name": "Beige Delight",
    "code": "9024"
  },
  "9025": {
    "hex": "#D694A5",
    "name": "Pink Pompas",
    "code": "9025"
  },
  "9026": {
    "hex": "#F1DBDC",
    "name": "Pink Cascade",
    "code": "9026"
  },
  "9027": {
    "hex": "#905175",
    "name": "Purple Ice",
    "code": "9027"
  },
  "9028": {
    "hex": "#E2D7C5",
    "name": "Ice Ballet",
    "code": "9028"
  },
  "9029": {
    "hex": "#CCD5DA",
    "name": "Out of the Blue",
    "code": "9029"
  },
  "9030": {
    "hex": "#F6C3C8",
    "name": "Pink Joy",
    "code": "9030"
  },
  "9031": {
    "hex": "#686FA0",
    "name": "Dark Melody",
    "code": "9031"
  },
  "9032": {
    "hex": "#BBCEDD",
    "name": "Blue Joy",
    "code": "9032"
  },
  "9034": {
    "hex": "#F0CAAD",
    "name": "Foundation",
    "code": "9034"
  },
  "9035": {
    "hex": "#D8BA5E",
    "name": "Finch",
    "code": "9035"
  },
  "9036": {
    "hex": "#E4A4C4",
    "name": "Pink Sherbert",
    "code": "9036"
  },
  "9037": {
    "hex": "#E2A1C1",
    "name": "Pink Splendor",
    "code": "9037"
  },
  "9038": {
    "hex": "#ED926D",
    "name": "Deviled Orange",
    "code": "9038"
  },
  "9039": {
    "hex": "#7DB0D1",
    "name": "Blue Splendor",
    "code": "9039"
  },
  "9040": {
    "hex": "#EDBCCB",
    "name": "Le Reve Pink",
    "code": "9040"
  },
  "9041": {
    "hex": "#DECBDF",
    "name": "Siberian Iris",
    "code": "9041"
  },
  "9042": {
    "hex": "#805D53",
    "name": "Brownstone",
    "code": "9042"
  },
  "9044": {
    "hex": "#E6C1CE",
    "name": "Fantasia Pink",
    "code": "9044"
  },
  "9045": {
    "hex": "#E0B6B8",
    "name": "Wild Ginseng",
    "code": "9045"
  },
  "9046": {
    "hex": "#774C6B",
    "name": "Aubergine",
    "code": "9046"
  },
  "9047": {
    "hex": "#F5B795",
    "name": "Shangri La",
    "code": "9047"
  },
  "9048": {
    "hex": "#859BC5",
    "name": "Amanda Lavender",
    "code": "9048"
  },
  "9049": {
    "hex": "#6B78B1",
    "name": "Purple Chariot",
    "code": "9049"
  },
  "9050": {
    "hex": "#D3933E",
    "name": "Golden Chair",
    "code": "9050"
  },
  "9051": {
    "hex": "#F7C11F",
    "name": "Golden Stargazor",
    "code": "9051"
  },
  "9052": {
    "hex": "#1FA5BD",
    "name": "Blue Wisteria",
    "code": "9052"
  },
  "9053": {
    "hex": "#5F5072",
    "name": "May Nights",
    "code": "9053"
  },
  "9054": {
    "hex": "#3DACBB",
    "name": "Blue Fringe",
    "code": "9054"
  },
  "9055": {
    "hex": "#7D5061",
    "name": "Salvia Plum",
    "code": "9055"
  },
  "9056": {
    "hex": "#B65B4A",
    "name": "Orange Glory",
    "code": "9056"
  },
  "9057": {
    "hex": "#5F5FA0",
    "name": "Vanessa Purple",
    "code": "9057"
  },
  "9058": {
    "hex": "#E37D75",
    "name": "Oriental Poppies",
    "code": "9058"
  },
  "9059": {
    "hex": "#9CD2E2",
    "name": "Pillow Blue",
    "code": "9059"
  },
  "9060": {
    "hex": "#44ACC0",
    "name": "Angela Blue",
    "code": "9060"
  },
  "9061": {
    "hex": "#E19085",
    "name": "Summer Splendor",
    "code": "9061"
  },
  "9062": {
    "hex": "#376374",
    "name": "Perpetual Teal",
    "code": "9062"
  },
  "9063": {
    "hex": "#C89C9C",
    "name": "Toasted Champagne",
    "code": "9063"
  },
  "9064": {
    "hex": "#9A95AD",
    "name": "Luck Lavender",
    "code": "9064"
  },
  "9065": {
    "hex": "#BA6A79",
    "name": "Scalloped Coral",
    "code": "9065"
  },
  "9066": {
    "hex": "#FF7F6A",
    "name": "Vibrant Orange",
    "code": "9066"
  },
  "9067": {
    "hex": "#BDB2CA",
    "name": "Arden Lavender",
    "code": "9067"
  },
  "9068": {
    "hex": "#FFA88A",
    "name": "Complex Orange",
    "code": "9068"
  },
  "9069": {
    "hex": "#EECFC8",
    "name": "Winter Almond",
    "code": "9069"
  },
  "9070": {
    "hex": "#CFB2AE",
    "name": "Heather Mist",
    "code": "9070"
  },
  "9071": {
    "hex": "#714C75",
    "name": "Mod Purple",
    "code": "9071"
  },
  "9072": {
    "hex": "#E56336",
    "name": "Grilled Orange",
    "code": "9072"
  },
  "9073": {
    "hex": "#F19BA2",
    "name": "Dancing Salmon",
    "code": "9073"
  },
  "9074": {
    "hex": "#EDBAC8",
    "name": "Exclusive Pink",
    "code": "9074"
  },
  "9075": {
    "hex": "#536D83",
    "name": "Favorite Deep Blue",
    "code": "9075"
  },
  "9076": {
    "hex": "#90CED5",
    "name": "Nautical Teal",
    "code": "9076"
  },
  "9077": {
    "hex": "#B37586",
    "name": "Comfort Pink",
    "code": "9077"
  },
  "9078": {
    "hex": "#F3C1C1",
    "name": "Pink Sham",
    "code": "9078"
  },
  "9079": {
    "hex": "#79B3CF",
    "name": "Bambino Blue",
    "code": "9079"
  },
  "9080": {
    "hex": "#E5C5C0",
    "name": "Ginger Jar",
    "code": "9080"
  },
  "9081": {
    "hex": "#638DAB",
    "name": "Blue Moon",
    "code": "9081"
  },
  "9082": {
    "hex": "#E2D9DF",
    "name": "Hi Ho Silver",
    "code": "9082"
  },
  "9083": {
    "hex": "#CFCFD1",
    "name": "Titanium",
    "code": "9083"
  },
  "9084": {
    "hex": "#B19C5A",
    "name": "Golden Slipper",
    "code": "9084"
  },
  "9085": {
    "hex": "#FFFF1F",
    "name": "Stunning Yellow",
    "code": "9085"
  },
  "9086": {
    "hex": "#BDA28D",
    "name": "French Toast",
    "code": "9086"
  },
  "9087": {
    "hex": "#ADA39B",
    "name": "Happy Trail",
    "code": "9087"
  },
  "9088": {
    "hex": "#937EB7",
    "name": "Cindy Purple",
    "code": "9088"
  },
  "9089": {
    "hex": "#A4BAC5",
    "name": "Cameron Blue",
    "code": "9089"
  },
  "9090": {
    "hex": "#C9CDCC",
    "name": "Storm Gail",
    "code": "9090"
  },
  "9091": {
    "hex": "#359961",
    "name": "Veggie Green",
    "code": "9091"
  },
  "9092": {
    "hex": "#1F9261",
    "name": "Conner Green",
    "code": "9092"
  },
  "9094": {
    "hex": "#DCBA97",
    "name": "Candy Tan",
    "code": "9094"
  },
  "9095": {
    "hex": "#D4D0CF",
    "name": "Raindrop",
    "code": "9095"
  },
  "9096": {
    "hex": "#A2A1A4",
    "name": "Millennium",
    "code": "9096"
  },
  "9097": {
    "hex": "#A3659B",
    "name": "Tich Pink",
    "code": "9097"
  },
  "9098": {
    "hex": "#B193A7",
    "name": "Pansy Purple",
    "code": "9098"
  },
  "9099": {
    "hex": "#8A8B96",
    "name": "Granite",
    "code": "9099"
  },
  "9100": {
    "hex": "#447280",
    "name": "Venus Blue",
    "code": "9100"
  },
  "9101": {
    "hex": "#BAD4CE",
    "name": "Shallow Green",
    "code": "9101"
  },
  "9102": {
    "hex": "#1F9497",
    "name": "Tempest Turq",
    "code": "9102"
  },
  "9103": {
    "hex": "#8BC8C8",
    "name": "Herbal Blue",
    "code": "9103"
  },
  "9104": {
    "hex": "#257274",
    "name": "Paradise Green",
    "code": "9104"
  },
  "9105": {
    "hex": "#1F8B96",
    "name": "Mountainview",
    "code": "9105"
  },
  "9106": {
    "hex": "#98CEB4",
    "name": "Tealeaf",
    "code": "9106"
  },
  "9107": {
    "hex": "#939F8F",
    "name": "Kiwi Green",
    "code": "9107"
  },
  "9108": {
    "hex": "#ABB88C",
    "name": "Envy Green",
    "code": "9108"
  },
  "9109": {
    "hex": "#E3AB52",
    "name": "Pooh",
    "code": "9109"
  },
  "9110": {
    "hex": "#8B8F91",
    "name": "Bellaire Grey",
    "code": "9110"
  },
  "9111": {
    "hex": "#767C7C",
    "name": "Vassar Chic",
    "code": "9111"
  },
  "9112": {
    "hex": "#86858A",
    "name": "Delano Grey",
    "code": "9112"
  },
  "9113": {
    "hex": "#B6BAB6",
    "name": "Melville",
    "code": "9113"
  },
  "9114": {
    "hex": "#A1A3AA",
    "name": "Fairview Grey",
    "code": "9114"
  },
  "9115": {
    "hex": "#AAB2B2",
    "name": "Otter Grey",
    "code": "9115"
  },
  "9116": {
    "hex": "#C1C6C9",
    "name": "Teardrop Grey",
    "code": "9116"
  },
  "9117": {
    "hex": "#959696",
    "name": "Grey Flannel",
    "code": "9117"
  },
  "9118": {
    "hex": "#C5B26B",
    "name": "Meilee Green",
    "code": "9118"
  },
  "9119": {
    "hex": "#8B7648",
    "name": "Allegheny",
    "code": "9119"
  },
  "9120": {
    "hex": "#BFB472",
    "name": "Daiqueri Ice",
    "code": "9120"
  },
  "9121": {
    "hex": "#A4A082",
    "name": "Limerick",
    "code": "9121"
  },
  "9122": {
    "hex": "#6E6953",
    "name": "Beau Geste",
    "code": "9122"
  },
  "9123": {
    "hex": "#D1BD99",
    "name": "Tommy Tan",
    "code": "9123"
  },
  "9124": {
    "hex": "#B99A57",
    "name": "Cheviot Gold",
    "code": "9124"
  },
  "9125": {
    "hex": "#B9A580",
    "name": "Rice Paper",
    "code": "9125"
  },
  "9126": {
    "hex": "#C7BDB1",
    "name": "Basket Beige",
    "code": "9126"
  },
  "9127": {
    "hex": "#FFE12F",
    "name": "Havana Tellow",
    "code": "9127"
  },
  "9128": {
    "hex": "#9D9186",
    "name": "Carbondale",
    "code": "9128"
  },
  "9129": {
    "hex": "#8D8177",
    "name": "Mars Green",
    "code": "9129"
  },
  "9130": {
    "hex": "#C69D75",
    "name": "Sweet Dreams",
    "code": "9130"
  },
  "9131": {
    "hex": "#C79C73",
    "name": "Terry Tan",
    "code": "9131"
  },
  "9132": {
    "hex": "#D3B593",
    "name": "Primedor",
    "code": "9132"
  },
  "9133": {
    "hex": "#988069",
    "name": "Lucrene",
    "code": "9133"
  },
  "9134": {
    "hex": "#ABA59A",
    "name": "Turkish Tan",
    "code": "9134"
  },
  "9135": {
    "hex": "#ADA39B",
    "name": "Decorator Tan",
    "code": "9135"
  },
  "9136": {
    "hex": "#C2A690",
    "name": "Bali",
    "code": "9136"
  },
  "9137": {
    "hex": "#7F6E62",
    "name": "Cajun Mist",
    "code": "9137"
  },
  "9138": {
    "hex": "#95CFD9",
    "name": "Alaska Sky",
    "code": "9138"
  },
  "9139": {
    "hex": "#229998",
    "name": "Blue Appeal",
    "code": "9139"
  },
  "9140": {
    "hex": "#42AB9F",
    "name": "Breath of Spring",
    "code": "9140"
  },
  "9141": {
    "hex": "#73BDB5",
    "name": "Sea Glass",
    "code": "9141"
  },
  "9142": {
    "hex": "#3D8F87",
    "name": "Inner Sanctum",
    "code": "9142"
  },
  "9143": {
    "hex": "#5B8E90",
    "name": "Southampton",
    "code": "9143"
  },
  "9144": {
    "hex": "#51A480",
    "name": "Cone Forest",
    "code": "9144"
  },
  "9145": {
    "hex": "#538C7C",
    "name": "Endicott Bay",
    "code": "9145"
  },
  "9146": {
    "hex": "#425E56",
    "name": "Teal Appeal",
    "code": "9146"
  },
  "9147": {
    "hex": "#8DAC7A",
    "name": "Eventide Green",
    "code": "9147"
  },
  "9148": {
    "hex": "#8CB86E",
    "name": "Rolling Meadow",
    "code": "9148"
  },
  "9149": {
    "hex": "#C2D2AB",
    "name": "Slightly Green",
    "code": "9149"
  },
  "9150": {
    "hex": "#8D985A",
    "name": "Mosstone",
    "code": "9150"
  },
  "9151": {
    "hex": "#616856",
    "name": "Alpine Green",
    "code": "9151"
  },
  "9152": {
    "hex": "#70754C",
    "name": "Bonaire Green",
    "code": "9152"
  },
  "9154": {
    "hex": "#9A8C51",
    "name": "Cone",
    "code": "9154"
  },
  "9155": {
    "hex": "#6B695A",
    "name": "Castlewalk Green",
    "code": "9155"
  },
  "9156": {
    "hex": "#7C6358",
    "name": "Sonesta Brown",
    "code": "9156"
  },
  "9157": {
    "hex": "#FFC11F",
    "name": "Singh Mise",
    "code": "9157"
  },
  "9158": {
    "hex": "#6D6963",
    "name": "Grey Wool",
    "code": "9158"
  },
  "9159": {
    "hex": "#FF5E67",
    "name": "Hot Cha Cha",
    "code": "9159"
  },
  "9160": {
    "hex": "#D7B3A4",
    "name": "Coast Point",
    "code": "9160"
  },
  "9161": {
    "hex": "#E96A99",
    "name": "Cheeky Pink",
    "code": "9161"
  },
  "9162": {
    "hex": "#69555F",
    "name": "Royal Crest",
    "code": "9162"
  },
  "9163": {
    "hex": "#76727B",
    "name": "Coal Hill",
    "code": "9163"
  },
  "9164": {
    "hex": "#C87D91",
    "name": "Maven Maud",
    "code": "9164"
  },
  "9165": {
    "hex": "#AB7B49",
    "name": "Temple Gold",
    "code": "9165"
  },
  "9166": {
    "hex": "#5F74AD",
    "name": "Livid Lavender",
    "code": "9166"
  },
  "9167": {
    "hex": "#9597BD",
    "name": "Tulip Lavender",
    "code": "9167"
  },
  "9168": {
    "hex": "#D36796",
    "name": "Horizon Pink",
    "code": "9168"
  },
  "9169": {
    "hex": "#345E4B",
    "name": "Latex Green",
    "code": "9169"
  },
  "9170": {
    "hex": "#B34347",
    "name": "Miami Artillery",
    "code": "9170"
  },
  "9171": {
    "hex": "#ERROR!",
    "name": "Chow Blue",
    "code": "9171"
  },
  "9172": {
    "hex": "#F8C11F",
    "name": "Warm Sunshine",
    "code": "9172"
  },
  "9173": {
    "hex": "#1F8D89",
    "name": "Sea Water",
    "code": "9173"
  },
  "182857": {
    "hex": "#182857",
    "name": "Oxford Blue",
    "code": "182857"
  },
  "220040": {
    "hex": "#220040",
    "name": "Dark Magenta Navy",
    "code": "220040"
  },
  "263371": {
    "hex": "#263371",
    "name": "Dark Royal Blue",
    "code": "263371"
  },
  "374550": {
    "hex": "#374550",
    "name": "Dark Slate Gray",
    "code": "374550"
  },
  "375239": {
    "hex": "#375239",
    "name": "Dark Sage Green",
    "code": "375239"
  },
  "424247": {
    "hex": "#424247",
    "name": "Gunmetal Gray",
    "code": "424247"
  },
  "485446": {
    "hex": "#485446",
    "name": "Olive Slate",
    "code": "485446"
  },
  "567345": {
    "hex": "#567345",
    "name": "Olive",
    "code": "567345"
  },
  "632192": {
    "hex": "#632192",
    "name": "Deep Purple",
    "code": "632192"
  },
  "737373": {
    "hex": "#737373",
    "name": "Medium Gray",
    "code": "737373"
  },
  "762742": {
    "hex": "#762742",
    "name": "Dark Raspberry",
    "code": "762742"
  },
  "886348": {
    "hex": "#886348",
    "name": "Warm Brown",
    "code": "886348"
  },
  "00395D": {
    "hex": "#00395D",
    "name": "Deep Sea Teal",
    "code": "00395D"
  },
  "2F2976": {
    "hex": "#2F2976",
    "name": "Medium Indigo",
    "code": "2F2976"
  },
  "063553": {
    "hex": "#063553",
    "name": "",
    "code": "063553"
  },
  "00664E": {
    "hex": "#00664E",
    "name": "Emerald Forest",
    "code": "00664E"
  },
  "14477B": {
    "hex": "#14477B",
    "name": "Denim Blue",
    "code": "14477B"
  },
  "003DA7": {
    "hex": "#003DA7",
    "name": "Cobalt Blue",
    "code": "003DA7"
  },
  "1B2647": {
    "hex": "#1B2647",
    "name": "Dark Denim Blue",
    "code": "1B2647"
  },
  "D1A558": {
    "hex": "#D1A558",
    "name": "Muted Gold",
    "code": "D1A558"
  },
  "004896": {
    "hex": "#004896",
    "name": "Ocean Blue",
    "code": "004896"
  },
  "1D2944": {
    "hex": "#1D2944",
    "name": "Slate Blue",
    "code": "1D2944"
  },
  "0E1A34": {
    "hex": "#0E1A34",
    "name": "Dark Slate Navy",
    "code": "0E1A34"
  },
  "C3": {
    "hex": "#3e6c45",
    "name": "Color Swap 3",
    "code": "C3"
  },
  "3B474E": {
    "hex": "#3B474E",
    "name": "Dark Cool Gray",
    "code": "3B474E"
  },
  "CCB8A0": {
    "hex": "#CCB8A0",
    "name": "Sand Beige",
    "code": "CCB8A0"
  },
  "B59758": {
    "hex": "#B59758",
    "name": "Warm Gold",
    "code": "B59758"
  },
  "1C144F": {
    "hex": "#1C144F",
    "name": "",
    "code": "1C144F"
  },
  "000000": {
    "hex": "#000000",
    "name": "Midnight Black",
    "code": "000000"
  },
  "011A81": {
    "hex": "#011A81",
    "name": "Ultramarine",
    "code": "011A81"
  },
  "08428B": {
    "hex": "#08428B",
    "name": "Medium Blue",
    "code": "08428B"
  },
  "F7F7F7": {
    "hex": "#F7F7F7",
    "name": "Near White",
    "code": "F7F7F7"
  },
  "0F1433": {
    "hex": "#0F1433",
    "name": "Dark Ink Navy",
    "code": "0F1433"
  },
  "12507B": {
    "hex": "#12507B",
    "name": "Ocean Slate",
    "code": "12507B"
  },
  "C5193C": {
    "hex": "#C5193C",
    "name": "Crimson Red",
    "code": "C5193C"
  },
  "061D45": {
    "hex": "#061D45",
    "name": "Dark Denim",
    "code": "061D45"
  },
  "1A1341": {
    "hex": "#1A1341",
    "name": "Dark Indigo",
    "code": "1A1341"
  },
  "6BA7F4": {
    "hex": "#6BA7F4",
    "name": "Periwinkle Blue",
    "code": "6BA7F4"
  },
  "3E609C": {
    "hex": "#3E609C",
    "name": "",
    "code": "3E609C"
  },
  "C4": {
    "hex": "#4ef5aa",
    "name": "Color Swap 4",
    "code": "C4"
  },
  "FFFFFF": {
    "hex": "#FFFFFF",
    "name": "White",
    "code": "FFFFFF"
  },
  "FED854": {
    "hex": "#FED854",
    "name": "Bright Yellow",
    "code": "FED854"
  },
  "2D3591": {
    "hex": "#2D3591",
    "name": "Deep Periwinkle Blue",
    "code": "2D3591"
  },
  "NEWSWITCHY": {
    "hex": "#f5d76e",
    "name": "SWITCHY",
    "code": "NEWSWITCHY"
  },
  "42495E": {
    "hex": "#42495E",
    "name": "Cool Slate",
    "code": "42495E"
  },
  "006400": {
    "hex": "#006400",
    "name": "Dark Green",
    "code": "006400"
  },
  "E1D9D1": {
    "hex": "#E1D9D1",
    "name": "Pale Sand",
    "code": "E1D9D1"
  },
  "19004A": {
    "hex": "#19004A",
    "name": "Deep Plum Navy",
    "code": "19004A"
  },
  "1A5326": {
    "hex": "#1A5326",
    "name": "Deep Forest",
    "code": "1A5326"
  },
  "15152E": {
    "hex": "#15152E",
    "name": "Charcoal Blue",
    "code": "15152E"
  },
  "050554": {
    "hex": "#050554",
    "name": "Deep Indigo",
    "code": "050554"
  },
  "EEF3EC": {
    "hex": "#EEF3EC",
    "name": "Pale Mint",
    "code": "EEF3EC"
  },
  "C5": {
    "hex": "#5e2d5a",
    "name": "Color Swap 5",
    "code": "C5"
  },
  "131F3B": {
    "hex": "#131F3B",
    "name": "Dark Navy Slate",
    "code": "131F3B"
  },
  "E0D5CA": {
    "hex": "#E0D5CA",
    "name": "Warm Linen",
    "code": "E0D5CA"
  },
  "0A3161": {
    "hex": "#0A3161",
    "name": "Classic Blue",
    "code": "0A3161"
  },
  "D71921": {
    "hex": "#D71921",
    "name": "Bright Red",
    "code": "D71921"
  },
  "184B9A": {
    "hex": "#184B9A",
    "name": "Royal Cobalt",
    "code": "184B9A"
  },
  "FC": {
    "hex": "#6BD088",
    "name": "No Color",
    "code": "FC"
  },
  "6B3D0B": {
    "hex": "#6B3D0B",
    "name": "Dark Amber Brown",
    "code": "6B3D0B"
  },
  "010D26": {
    "hex": "#010D26",
    "name": "Ink Navy",
    "code": "010D26"
  },
  "355E3B": {
    "hex": "#355E3B",
    "name": "Moss Green",
    "code": "355E3B"
  },
  "C2": {
    "hex": "#2ed8c4",
    "name": "Color Swap 2",
    "code": "C2"
  },
  "1801- OLD": {
    "hex": "#E5E8FD",
    "name": "Super White",
    "code": "1801- OLD"
  },
  "3B4040": {
    "hex": "#3B4040",
    "name": "Charcoal",
    "code": "3B4040"
  },
  "395D12": {
    "hex": "#395D12",
    "name": "Olive Green",
    "code": "395D12"
  },
  "C0C8D4": {
    "hex": "#C0C8D4",
    "name": "Cool Mist Gray",
    "code": "C0C8D4"
  },
  "C1": {
    "hex": "#1e4287 ",
    "name": "Color Swap 1",
    "code": "C1"
  },
  "0E003F": {
    "hex": "#0E003F",
    "name": "Deep Purple Navy",
    "code": "0E003F"
  },
  "1E0746": {
    "hex": "#1E0746",
    "name": "Midnight Plum",
    "code": "1E0746"
  },
  "16214B": {
    "hex": "#16214B",
    "name": "Dark Cobalt Navy",
    "code": "16214B"
  },
  "1F1F77": {
    "hex": "#1F1F77",
    "name": "Deep Periwinkle",
    "code": "1F1F77"
  },
  "044494": {
    "hex": "#044494",
    "name": "Bold Blue",
    "code": "044494"
  },
  "0D0248": {
    "hex": "#0D0248",
    "name": "Dark Violet Navy",
    "code": "0D0248"
  },
  "01313F": {
    "hex": "#01313F",
    "name": "Dark Teal",
    "code": "01313F"
  },
  "SWITCHY": {
    "hex": "#60FFC3",
    "name": "SWITCHY",
    "code": "SWITCHY"
  },
  "0E4C89": {
    "hex": "#0E4C89",
    "name": "Steel Blue",
    "code": "0E4C89"
  },
  "073957": {
    "hex": "#073957",
    "name": "",
    "code": "073957"
  },
  "132A50": {
    "hex": "#132A50",
    "name": "Deep Navy Blue",
    "code": "132A50"
  },
  "0D223F": {
    "hex": "#0D223F",
    "name": "Charcoal Navy",
    "code": "0D223F"
  },
  "2A295F": {
    "hex": "#2A295F",
    "name": "Navy Indigo",
    "code": "2A295F"
  },
  "06435D": {
    "hex": "#06435D",
    "name": "Slate Teal",
    "code": "06435D"
  },
  "DBDBDB": {
    "hex": "#DBDBDB",
    "name": "Silver Gray",
    "code": "DBDBDB"
  },
  "005740": {
    "hex": "#005740",
    "name": "Deep Forest Green",
    "code": "005740"
  },
  "16336B": {
    "hex": "#16336B",
    "name": "Deep Royal Blue",
    "code": "16336B"
  },
  "951E20": {
    "hex": "#951E20",
    "name": "Deep Crimson",
    "code": "951E20"
  },
  "029CCE": {
    "hex": "#029CCE",
    "name": "Bright Cerulean",
    "code": "029CCE"
  },
  "054A2C": {
    "hex": "#054A2C",
    "name": "Pine Green",
    "code": "054A2C"
  },
  "EBE3C9": {
    "hex": "#EBE3C9",
    "name": "Cream",
    "code": "EBE3C9"
  },
  "1D354D": {
    "hex": "#1D354D",
    "name": "Steel Navy",
    "code": "1D354D"
  },
  "152C47": {
    "hex": "#152C47",
    "name": "Deep Steel Blue",
    "code": "152C47"
  },
  "AD2B2A": {
    "hex": "#AD2B2A",
    "name": "Bold Red",
    "code": "AD2B2A"
  },
  "002496": {
    "hex": "#002496",
    "name": "Royal Blue",
    "code": "002496"
  },
  "3E4A76": {
    "hex": "#3E4A76",
    "name": "Muted Cobalt",
    "code": "3E4A76"
  },
  "F2F2F2": {
    "hex": "#F2F2F2",
    "name": "Soft White",
    "code": "F2F2F2"
  },
  "15467A": {
    "hex": "#15467A",
    "name": "Navy Blue",
    "code": "15467A"
  },
  "005940": {
    "hex": "#005940",
    "name": "Hunter Green",
    "code": "005940"
  },
  "364D75": {
    "hex": "#364D75",
    "name": "Steel Navy Blue",
    "code": "364D75"
  },
  "003B71": {
    "hex": "#003B71",
    "name": "Dark Cobalt",
    "code": "003B71"
  },
  "174C99": {
    "hex": "#174C99",
    "name": "Medium Royal Blue",
    "code": "174C99"
  },
  "000080": {
    "hex": "#000080",
    "name": "Navy Blue",
    "code": "000080"
  },
  "091931": {
    "hex": "#091931",
    "name": "Deep Midnight",
    "code": "091931"
  },
  "0E0E23": {
    "hex": "#0E0E23",
    "name": "Graphite Navy",
    "code": "0E0E23"
  },
  "D3D3D3": {
    "hex": "#D3D3D3",
    "name": "Light Gray",
    "code": "D3D3D3"
  },
  "3D4F76": {
    "hex": "#3D4F76",
    "name": "Slate Cobalt",
    "code": "3D4F76"
  },
  "004789": {
    "hex": "#004789",
    "name": "Sapphire Navy",
    "code": "004789"
  },
  "000435": {
    "hex": "#000435",
    "name": "Abyss Blue",
    "code": "000435"
  },
  "29235C": {
    "hex": "#29235C",
    "name": "Deep Purple Indigo",
    "code": "29235C"
  },
  "TRANSPARENT": {
    "hex": "transparent",
    "name": "",
    "code": "TRANSPARENT"
  },
  "2B6D3E": {
    "hex": "#2B6D3E",
    "name": "Forest Green",
    "code": "2B6D3E"
  },
  "311C1D": {
    "hex": "#311C1D",
    "name": "Dark Maroon",
    "code": "311C1D"
  },
  "333C53": {
    "hex": "#333C53",
    "name": "Dark Slate",
    "code": "333C53"
  },
  "465A5E": {
    "hex": "#465A5E",
    "name": "Muted Teal Gray",
    "code": "465A5E"
  },
  "BFB2AA": {
    "hex": "#BFB2AA",
    "name": "Warm Greige",
    "code": "BFB2AA"
  },
  "022135": {
    "hex": "#022135",
    "name": "Midnight Teal",
    "code": "022135"
  },
  "232E43": {
    "hex": "#232E43",
    "name": "Dark Gunmetal",
    "code": "232E43"
  },
  "23F532": {
    "hex": "#23F532",
    "name": "Bright Green",
    "code": "23F532"
  },
  "C7AA4C": {
    "hex": "#C7AA4C",
    "name": "Antique Gold",
    "code": "C7AA4C"
  },
  "116547 ": {
    "hex": "#116547 ",
    "name": "Christmas Green",
    "code": "116547 "
  },
  "000068": {
    "hex": "#000068",
    "name": "Deep Navy",
    "code": "000068"
  }
};